import * as React from "react"

const Shrug = (props) => (
  <svg
    x={0}
    y={0}
    xmlSpace="preserve"
    id="svg9204"
    width={98.66}
    height={199.551}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css" id="style8032">
      {
        ".st0{fill:#ffd9c0}.st5{fill:#8eb2ba}.st6{fill:#fff}.st7{fill:#ebeaea}.st8{fill:#27b2ff}.st9{fill:#27aae1}.st10{fill:#443d3f}.st13{opacity:.32;fill:#012f77}.st15{fill:#f7d39f}.st20,.st21{fill:#754a1b}.st21{opacity:.46}.st23{fill:#bcbec0}.st24{fill:#caea73}.st26{fill:#6d1c00}.st27{opacity:.05}"
      }
    </style>
    <g id="Layer_1" transform="matrix(.285 0 0 .285 -89.865 -53.46)">
      <path
        className="st0"
        d="M431.09 487.19s-12.98 33.04-20.83 43.87c-1.28 1.76-2.41 3.34-3.46 4.72-5.42 7.12-8.7 9.12-18.4 4.62-11.57-5.36-19.16-33.38-21.87-41.27-2.04-5.97-6.81-16.89-9.01-22.1-.7-1.68-1.14-2.77-1.14-2.92 0-.62-5.42-3.04-10.78-5.62-5.37-2.58-16.17-1.7-20.14-2.13-3.97-.42-4.3-2.29-4.3-2.29s-2.33-.03-3.38-.46c-1.06-.42.19-2.44.19-2.44s-1.99 0-2.59-1.67c-.59-1.67 3.18-3.52 3.18-3.52s.31-.86 1.34-1.98 14.97-2.87 22.28-1.56c7.32 1.31 11.83 1.38 14.2.15 2.37-1.24 1.02-2.56-.54-5.73-1.55-3.17-2.24-8.58.54-11.39 2.79-2.81 4.45-.34 4.79 2.55.34 2.89.17 5.96 4.69 10.43 4.51 4.47 5.87 11.63 6.48 16.89.6 5.26.92 9.62 3.93 14.05 2.34 3.44 11.53 14.82 15.56 19.78 1.18 1.44 1.91 2.34 1.91 2.34l9.02-25.13 6.33 2.41z"
        id="path8034"
      />
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1={391.83}
        y1={491.645}
        x2={409.09}
        y2={491.645}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#e57070",
          }}
          id="stop8036"
        />
        <stop
          offset={0.17}
          style={{
            stopColor: "#e67574",
            stopOpacity: 0.8303,
          }}
          id="stop8038"
        />
        <stop
          offset={0.379}
          style={{
            stopColor: "#ea8480",
            stopOpacity: 0.6213,
          }}
          id="stop8040"
        />
        <stop
          offset={0.608}
          style={{
            stopColor: "#f09d93",
            stopOpacity: 0.3917,
          }}
          id="stop8042"
        />
        <stop
          offset={0.851}
          style={{
            stopColor: "#f9c0ad",
            stopOpacity: 0.149,
          }}
          id="stop8044"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#ffd9c0",
            stopOpacity: 0,
          }}
          id="stop8046"
        />
      </linearGradient>
      <path
        d="M409.09 478.79c-.31 1.48-1.06 2.93-1.62 4.22-3.41 7.84-6.51 15.81-9.29 23.9-1.69-1.87-3.37-3.74-5.06-5.6-.46-.51-.92-1.03-1.16-1.66-.06-.16-.1-.32-.13-.48 1.18 1.44 1.91 2.34 1.91 2.34l9.02-25.13z"
        id="path8049"
        style={{
          fill: "url(#SVGID_1_)",
          opacity: 0.66,
        }}
      />
      <linearGradient
        id="SVGID_00000155107132216377957130000016754335194514936252_"
        gradientUnits="userSpaceOnUse"
        x1={357.52}
        y1={509.914}
        x2={406.8}
        y2={509.914}
      >
        <stop
          offset={0}
          style={{
            stopColor: "#ffd9c0",
            stopOpacity: 0,
          }}
          id="stop8051"
        />
        <stop
          offset={0.149}
          style={{
            stopColor: "#f9c0ad",
            stopOpacity: 0.149,
          }}
          id="stop8053"
        />
        <stop
          offset={0.392}
          style={{
            stopColor: "#f09d93",
            stopOpacity: 0.3917,
          }}
          id="stop8055"
        />
        <stop
          offset={0.621}
          style={{
            stopColor: "#ea8480",
            stopOpacity: 0.6213,
          }}
          id="stop8057"
        />
        <stop
          offset={0.83}
          style={{
            stopColor: "#e67574",
            stopOpacity: 0.8303,
          }}
          id="stop8059"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#e57070",
          }}
          id="stop8061"
        />
      </linearGradient>
      <path
        style={{
          opacity: 0.66,
          fill: "url(#SVGID_00000155107132216377957130000016754335194514936252_)",
        }}
        d="M406.8 535.78c-5.42 7.12-8.7 9.12-18.4 4.62-11.57-5.36-19.16-33.38-21.87-41.27-2.04-5.97-6.81-16.89-9.01-22.1 1.3.4 2.46 1.3 3.36 2.58 2.75 3.92 4.17 9.03 5.88 13.46 4.22 10.89 9.38 21.42 15.43 31.41 2.81 4.65 6 9.37 10.76 12 4.31 2.38 10.25 2.47 13.85-.7z"
        id="path8064"
      />
      <path
        className="st0"
        d="M545.72 486.58s12.98 33.04 20.83 43.87c1.28 1.76 2.41 3.34 3.46 4.72 5.42 7.12 8.7 9.12 18.4 4.62 11.57-5.36 19.16-33.38 21.87-41.27 2.04-5.97 6.81-16.89 9.01-22.1.7-1.68 1.14-2.77 1.14-2.92 0-.62 5.42-3.04 10.78-5.62 5.37-2.58 16.17-1.7 20.14-2.13 3.97-.42 4.3-2.29 4.3-2.29s2.33-.03 3.38-.46c1.06-.42-.19-2.44-.19-2.44s1.99 0 2.59-1.67c.59-1.67-3.18-3.52-3.18-3.52s-.31-.86-1.34-1.98-14.97-2.87-22.28-1.56c-7.32 1.31-11.83 1.38-14.2.15-2.37-1.24-1.02-2.56.54-5.73 1.55-3.17 2.24-8.58-.54-11.39-2.79-2.81-4.45-.34-4.79 2.55-.34 2.89-.17 5.96-4.69 10.43-4.51 4.47-5.87 11.63-6.48 16.89-.6 5.26-.92 9.62-3.93 14.05-2.34 3.44-11.53 14.82-15.56 19.78-1.18 1.44-1.91 2.34-1.91 2.34l-9.02-25.13-6.33 2.41z"
        id="path8066"
      />
      <linearGradient
        id="SVGID_00000133515035393969943480000002261131022855945660_"
        gradientUnits="userSpaceOnUse"
        x1={646.254}
        y1={491.031}
        x2={663.514}
        y2={491.031}
        gradientTransform="matrix(-1 0 0 1 1231.235 0)"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#e57070",
          }}
          id="stop8068"
        />
        <stop
          offset={0.17}
          style={{
            stopColor: "#e67574",
            stopOpacity: 0.8303,
          }}
          id="stop8070"
        />
        <stop
          offset={0.379}
          style={{
            stopColor: "#ea8480",
            stopOpacity: 0.6213,
          }}
          id="stop8072"
        />
        <stop
          offset={0.608}
          style={{
            stopColor: "#f09d93",
            stopOpacity: 0.3917,
          }}
          id="stop8074"
        />
        <stop
          offset={0.851}
          style={{
            stopColor: "#f9c0ad",
            stopOpacity: 0.149,
          }}
          id="stop8076"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#ffd9c0",
            stopOpacity: 0,
          }}
          id="stop8078"
        />
      </linearGradient>
      <path
        style={{
          opacity: 0.66,
          fill: "url(#SVGID_00000133515035393969943480000002261131022855945660_)",
        }}
        d="M567.72 478.18c.31 1.48 1.06 2.93 1.62 4.22 3.41 7.84 6.51 15.81 9.29 23.9 1.69-1.87 3.37-3.74 5.06-5.6.46-.51.92-1.03 1.16-1.66.06-.16.1-.32.13-.48-1.18 1.44-1.91 2.34-1.91 2.34l-9.02-25.13z"
        id="path8081"
      />
      <linearGradient
        id="SVGID_00000080922371109876119400000001651923222226224319_"
        gradientUnits="userSpaceOnUse"
        x1={611.944}
        y1={509.3}
        x2={661.224}
        y2={509.3}
        gradientTransform="matrix(-1 0 0 1 1231.235 0)"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#ffd9c0",
            stopOpacity: 0,
          }}
          id="stop8083"
        />
        <stop
          offset={0.149}
          style={{
            stopColor: "#f9c0ad",
            stopOpacity: 0.149,
          }}
          id="stop8085"
        />
        <stop
          offset={0.392}
          style={{
            stopColor: "#f09d93",
            stopOpacity: 0.3917,
          }}
          id="stop8087"
        />
        <stop
          offset={0.621}
          style={{
            stopColor: "#ea8480",
            stopOpacity: 0.6213,
          }}
          id="stop8089"
        />
        <stop
          offset={0.83}
          style={{
            stopColor: "#e67574",
            stopOpacity: 0.8303,
          }}
          id="stop8091"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#e57070",
          }}
          id="stop8093"
        />
      </linearGradient>
      <path
        style={{
          opacity: 0.66,
          fill: "url(#SVGID_00000080922371109876119400000001651923222226224319_)",
        }}
        d="M570.01 535.17c5.42 7.12 8.7 9.12 18.4 4.62 11.57-5.36 19.16-33.38 21.87-41.27 2.04-5.97 6.81-16.89 9.01-22.1-1.3.4-2.46 1.3-3.36 2.58-2.75 3.92-4.17 9.03-5.88 13.46a200.557 200.557 0 0 1-15.43 31.41c-2.81 4.65-6 9.37-10.76 12-4.31 2.38-10.25 2.47-13.85-.7z"
        id="path8096"
      />
      <path
        className="st5"
        d="M402.62 471.43s-.6 4.41-.43 4.5c.18.09 29.34 11.44 29.34 11.44s1.35-.24 1.54-.49c.19-.26.31-3.48.31-3.48l-17.3-6.1z"
        id="path8098"
      />
      <path
        className="st5"
        d="m542.88 483.03 1.68 4.7s24.27-7.88 27.27-9.8l3-1.91-1.17-5.46s-9.87 4.82-17.72 8.52c-7.85 3.71-13.06 3.95-13.06 3.95z"
        id="path8100"
      />
      <path
        className="st6"
        d="M570.06 472.83c-1.35.78-3 1.71-4.97 2.89-8.35 4.99-21.83 7.24-21.83 7.24l.42 2.7c.42 2.7 2.55 3.26 2.55 3.26s-4.96 25.37-6.15 30.29c-1.19 4.93 2.38 51.83 2.38 51.83l1.6 20.67s-5.19.35-11.91 3.67-42.98 10.9-62.47 8.05c-19.49-2.86-40.35-12.98-40.35-12.98s4.86-28.6 7.91-41.28c3.04-12.68 2.57-35.51 2.57-35.51l-4.6-30.27s-.12-.43-6.97-1.91-25.19-10.35-26.19-11.68c-1-1.32-.28-5.48 3.96-12.81s8.86-28.16 13.46-36.94c4.59-8.77 16.68-9.52 31.32-3.14 14.64 6.39 22.54 4.95 22.54 4.95h25.97s.91.31 2.81.55c2.3.29 6.05.48 11.4-.12 9.79-1.1 9.79-3.59 23.23-7.06 13.45-3.46 19.49 4.66 23.66 15.25 4.16 10.59 12.32 32.39 13.97 36.03 1.25 2.77.04 3.78-4.31 6.32z"
        id="path8102"
      />
      <path
        className="st7"
        d="M570.06 472.83c-1.03.35-2.07.65-3.12.92 1.81-.6 2.69-2.97 2.26-4.89-.45-2.07-1.91-3.73-3.2-5.4a44.25 44.25 0 0 1-6.18-10.83c-1.74-4.38-2.77-9.02-4.76-13.28-1.99-4.26-5.18-8.27-9.64-9.75-3.06-1.01-6.39-.74-9.57-.21-5.38.89-10.68 2.5-16.13 2.71-7.53.29-14.45-3.3-17.61-9.69 2.3.29 6.05.48 11.4-.12 9.79-1.1 9.79-3.59 23.23-7.06 13.45-3.46 19.49 4.66 23.66 15.25 4.16 10.59 12.32 32.39 13.97 36.03 1.25 2.77.04 3.78-4.31 6.32z"
        id="path8104"
      />
      <path
        className="st7"
        d="M406.07 470.92c1.03.35 2.07.65 3.12.92-1.81-.6-2.69-2.97-2.26-4.89.45-2.07 1.91-3.73 3.2-5.4a44.25 44.25 0 0 0 6.18-10.83c1.74-4.38 2.77-9.02 4.76-13.28 1.99-4.26 5.18-8.27 9.64-9.75 3.06-1.01 6.39-.74 9.57-.21 5.38.89 10.68 2.5 16.13 2.71 7.53.29 14.45-3.3 17.61-9.69-2.3.29-6.05.48-11.4-.12-9.79-1.1-9.79-3.59-23.23-7.06-13.45-3.46-19.49 4.66-23.66 15.25-4.16 10.59-12.32 32.39-13.97 36.03-1.25 2.77-.04 3.78 4.31 6.32z"
        id="path8106"
      />
      <path
        className="st6"
        d="m436.24 502.68-3.17-12.53c.49.73 1 1.48 1.34 2.3.01.03.03.05.04.08.19 1.77.47 3.53.79 5.27.3 1.63.63 3.26 1 4.88z"
        id="path8108"
      />
      <path
        className="st6"
        d="M409.64 456.99c-.02 0-.05-.01-.07-.02l-1.54-1.99c.48.6 1.01 1.27 1.61 2.01z"
        id="path8110"
      />
      <path
        className="st6"
        d="M438.23 510.54a132.9 132.9 0 0 1-1.99-7.86z"
        id="path8112"
      />
      <path
        className="st6"
        d="M470.85 859.73c-1.2.97-2.44 1.47-3.73 1.49-.02 0-.05.01-.08.01-1.49 0-2.85-.64-3.89-1.34.49-.13.99-.23 1.52-.31 2.3-.34 4.37-.28 6.18.15z"
        id="path8114"
      />
      <path
        className="st6"
        d="M473.38 866.14c-4.73-2.47-10.29-.7-12.27.08a13.653 13.653 0 0 1-2.38-3.99c.63-.55 1.32-1.04 2.11-1.45 1.35 1.13 3.55 2.56 6.2 2.56.04 0 .06-.01.1-.01 2.14-.02 4.15-.97 5.99-2.8 1.03.49 1.96 1.13 2.78 1.92l.09.09a21.52 21.52 0 0 1-2.62 3.6z"
        id="path8116"
      />
      <path
        className="st6"
        d="M471.77 867.72c-1.73 1.48-3.23 2.16-4.07 2.44-.37.13-.77.11-1.12-.03-1.51-.63-2.77-1.42-3.79-2.27 2.03-.66 5.74-1.49 8.98-.14z"
        id="path8118"
      />
      <path
        className="st8"
        d="M477.44 864.26c2.67 3.87 3.29 9.19 2.99 12.05 0 .03-.01.06-.01.09-8.79 3.85-22 2.22-26.84 1.44-.07-2.04-.04-9.16 3.58-13.93.58 1.28 1.5 2.8 2.89 4.27 1.38 1.47 3.23 2.87 5.72 3.9.44.18.92.27 1.4.27.41 0 .82-.06 1.21-.2 1.43-.49 3.67-1.59 6.01-4 1.02-1.03 2.05-2.31 3.05-3.89z"
        id="path8120"
      />
      <path
        className="st6"
        d="M455.88 882.08c-.87-.25-1.55-.97-1.78-1.87l-.04-.14c2.66.41 6.95.92 11.67.92 4.86 0 10.19-.55 14.68-2.32-.09.9-.62 1.68-1.4 2.04-9.27 4.32-18.47 2.71-23.13 1.37z"
        id="path8122"
      />
      <path
        className="st6"
        d="M518.55 882.08c-4.66 1.35-13.85 2.95-23.14-1.36-.79-.37-1.31-1.14-1.4-2.04 4.5 1.78 9.81 2.32 14.68 2.32 4.73 0 9.02-.51 11.68-.92l-.04.14c-.23.9-.91 1.62-1.78 1.86z"
        id="path8124"
      />
      <path
        className="st8"
        d="M517.27 863.93c3.62 4.77 3.64 11.89 3.57 13.92-4.84.78-18.04 2.4-26.83-1.45 0-.03-.01-.06-.01-.08-.3-2.85.32-8.18 2.99-12.05a22.61 22.61 0 0 0 3.04 3.9c2.35 2.41 4.58 3.5 6.02 3.99a3.749 3.749 0 0 0 2.61-.07c2.48-1.03 4.34-2.43 5.71-3.9 1.4-1.47 2.31-2.99 2.9-4.26z"
        id="path8126"
      />
      <path
        className="st6"
        d="M511.63 867.86c-1.02.86-2.27 1.64-3.78 2.27-.35.14-.75.15-1.12.03-.84-.29-2.35-.96-4.07-2.44 3.24-1.34 6.96-.51 8.97.14z"
        id="path8128"
      />
      <path
        className="st6"
        d="M513.32 866.22c-1.96-.77-7.53-2.54-12.27-.07-.87-.97-1.77-2.15-2.63-3.6.03-.04.06-.07.09-.1.82-.8 1.75-1.44 2.78-1.92 1.84 1.84 3.85 2.78 5.99 2.8.04 0 .07.01.1.01 2.65 0 4.85-1.42 6.2-2.56.79.41 1.49.89 2.11 1.45a14.08 14.08 0 0 1-2.37 3.99z"
        id="path8130"
      />
      <path
        className="st6"
        d="M506.91 859.36c.9 0 1.85.06 2.83.21.53.08 1.04.18 1.51.31-1.04.7-2.4 1.34-3.88 1.34-.03 0-.05-.01-.08-.01-1.28-.02-2.53-.51-3.73-1.48 1.05-.24 2.16-.37 3.35-.37z"
        id="path8132"
      />
      <path
        className="st0"
        d="m515.99 843.26-2.47 12.89c-.98-.35-2.04-.61-3.18-.77-3.33-.48-6.33-.3-8.95.54l1.44-13.79c3.67.91 7.08 1.23 10.08 1.23 1.08.01 2.11-.03 3.08-.1z"
        id="path8134"
      />
      <path
        className="st8"
        d="M513.53 832.45c4.66 0 8.27-.86 10.62-1.66-.42 2.3-.86 4.62-1.31 6.94-.95.29-2.52.7-4.56.99-4.04.58-9.95.73-16.68-1.32-2.44-.75-4.99-1.78-7.59-3.19v-6.36c7.65 3.5 14.26 4.6 19.52 4.6z"
        id="path8136"
      />
      <path
        className="st8"
        d="M480.42 827.84v6.36a40.86 40.86 0 0 1-7.71 3.23c-6.68 2.01-12.55 1.86-16.56 1.28-2.04-.3-3.61-.7-4.55-.99-.45-2.32-.89-4.64-1.31-6.94 2.35.8 5.95 1.66 10.62 1.66 5.25.01 11.85-1.09 19.51-4.6z"
        id="path8138"
      />
      <path
        className="st0"
        d="m471.6 842.14 1.44 13.79c-2.63-.84-5.62-1.01-8.95-.54-1.14.16-2.21.42-3.18.77l-2.47-12.89c.97.07 1.99.11 3.07.11 3-.01 6.41-.33 10.09-1.24z"
        id="path8140"
      />
      <path
        className="st8"
        d="m542.98 614-9.14-8.42c3.03-1.13 6.03-2.38 8.96-3.75.07 3.34.14 7.42.18 12.17z"
        id="path8142"
      />
      <path
        className="st8"
        d="m440.61 605.56-9.15 8.43c.04-4.64.1-8.64.18-11.92 2.06.91 5.11 2.15 8.97 3.49z"
        id="path8144"
      />
      <path
        className="st9"
        d="M484.95 639.43h-1.4c-1.38 0-2.42-.78-2.42-1.47v-24.49c1.19.06 2.39.11 3.61.15v.51c0 .18.13.32.29.35-.16.03-.29.18-.29.35v.69c0 .18.13.32.29.35-.16.04-.29.18-.29.35v.69c0 .18.13.32.29.35-.16.03-.29.18-.29.35v.69c0 .18.13.32.29.35-.16.03-.29.17-.29.35v.69c0 .18.13.32.29.35-.16.03-.29.17-.29.35v.69c0 .18.13.32.29.35-.16.03-.29.17-.29.35v.69c0 .18.13.32.29.35-.16.03-.29.17-.29.35v.69c0 .18.13.32.29.35-.16.03-.29.17-.29.35v.69c0 .18.13.32.29.35-.16.03-.29.17-.29.35v.69c0 .18.13.32.29.35-.16.03-.29.17-.29.35v.7c0 .17.13.32.29.35-.16.03-.29.17-.29.35v.69c0 .18.13.32.29.35-.16.03-.29.17-.29.35v.7c0 .17.13.32.29.35-.16.03-.29.17-.29.35v.7c0 .17.13.32.29.35-.16.03-.29.17-.29.35v.7c0 .17.13.32.29.35-.16.03-.29.17-.29.35v.7c0 .17.13.32.29.35-.16.03-.29.18-.29.35v.7c0 .17.13.32.29.35-.16.03-.29.18-.29.35v.7c0 .17.13.32.29.35-.16.03-.29.18-.29.35v.7c0 .02.09.15.21.2z"
        id="path8146"
      />
      <path
        className="st9"
        d="M485.45 614.82c0-.18-.13-.32-.29-.35.16-.03.29-.17.29-.35v-.49c1.01.02 2.02.04 3.04.04 1.58 0 3.18-.03 4.8-.08v24.38c0 .7-1.04 1.47-2.42 1.47h-5.64c.13-.05.21-.18.21-.32v-.7c0-.17-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.7c0-.17-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.7c0-.17-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.7c0-.18-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.7c0-.18-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.7c0-.18-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.7c0-.18-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.69c0-.18-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.7c0-.18-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.69c0-.18-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.69c0-.18-.13-.32-.29-.35.16-.04.29-.18.29-.35v-.69c0-.18-.13-.32-.29-.35.16-.03.29-.18.29-.35v-.69c0-.18-.13-.32-.29-.35.16-.04.29-.18.29-.35v-.69c0-.18-.13-.32-.29-.35.16-.04.29-.18.29-.35v-.69c0-.18-.13-.32-.29-.35.16-.04.29-.18.29-.35v-.69c0-.18-.13-.32-.29-.35.16-.03.29-.17.29-.35v-.69c0-.18-.13-.32-.29-.35.16-.03.29-.17.29-.35v-.59z"
        id="path8148"
      />
      <path
        className="st8"
        d="M543.01 619.77c.05 32.84-1.47 90.98-10.46 158.18-2.18 16.34-4.81 33.21-7.95 50.39-3.97 1.56-15.17 4.54-30.58-2.84V642.98c.51-.23.97-.52 1.39-.85 1.3-1.04 2.12-2.52 2.12-4.17v-24.59c10.08-.67 20.82-2.53 31.82-6.19z"
        id="path8150"
      />
      <path
        className="st8"
        d="M480.42 642.98v182.53c-7.64 3.65-14.25 4.76-19.46 4.76-2.74 0-5.09-.31-7-.72-1.78-.37-3.16-.83-4.12-1.21-2.65-14.44-4.92-28.68-6.88-42.55-9.93-70.5-11.58-131.91-11.53-166.01l1.16-1.06 12.63-11.65c7.76 2.41 18.73 5.06 31.69 6.12v24.77c0 .95.27 1.85.76 2.64.61 1.01 1.58 1.84 2.75 2.38z"
        id="path8152"
      />
      <path
        className="st8"
        d="M542.59 594.39c.03.8.06 1.74.09 2.83-4.19 2.02-8.53 3.83-12.93 5.36-.46 0-.92.15-1.3.44-11.47 3.86-22.66 5.7-33.09 6.24-5.67.3-11.12.2-16.27-.15-14.06-.97-25.85-3.91-33.78-6.45-6.7-2.13-11.39-4.17-13.58-5.18.04-1.2.07-2.24.1-3.1 18.38 8.24 36.88 12.36 55.38 12.36s37-4.11 55.38-12.35z"
        id="path8154"
      />
      <path
        className="st0"
        d="M507.61 436.72c-3.05 5.44-8.9 16.35-13.72 28.38-.11.26-.21.53-.32.79h-8.71c-.01-.03-.02-.05-.03-.08-.09-.23-.18-.47-.28-.7-4.83-12.03-10.68-22.95-13.73-28.39a5.154 5.154 0 0 1-.03-5.02l6.08-11.12c.04-.06.07-.13.1-.19l.95-1.73c.18-.31.26-.66.26-1.01v-10.71c1.47.08 2.96.11 4.44.11.48 0 .95-.01 1.43-.01 5.47-.08 10.9-.73 16.2-1.89v12.5c0 .35.09.7.26 1.01l2.4 4.38c0 .01 0 .01.01.01l4.73 8.65a5.18 5.18 0 0 1-.04 5.02z"
        id="path8156"
      />
      <path
        className="st10"
        d="M547.22 618.46c.06.27.06.55 0 .82.01-.28.01-.55 0-.82z"
        id="path8158"
      />
      <path
        className="st10"
        d="M547.22 618.46c.01.27.01.54 0 .82-.07.37-.24.73-.51 1.03a2.116 2.116 0 0 1-2.99.12l-.71-.66c-.01-2.02-.01-3.95-.03-5.77l3.6 3.32c.34.31.56.71.64 1.14 0-.01 0-.01 0 0z"
        id="path8160"
      />
      <path
        className="st10"
        d="M545.52 600.54c.75-.37 1.18-1.12 1.18-1.9l.26-.01c.13 4.66.25 11.37.27 19.83-.08-.42-.3-.82-.64-1.13l-3.6-3.32c-.04-4.75-.11-8.83-.18-12.17.9-.43 1.81-.86 2.71-1.3z"
        id="path8162"
      />
      <path
        className="st10"
        d="M542.68 597.21c-.04-1.09-.06-2.03-.09-2.83.97-.43 1.92-.87 2.89-1.32.82-.39 1.3-1.26 1.2-2.15.01.04.01.08.01.13.01.17.13 2.8.26 7.59l-.26.01c0-.31-.07-.63-.22-.93a2.104 2.104 0 0 0-2.83-.96c-.32.15-.63.31-.96.46z"
        id="path8164"
      />
      <path
        className="st10"
        d="M546.68 590.91c.1.89-.37 1.75-1.2 2.15-.97.46-1.92.89-2.89 1.32-.07-1.95-.12-3.02-.13-3.13-.02-.39.07-.76.24-1.08.33-.65.99-1.11 1.77-1.14 1-.06 1.89.61 2.14 1.56.01.03.02.05.02.08.03.08.04.17.05.24z"
        id="path8166"
      />
      <path
        className="st10"
        d="M546.68 590.91c-.01-.08-.02-.16-.04-.24.02.08.03.16.04.24z"
        id="path8168"
      />
      <path
        className="st10"
        d="M546.47 597.71a2.113 2.113 0 0 1-.96 2.83c-.89.44-1.8.87-2.71 1.3-.04-1.75-.08-3.29-.12-4.62.32-.16.64-.31.96-.47 1.05-.52 2.32-.09 2.83.96z"
        id="path8170"
      />
      <path
        className="st10"
        d="m543.01 619.77-13.67-12.59c.4-.13.8-.27 1.21-.41 1.1-.38 2.2-.77 3.29-1.19l9.14 8.42.03 5.77z"
        id="path8172"
      />
      <path
        className="st10"
        d="M542.68 597.21c.04 1.33.08 2.87.12 4.62-2.93 1.37-5.93 2.62-8.96 3.75l-2.66-2.45c-.41-.37-.92-.56-1.43-.56 4.4-1.53 8.74-3.34 12.93-5.36z"
        id="path8174"
      />
      <path
        className="st10"
        d="M432.29 589.96c36.45 16.73 73.39 16.73 109.84 0l.57.23c-.17.32-.26.69-.24 1.08.01.11.06 1.18.13 3.13-18.38 8.24-36.88 12.36-55.38 12.36-18.49 0-37-4.11-55.38-12.36.07-1.95.12-3.02.13-3.13.02-.46-.11-.89-.34-1.25z"
        id="path8176"
      />
      <path
        className="st10"
        d="m531.19 603.13 2.66 2.45c-1.09.42-2.19.81-3.29 1.19-.41.14-.81.27-1.21.41l-1.02-.94a2.114 2.114 0 0 1 .14-3.22c.24-.08.48-.15.72-.24.19-.06.39-.13.58-.2.5-.01 1.01.18 1.42.55z"
        id="path8178"
      />
      <path
        className="st10"
        d="M529.75 602.57c-.19.07-.39.14-.58.2l-.72.24c.39-.29.85-.44 1.3-.44z"
        id="path8180"
      />
      <path
        className="st10"
        d="M524.6 828.34c16.1-87.82 18.47-167.75 18.41-208.57l.71.66a2.116 2.116 0 0 0 2.99-.12c.27-.3.44-.66.51-1.03.09 40.84-2.25 121.22-18.42 209.59l-1.04-.19c.03-.22-.01-.45-.13-.66-.29-.5-.94-.68-1.44-.39-.04.01-.58.31-1.59.71z"
        id="path8182"
      />
      <path
        className="st10"
        d="M495.37 609.26c10.43-.54 21.62-2.38 33.09-6.24-.09.07-.18.16-.26.24-.79.85-.73 2.19.12 2.98l1.02.94c-11 3.66-21.74 5.52-31.82 6.19v-1.15c0-1.17-.94-2.11-2.11-2.11z"
        id="path8184"
      />
      <path
        className="st10"
        d="M527.63 828.02c.12.21.16.44.13.66-.04.32-.22.61-.51.78-.16.08-1.22.69-3.1 1.32.15-.82.31-1.63.45-2.44 1.01-.39 1.56-.7 1.59-.71.5-.29 1.15-.11 1.44.39z"
        id="path8186"
      />
      <path
        className="st10"
        d="M524.6 828.34c-.14.81-.3 1.63-.45 2.44-2.35.8-5.95 1.66-10.62 1.66-5.26 0-11.86-1.09-19.52-4.61v-2.34c15.42 7.39 26.61 4.41 30.59 2.85z"
        id="path8188"
      />
      <path
        className="st10"
        d="M523.96 878.33a1.044 1.044 0 0 1-.81 1.24c-.18.04-1.18.25-2.78.49l.46-1.85c.01-.09.01-.22.01-.37 1.16-.18 1.83-.32 1.87-.33.56-.12 1.13.25 1.25.82z"
        id="path8190"
      />
      <path
        className="st10"
        d="M518.92 839.16c1.15.22 1.9 1.32 1.68 2.47l-.2 1.04c-1.27.25-2.75.46-4.42.58l.46-2.42c.18-.95.97-1.63 1.89-1.72.19 0 .39.01.59.05z"
        id="path8192"
      />
      <path
        className="st10"
        d="m520.41 842.68-2.97 15.54c-1.14-.85-2.44-1.55-3.91-2.06l2.47-12.89a44 44 0 0 0 4.41-.59z"
        id="path8194"
      />
      <path
        className="st10"
        d="M518.92 839.16c-.2-.04-.39-.05-.58-.04l-.06-.41c2.04-.3 3.61-.7 4.56-.99.45-2.32.89-4.64 1.31-6.94 1.88-.63 2.95-1.24 3.1-1.32.3-.18.47-.46.51-.78l1.04.19c-.66 3.61-1.35 7.23-2.05 10.86-.14.7-.61 1.28-1.28 1.55-.22.09-2.05.82-5.07 1.39l.2-1.04c.22-1.14-.53-2.25-1.68-2.47z"
        id="path8196"
      />
      <path
        className="st10"
        d="M515.69 862.23c.37-.94.49-1.57.5-1.66.11-.57.66-.95 1.23-.85.57.11.96.65.86 1.22-.02.13-.25 1.35-1.01 2.99-.46-.62-.99-1.19-1.58-1.7z"
        id="path8198"
      />
      <path
        className="st10"
        d="M514.43 859.98c.15.07.32.12.49.16.13.03.27.04.39.04.99 0 1.88-.7 2.08-1.72l.04-.24c6.7 4.96 8.03 14.83 7.59 20.49 0 .06-.01.12-.02.18l-1.04-.16c.02-.13.02-.26-.01-.39-.12-.58-.68-.94-1.25-.82-.04.01-.71.15-1.87.33.08-2.04.06-9.15-3.57-13.92.76-1.64.99-2.86 1.01-2.99.1-.57-.29-1.11-.86-1.22-.57-.1-1.12.28-1.23.85-.01.08-.13.72-.5 1.66-.63-.56-1.32-1.04-2.11-1.45.35-.3.64-.57.86-.8z"
        id="path8200"
      />
      <path
        className="st10"
        d="M514.04 866.52a1.056 1.056 0 0 1 .33 1.66c-.3.34-.8.46-1.23.25-.02-.01-.58-.27-1.5-.57.64-.53 1.2-1.09 1.68-1.65.41.17.67.29.72.31z"
        id="path8202"
      />
      <path
        className="st10"
        d="M514.04 866.52c-.05-.02-.3-.14-.72-.3 1.23-1.45 1.97-2.92 2.37-3.99.59.51 1.11 1.09 1.58 1.7-.59 1.28-1.5 2.8-2.9 4.26l-.01-.01c.07-.07.13-.16.17-.25.26-.53.03-1.16-.49-1.41z"
        id="path8204"
      />
      <path
        className="st10"
        d="M514.43 859.98c-.7-.32-1.17-1-1.23-1.77.1-.11.15-.17.15-.18.37-.45 1.04-.52 1.49-.15.45.37.52 1.04.15 1.49-.02.04-.22.28-.56.61z"
        id="path8206"
      />
      <path
        className="st10"
        d="M513.58 860.78c-.7-.37-1.47-.68-2.32-.89.96-.65 1.65-1.35 1.94-1.67.06.77.53 1.45 1.23 1.77-.22.22-.51.49-.85.79z"
        id="path8208"
      />
      <path
        className="st10"
        d="M514.85 857.89c-.45-.37-1.11-.3-1.49.15-.01.01-.06.06-.15.18-.01-.18-.01-.36.03-.55l.29-1.51c1.47.51 2.77 1.21 3.91 2.06l-.04.24a2.135 2.135 0 0 1-2.08 1.72c-.13 0-.26-.01-.39-.04-.17-.04-.34-.08-.49-.16.34-.33.54-.57.56-.61.37-.45.3-1.12-.15-1.48z"
        id="path8210"
      />
      <path
        className="st10"
        d="M510.34 855.39c1.14.16 2.2.42 3.18.77l-.29 1.51c-.04.19-.04.37-.03.55-.3.32-.99 1.02-1.94 1.67-.48-.13-.99-.23-1.51-.31-.99-.15-1.93-.21-2.83-.21-1.19 0-2.3.13-3.34.37-.65-.52-1.28-1.18-1.9-1.98a.855.855 0 0 0-.44-.32l.15-1.5c2.63-.85 5.62-1.03 8.95-.55z"
        id="path8212"
      />
      <path
        className="st10"
        d="M513.58 860.78c-1.35 1.13-3.55 2.56-6.2 2.56-.03 0-.06-.01-.1-.01-2.14-.02-4.15-.97-5.99-2.8.71-.34 1.47-.61 2.28-.79 1.2.97 2.44 1.46 3.73 1.48.03 0 .05.01.08.01 1.49 0 2.84-.63 3.88-1.34.85.21 1.61.51 2.32.89z"
        id="path8214"
      />
      <path
        className="st10"
        d="m506.24 420.32 2.93 5.37c-3.02-.97-4.92-1.56-5.01-1.59-.56-.18-1-.56-1.25-1.05-.01 0-.01-.01-.01-.01a2.114 2.114 0 0 1 2.52-2.97c.1.03.39.12.82.25z"
        id="path8216"
      />
      <path
        className="st10"
        d="M511.63 867.86c-2.01-.66-5.73-1.49-8.98-.14-.52-.45-1.06-.97-1.61-1.58 4.73-2.47 10.31-.7 12.27.07-.48.57-1.03 1.13-1.68 1.65z"
        id="path8218"
      />
      <path
        className="st10"
        d="M503.09 839.65a2.12 2.12 0 0 0-1.49-2.25v-.01c6.73 2.06 12.63 1.91 16.68 1.32l.06.41c-.92.08-1.71.77-1.89 1.72l-.46 2.42c-.97.07-1.99.11-3.07.11-3 0-6.41-.32-10.08-1.23z"
        id="path8220"
      />
      <path
        className="st10"
        d="M501.6 837.4c.95.29 1.6 1.22 1.49 2.25l-.26 2.49c-1.34-.33-2.72-.73-4.12-1.23l.18-1.71a2.11 2.11 0 0 1 2.32-1.88c.13.02.26.04.39.08z"
        id="path8222"
      />
      <path
        className="st10"
        d="m502.83 842.14-1.44 13.79c-1.64.52-3.14 1.3-4.49 2.34l1.82-17.36c1.39.5 2.78.9 4.11 1.23z"
        id="path8224"
      />
      <path
        className="st10"
        d="M500.86 860.07c.08-.19.14-.39.16-.61l.21-2.02c.17.06.32.17.44.32.61.8 1.25 1.46 1.9 1.98-.81.18-1.57.45-2.28.79l-.43-.46z"
        id="path8226"
      />
      <path
        className="st10"
        d="M502.66 867.72c-.42.17-.85.39-1.25.64-.18.11-.37.17-.56.17-.31 0-.61-.13-.81-.37-.03-.04-.06-.07-.08-.11-.31-.49-.17-1.15.32-1.46.25-.16.51-.31.77-.44.55.6 1.09 1.12 1.61 1.57z"
        id="path8228"
      />
      <path
        className="st10"
        d="m501.23 857.43-.21 2.02c-.02.22-.08.42-.16.61-.29-.32-.57-.66-.85-1.01-.36-.47-.27-1.13.19-1.49.31-.23.7-.27 1.03-.13z"
        id="path8230"
      />
      <path
        className="st10"
        d="m502.9 423.03-2.4-4.38a2.11 2.11 0 0 1-.26-1.01v-12.5c1.39-.3 2.78-.65 4.15-1.03.05.18.08.37.08.57v12.41l1.76 3.22c-.43-.13-.71-.22-.82-.25-1.11-.35-2.3.27-2.65 1.39-.16.55-.1 1.11.14 1.58z"
        id="path8232"
      />
      <path
        className="st10"
        d="M506.05 872.16c-1.44-.49-3.67-1.59-6.02-3.99l.01-.01a1.05 1.05 0 0 0 1.37.2c.4-.25.82-.47 1.25-.64 1.73 1.48 3.23 2.15 4.07 2.44.37.13.77.11 1.12-.03 1.51-.63 2.76-1.41 3.78-2.27.92.3 1.48.56 1.5.57.43.2.93.08 1.23-.25l.01.01c-1.37 1.47-3.23 2.87-5.71 3.9-.45.18-.92.27-1.4.27-.41 0-.82-.06-1.21-.2z"
        id="path8234"
      />
      <path
        className="st10"
        d="M500.03 868.17c-1.01-1.04-2.04-2.32-3.04-3.9.42-.61.89-1.2 1.43-1.72.86 1.45 1.75 2.64 2.63 3.6-.26.13-.52.28-.77.44-.49.31-.63.97-.32 1.46.02.04.05.08.07.12z"
        id="path8236"
      />
      <path
        className="st10"
        d="M496.89 858.27a14.47 14.47 0 0 1 4.49-2.34l-.15 1.5c-.33-.14-.73-.1-1.04.13-.46.36-.55 1.02-.19 1.49.28.36.56.7.85 1.01-.32.76-1.08 1.28-1.94 1.28-.07 0-.15-.01-.22-.01a2.18 2.18 0 0 1-1.36-.69 2.14 2.14 0 0 1-.53-1.63z"
        id="path8238"
      />
      <path
        className="st10"
        d="M498.42 862.55c-.31-.51-.61-1.05-.9-1.63a.966.966 0 0 0-.19-.26l.01-.01c.34.37.82.63 1.36.69a2.118 2.118 0 0 0 2.16-1.27l.43.46c-1.03.49-1.95 1.13-2.78 1.92-.03.02-.06.06-.09.1z"
        id="path8240"
      />
      <path
        className="st10"
        d="M497.52 612.22v1.15c-1.42.09-2.83.16-4.23.21v-1.36c0-1.17.95-2.11 2.11-2.11 1.18 0 2.12.94 2.12 2.11z"
        id="path8242"
      />
      <path
        className="st10"
        d="M495.64 861.88c-.27-.52-.06-1.16.46-1.42a1.058 1.058 0 0 1 1.42.46c.3.58.59 1.12.9 1.63-.54.52-1.01 1.11-1.43 1.72-.45-.74-.91-1.53-1.35-2.39z"
        id="path8244"
      />
      <path
        className="st10"
        d="m493.98 878.35.03-1.78c0-.06 0-.12-.01-.18 8.79 3.85 21.99 2.23 26.83 1.45 0 .16-.01.28-.01.37l-.46 1.85c-2.66.41-6.95.92-11.68.92-4.86 0-10.18-.54-14.68-2.32-.02-.09-.02-.2-.02-.31z"
        id="path8246"
      />
      <path
        className="st10"
        d="M494.01 825.5v2.34c-.85-.39-1.72-.82-2.6-1.27-.37-.19-.58-.56-.58-.94 0-.16.04-.32.12-.48.27-.52.91-.72 1.43-.46.56.28 1.1.55 1.63.81z"
        id="path8248"
      />
      <path
        className="st10"
        d="M494.01 878.68c-.91-.35-1.79-.75-2.62-1.22-.34-.18-.54-.53-.54-.89-.01-.18.04-.37.13-.55.28-.51.92-.69 1.44-.41.52.28 1.04.55 1.59.78.01.06.01.12.01.18l-.03 1.78a.92.92 0 0 0 .02.33z"
        id="path8250"
      />
      <path
        className="st10"
        d="M495.84 465.88c-2.18 5.37-4.14 10.96-5.54 16.37-.32-1.29-.69-2.61-1.09-3.97 1.15-3.88 2.61-8.03 4.35-12.4z"
        id="path8252"
      />
      <path
        className="st10"
        d="M484.86 465.88h8.71c-1.75 4.37-3.21 8.52-4.35 12.4-1.15-3.88-2.61-8.02-4.36-12.4z"
        id="path8254"
      />
      <path
        className="st10"
        d="M489.79 835.43v-9.81h1.05c0 .39.21.75.58.94.88.45 1.75.87 2.6 1.27v6.36c2.6 1.41 5.15 2.44 7.59 3.19v.01c-.13-.04-.26-.06-.39-.08-1.15-.13-2.2.73-2.32 1.88l-.18 1.71c-2.54-.89-5.18-2.09-7.87-3.64a2.088 2.088 0 0 1-1.06-1.83z"
        id="path8256"
      />
      <path
        className="st10"
        d="M491.39 877.46c.83.47 1.71.87 2.62 1.22.08.9.61 1.68 1.4 2.04 9.29 4.3 18.49 2.71 23.14 1.36a2.59 2.59 0 0 0 1.78-1.87l.04-.14c1.59-.25 2.6-.46 2.78-.49.44-.09.75-.44.82-.85l1.04.16c-.01.06-.02.12-.04.18l-.54 2.18a6.852 6.852 0 0 1-4.71 4.91c-2.66.76-6.62 1.6-11.27 1.6-4.5 0-9.63-.78-14.82-3.19-2.4-1.11-3.92-3.57-3.87-6.28l.02-1.65 1.06-.06c.01.35.21.7.55.88z"
        id="path8258"
      />
      <path
        className="st10"
        d="M490.96 825.15c-.08.15-.12.32-.12.48h-1.05V643.66h1.09c1.13 0 2.2-.25 3.14-.68V825.5c-.54-.26-1.08-.53-1.63-.81-.53-.26-1.16-.06-1.43.46z"
        id="path8260"
      />
      <path
        className="st10"
        d="M494.01 642.98c-.94.43-2 .68-3.14.68h-1.09v-1a2.11 2.11 0 0 1 4.22 0v.32z"
        id="path8262"
      />
      <path
        className="st10"
        d="M490.98 876.02c-.1.18-.14.37-.13.55l-1.06.06c-.36-3.76.39-12.01 5.8-17.23.42-.41.86-.79 1.32-1.13l-.08.75c-.06.61.15 1.2.53 1.63l-.01.01c-.31-.32-.81-.42-1.23-.2-.51.27-.73.9-.46 1.42.44.87.89 1.66 1.35 2.39-2.68 3.87-3.3 9.19-2.99 12.05 0 .03.01.06.01.08-.55-.23-1.08-.5-1.59-.78s-1.18-.1-1.46.4z"
        id="path8264"
      />
      <path
        className="st10"
        d="M491.29 486.55c-.27-1.39-.6-2.82-.98-4.3 1.4-5.4 3.36-11 5.54-16.37h-2.28c.11-.26.21-.53.32-.79 4.83-12.03 10.67-22.94 13.72-28.38.88-1.56.89-3.44.03-5.02l-4.73-8.65c.25.49.68.87 1.25 1.05.08.03 1.99.63 5.01 1.59l2.18 3.98a9.366 9.366 0 0 1-.04 9.12c-3.01 5.35-8.76 16.08-13.5 27.89-3.11 7.7-5.31 14.65-6.51 20.66.04-.25.04-.51-.01-.78z"
        id="path8266"
      />
      <path
        className="st10"
        d="M488.55 488.6c.05-.04.09-.08.13-.12-.04.04-.08.08-.13.12z"
        id="path8268"
      />
      <path
        className="st10"
        d="M488.19 488.84c.04-.03.09-.05.13-.08-.04.03-.09.05-.13.08z"
        id="path8270"
      />
      <path className="st10" d="M487.83 488.98z" id="path8272" />
      <path className="st10" d="M487.21 489.07z" id="path8274" />
      <path
        className="st10"
        d="M490.31 482.25c-.42 1.59-.78 3.16-1.09 4.71-.31-1.54-.68-3.11-1.09-4.71.32-1.29.69-2.61 1.09-3.97.4 1.36.76 2.68 1.09 3.97z"
        id="path8276"
      />
      <path
        className="st10"
        d="M489.63 489.03c-.14.03-.28.04-.42.04-.05 0-.1 0-.15-.01-.08-.01-.18-.01-.27-.04-.08-.01-.15-.04-.22-.06a.578.578 0 0 1-.14-.05c-.06-.02-.11-.05-.17-.08a.914.914 0 0 1-.14-.07c-.08-.06-.17-.11-.25-.18-.04-.04-.09-.08-.13-.12a1.8 1.8 0 0 1-.3-.37c-.03-.04-.05-.08-.07-.12a.405.405 0 0 1-.05-.09 2.226 2.226 0 0 1-.19-.57c-.04-.25-.04-.51.01-.77.27-1.39.61-2.82.98-4.3.42 1.59.78 3.16 1.09 4.71.31-1.55.68-3.12 1.09-4.71.38 1.48.7 2.91.98 4.3.06.27.06.53.01.78 0 .01-.01.03-.01.04-.08.44-.3.82-.61 1.11-.04.04-.08.08-.13.12-.07.06-.15.11-.23.16-.04.03-.09.05-.13.08-.06.03-.13.06-.2.08l-.15.06c-.07.03-.13.05-.2.06z"
        id="path8278"
      />
      <path
        className="st10"
        d="M484.86 465.88c1.75 4.38 3.21 8.52 4.35 12.4-.4 1.35-.77 2.68-1.09 3.97-1.4-5.4-3.36-11-5.53-16.37z"
        id="path8280"
      />
      <path
        className="st10"
        d="M487.07 489.06c-.09-.01-.18-.01-.27-.04.09.03.18.04.27.04z"
        id="path8282"
      />
      <path className="st10" d="M486.44 488.92z" id="path8284" />
      <path
        className="st10"
        d="M486.27 488.85c.06.03.11.06.17.08-.06-.03-.11-.05-.17-.08z"
        id="path8286"
      />
      <path
        className="st10"
        d="M486.13 488.78c.05.03.09.05.14.07-.05-.03-.1-.05-.14-.07z"
        id="path8288"
      />
      <path
        className="st10"
        d="M485.75 488.48c.04.04.09.08.13.12-.05-.04-.09-.08-.13-.12z"
        id="path8290"
      />
      <path
        className="st10"
        d="M485.45 612.38v.35c0 .18-.13.33-.32.35-.01-.01-.02-.01-.04-.01-.01 0-.02 0-.04.01a.356.356 0 0 1-.32-.35v-.35c0-.19.15-.35.35-.35.21 0 .37.16.37.35z"
        id="path8292"
      />
      <path
        className="st10"
        d="M485.38 487.99c.02.04.04.08.07.12a.346.346 0 0 1-.07-.12z"
        id="path8294"
      />
      <path
        className="st10"
        d="M484.74 641.54v-.35c0-.17.12-.31.28-.35.02.01.04.01.07.01.03 0 .05 0 .07-.01.16.04.28.18.28.35v.35c0 .2-.15.35-.35.35a.33.33 0 0 1-.32-.21.32.32 0 0 1-.03-.14z"
        id="path8296"
      />
      <path
        className="st10"
        d="M485.26 487.77c.02.05.04.09.06.13-.02-.04-.04-.09-.06-.13z"
        id="path8298"
      />
      <path
        className="st10"
        d="M485.16 640.84c-.02.01-.04.01-.07.01-.03 0-.05 0-.07-.01.02-.01.04-.01.07-.01.03.01.05.01.07.01z"
        id="path8300"
      />
      <path
        className="st10"
        d="M485.09 613.08c.01 0 .02 0 .04.01-.02 0-.02 0-.04-.01-.01.01-.02.01-.04.01.02-.01.03-.01.04-.01z"
        id="path8302"
      />
      <path
        className="st10"
        d="M484.95 639.43h.28c-.02.01-.05.02-.08.03.16.03.29.18.29.35v.7c0 .17-.12.31-.28.35-.02-.01-.04-.01-.07-.01-.03 0-.05 0-.07.01a.363.363 0 0 1-.28-.35v-.7c0-.17.13-.32.29-.35a.689.689 0 0 1-.08-.03z"
        id="path8304"
      />
      <path
        className="st10"
        d="M485.45 613.63c-.23 0-.47-.01-.7-.01v-.18c0-.18.13-.33.32-.35h.08c.18.01.32.16.32.35v.19z"
        id="path8306"
      />
      <path
        className="st10"
        d="M485.16 614.47c.16.03.29.18.29.35v.69c0 .18-.13.32-.29.35.16.04.29.18.29.35v.69c0 .18-.13.32-.29.35.16.03.29.18.29.35v.69c0 .18-.13.32-.29.35.16.03.29.17.29.35v.69c0 .18-.13.32-.29.35.16.03.29.17.29.35v.69c0 .18-.13.32-.29.35.16.03.29.17.29.35v.69c0 .18-.13.32-.29.35.16.03.29.17.29.35v.69c0 .18-.13.32-.29.35.16.03.29.17.29.35v.69c0 .18-.13.32-.29.35.16.03.29.17.29.35v.69c0 .18-.13.32-.29.35.16.03.29.17.29.35v.7c0 .17-.13.32-.29.35.16.03.29.17.29.35v.69c0 .18-.13.32-.29.35.16.03.29.17.29.35v.7c0 .17-.13.32-.29.35.16.03.29.17.29.35v.7c0 .17-.13.32-.29.35.16.03.29.17.29.35v.7c0 .17-.13.32-.29.35.16.03.29.17.29.35v.7c0 .17-.13.32-.29.35.16.03.29.18.29.35v.7c0 .17-.13.32-.29.35.16.03.29.18.29.35v.7c0 .17-.13.32-.29.35.16.03.29.18.29.35v.7c0 .14-.08.27-.21.32h-.28a.339.339 0 0 1-.21-.32v-.7c0-.17.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.7c0-.17.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.7c0-.17.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.7c0-.18.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.7c0-.18.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.7c0-.18.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.7c0-.18.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.69c0-.18.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.7c0-.18.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.69c0-.18.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.69c0-.18.13-.32.29-.35a.373.373 0 0 1-.29-.35v-.69c0-.18.13-.32.29-.35a.364.364 0 0 1-.29-.35v-.69c0-.18.13-.32.29-.35a.373.373 0 0 1-.29-.35v-.69c0-.18.13-.32.29-.35a.373.373 0 0 1-.29-.35v-.69c0-.18.13-.32.29-.35a.373.373 0 0 1-.29-.35v-.69c0-.18.13-.32.29-.35a.356.356 0 0 1-.29-.35v-.69c0-.18.13-.32.29-.35a.356.356 0 0 1-.29-.35v-.69c0-.18.13-.32.29-.35a.356.356 0 0 1-.29-.35v-.51c.23.01.47.01.7.01v.49c0 .19-.13.33-.29.36z"
        id="path8308"
      />
      <path
        className="st10"
        d="m484.47 641.83.3-.15c.05.13.18.21.32.21.2 0 .35-.15.35-.35v-.35c0-.17-.12-.31-.28-.35.16-.04.28-.18.28-.35v-.7c0-.17-.13-.32-.29-.35.03-.01.06-.01.08-.03h5.64c1.38 0 2.42-.78 2.42-1.47v-24.38c1.39-.05 2.8-.12 4.23-.21v24.59c0 2.18-1.42 4.07-3.51 5.02v-.32a2.11 2.11 0 0 0-4.22 0v1h-5.14v-1c-.01-.27-.06-.55-.18-.81z"
        id="path8310"
      />
      <path
        className="st10"
        d="M484.64 642.66v1h-1.09a7.52 7.52 0 0 1-3.14-.68v-.32c0-1.16.95-2.11 2.11-2.11.87 0 1.63.54 1.94 1.29.13.25.18.53.18.82z"
        id="path8312"
      />
      <path
        className="st10"
        d="M487.14 487.32c-1.2-6-3.39-12.95-6.5-20.64-4.75-11.82-10.5-22.55-13.5-27.89a9.34 9.34 0 0 1-.05-9.12l1.35-2.46c5.32-3.14 8.03-6.13 8.21-6.33.08-.1.16-.2.23-.3l-6.08 11.12c-.86 1.58-.85 3.45.03 5.02 3.05 5.44 8.9 16.35 13.73 28.39.11.26.21.52.31.78h-2.27c2.17 5.37 4.13 10.96 5.53 16.37-.37 1.48-.7 2.91-.98 4.3-.06.25-.06.52-.01.76z"
        id="path8314"
      />
      <path
        className="st10"
        d="M483.47 825.15a1.047 1.047 0 0 1-.46 1.42c-.88.45-1.75.87-2.6 1.27v-2.33c.54-.26 1.09-.54 1.63-.82a1.06 1.06 0 0 1 1.43.46z"
        id="path8316"
      />
      <path
        className="st10"
        d="M483.47 825.15c-.27-.52-.91-.73-1.42-.46-.55.28-1.09.56-1.63.82V642.98c.93.43 2 .68 3.14.68h1.09v181.97h-1.05c-.01-.17-.05-.33-.13-.48z"
        id="path8318"
      />
      <path
        className="st10"
        d="M482.53 640.54c-1.16 0-2.11.95-2.11 2.11v.32c-2.09-.96-3.51-2.85-3.51-5.02v-24.77c1.39.11 2.8.21 4.23.28v24.49c0 .7 1.04 1.47 2.42 1.47h1.4c.02.01.05.02.08.03-.16.03-.29.18-.29.35v.7c0 .17.12.31.28.35-.16.04-.28.18-.28.35v.35c0 .05.01.1.03.14l-.3.15c-.32-.76-1.08-1.3-1.95-1.3z"
        id="path8320"
      />
      <path
        className="st10"
        d="M481.13 612.38v1.09c-1.43-.07-2.84-.17-4.23-.28v-.8c0-1.17.94-2.11 2.11-2.11 1.18-.01 2.12.93 2.12 2.1z"
        id="path8322"
      />
      <path
        className="st10"
        d="M483.04 877.46c-.83.46-1.7.87-2.61 1.22.01-.11.02-.22.02-.33l-.04-1.78c0-.06 0-.11.01-.17.55-.24 1.08-.51 1.6-.79.51-.28 1.15-.1 1.44.41.1.17.14.36.13.54-.01.36-.21.72-.55.9z"
        id="path8324"
      />
      <path
        className="st10"
        d="M481.13 612.38c0-1.17-.94-2.11-2.11-2.11l.08-1.16c5.14.35 10.6.44 16.27.15l.04.85c-1.16 0-2.11.94-2.11 2.11v1.36c-1.62.06-3.23.08-4.8.08-1.02 0-2.04-.01-3.04-.04v-.2c0-.18-.13-.33-.32-.35.18-.02.32-.17.32-.35v-.35c0-.19-.15-.35-.35-.35-.2 0-.35.16-.35.35v.35c0 .18.13.33.32.35-.18.01-.32.16-.32.35v.18c-1.22-.04-2.42-.08-3.61-.15v-1.07z"
        id="path8326"
      />
      <path
        className="st10"
        d="M453.59 877.85c4.83.78 18.04 2.4 26.84-1.44-.01.06-.01.11-.01.17l.04 1.78c0 .11-.01.23-.02.33-4.49 1.77-9.82 2.32-14.68 2.32-4.73 0-9.01-.51-11.67-.92l-.46-1.85a1.51 1.51 0 0 1-.04-.39z"
        id="path8328"
      />
      <path
        className="st10"
        d="M480.42 825.51v2.33c-7.65 3.52-14.25 4.61-19.52 4.61-4.66 0-8.27-.86-10.62-1.66-.15-.82-.31-1.63-.45-2.44 2 .78 5.84 1.93 11.12 1.93 5.21-.01 11.82-1.12 19.47-4.77z"
        id="path8330"
      />
      <path
        className="st10"
        d="M477.1 860.66c.31-.32.81-.42 1.23-.2.52.27.73.9.46 1.42-.44.87-.89 1.66-1.35 2.39-.42-.62-.89-1.2-1.43-1.73.3-.51.6-1.04.89-1.62.06-.1.12-.19.2-.26z"
        id="path8332"
      />
      <path
        className="st10"
        d="m475.72 840.91 1.82 17.36a14.47 14.47 0 0 0-4.49-2.34l-1.44-13.79c1.33-.33 2.7-.73 4.11-1.23z"
        id="path8334"
      />
      <path
        className="st10"
        d="M478.33 860.45c-.42-.21-.92-.12-1.23.2l-.01-.01c.39-.43.59-1.01.53-1.63l-.08-.75c.46.35.89.73 1.32 1.13 5.4 5.21 6.16 13.46 5.8 17.22l-1.06-.06c.01-.18-.04-.37-.13-.54-.29-.51-.93-.69-1.44-.41-.51.28-1.05.55-1.6.79 0-.03.01-.06.01-.09.3-2.85-.32-8.18-2.99-12.05.46-.73.92-1.52 1.35-2.39.26-.51.05-1.14-.47-1.41z"
        id="path8336"
      />
      <path
        className="st10"
        d="M476.48 417.9a2.12 2.12 0 0 0-2.99.18l-.15.15.62-1.13v-10.47c.66.06 1.31.11 1.96.16.75.06 1.51.11 2.27.14v10.71c0 .35-.08.7-.26 1.01l-.95 1.73c.39-.81.21-1.84-.5-2.48z"
        id="path8338"
      />
      <path
        className="st10"
        d="m475.54 839.2.18 1.71c-1.4.5-2.78.9-4.11 1.23l-.26-2.49c-.11-.98.48-1.87 1.36-2.21a2.115 2.115 0 0 1 2.83 1.76z"
        id="path8340"
      />
      <path
        className="st10"
        d="M476.48 417.9c.72.64.89 1.67.49 2.49-.03.06-.06.13-.1.19-.06.11-.14.2-.23.3-.18.2-2.9 3.19-8.21 6.33l4.9-8.98.15-.15c.78-.88 2.12-.96 3-.18z"
        id="path8342"
      />
      <path
        className="st10"
        d="M477.44 864.26c-1 1.58-2.03 2.86-3.04 3.9.03-.04.06-.07.08-.11.32-.49.17-1.15-.32-1.47a8.46 8.46 0 0 0-.77-.44c.87-.97 1.77-2.15 2.63-3.6.53.53 1.01 1.1 1.42 1.72z"
        id="path8344"
      />
      <path
        className="st10"
        d="M474.15 866.58c.49.32.64.97.32 1.47-.02.04-.05.08-.08.11-.2.24-.51.37-.81.37-.2 0-.39-.06-.57-.16-.41-.26-.82-.47-1.25-.65.52-.45 1.06-.97 1.61-1.59.27.14.53.29.78.45z"
        id="path8346"
      />
      <path
        className="st10"
        d="m473.41 859.45-.21-2.02c.33-.15.73-.1 1.04.13.46.36.55 1.02.19 1.49-.28.36-.56.7-.85 1.01-.1-.19-.15-.39-.17-.61z"
        id="path8348"
      />
      <path
        className="st10"
        d="M476.91 860.92c-.3.58-.59 1.11-.89 1.62-.03-.04-.06-.06-.09-.09-.82-.8-1.75-1.44-2.78-1.92.14-.15.29-.3.43-.46.32.76 1.09 1.28 1.94 1.28.08 0 .15-.01.23-.01.54-.06 1.01-.32 1.35-.69l.01.01c-.09.07-.15.16-.2.26z"
        id="path8350"
      />
      <path
        className="st10"
        d="M473.04 855.93c1.64.52 3.14 1.3 4.49 2.34l.08.75c.06.61-.14 1.2-.53 1.63-.34.37-.81.63-1.35.69-.08.01-.15.01-.23.01-.85 0-1.61-.52-1.94-1.28.29-.32.57-.66.85-1.01.36-.47.27-1.13-.19-1.49-.3-.23-.7-.28-1.04-.13z"
        id="path8352"
      />
      <path
        className="st10"
        d="M473.14 860.52c-.71-.35-1.47-.61-2.28-.8.65-.51 1.28-1.18 1.9-1.97.12-.16.27-.27.44-.32l.21 2.02c.02.22.08.42.16.61-.14.16-.29.32-.43.46z"
        id="path8354"
      />
      <path
        className="st10"
        d="M473.22 837.32c-.18.02-.36.06-.52.12v-.01c2.48-.75 5.07-1.8 7.71-3.23v-6.36c.85-.39 1.72-.82 2.6-1.27.37-.19.58-.56.58-.94h1.05v9.81c0 .75-.4 1.45-1.05 1.83-2.7 1.56-5.33 2.75-7.88 3.64l-.18-1.71c-.11-1.15-1.15-2-2.31-1.88z"
        id="path8356"
      />
      <path
        className="st10"
        d="M464.09 855.39c3.33-.47 6.32-.3 8.95.54l.15 1.5c-.17.06-.32.17-.44.32-.61.8-1.25 1.46-1.9 1.97-1.82-.43-3.88-.49-6.17-.16-.54.08-1.04.18-1.52.31-.95-.65-1.64-1.35-1.94-1.67.01-.18.01-.36-.03-.55l-.29-1.51c.99-.33 2.05-.59 3.19-.75z"
        id="path8358"
      />
      <path
        className="st10"
        d="M471.77 867.72c-3.24-1.35-6.95-.52-8.98.14-.64-.54-1.2-1.09-1.68-1.65 1.97-.78 7.53-2.54 12.27-.08-.55.62-1.09 1.14-1.61 1.59z"
        id="path8360"
      />
      <path
        className="st10"
        d="M467.05 863.33c-2.65 0-4.85-1.42-6.2-2.56.7-.37 1.47-.67 2.31-.89 1.04.7 2.4 1.34 3.89 1.34.03 0 .06-.01.08-.01 1.28-.02 2.53-.51 3.73-1.49.81.19 1.57.45 2.28.8-1.84 1.84-3.85 2.78-5.99 2.8-.04.01-.06.01-.1.01z"
        id="path8362"
      />
      <path
        className="st10"
        d="M461.22 858.21c.3.32.99 1.02 1.94 1.67-.84.23-1.61.53-2.31.89-.35-.3-.63-.56-.85-.8.7-.31 1.17-.98 1.22-1.76z"
        id="path8364"
      />
      <path
        className="st10"
        d="M462.79 867.86c-.91.3-1.47.56-1.49.57-.43.2-.93.08-1.24-.25-.06-.07-.12-.16-.17-.25-.25-.53-.02-1.16.5-1.41.06-.03.31-.14.73-.3.48.55 1.03 1.11 1.67 1.64z"
        id="path8366"
      />
      <path
        className="st10"
        d="M461.3 868.44c.02-.01.58-.27 1.49-.57 1.02.85 2.28 1.64 3.79 2.27.35.14.75.15 1.12.03.84-.28 2.34-.96 4.07-2.44.42.18.84.39 1.25.65.18.11.37.16.57.16.3 0 .61-.13.81-.37-2.34 2.42-4.58 3.51-6.01 4-.39.13-.8.2-1.21.2-.48 0-.96-.09-1.4-.27-2.49-1.03-4.34-2.43-5.72-3.9l.01-.01c.3.33.8.45 1.23.25z"
        id="path8368"
      />
      <path
        className="st10"
        d="m458.44 843.26 2.47 12.89c-1.47.51-2.76 1.21-3.9 2.06l-2.97-15.54c1.26.25 2.74.46 4.4.59z"
        id="path8370"
      />
      <path
        className="st10"
        d="M459.43 859.37c-.37-.46-.3-1.12.15-1.49.45-.37 1.12-.3 1.49.15.01.01.06.07.15.18-.06.77-.53 1.45-1.23 1.77-.33-.33-.53-.57-.56-.61z"
        id="path8372"
      />
      <path
        className="st10"
        d="M460.05 868.19a15.92 15.92 0 0 1-2.89-4.27c.46-.61.99-1.18 1.57-1.69a13.88 13.88 0 0 0 2.38 3.99c-.42.16-.67.27-.73.3-.52.25-.75.88-.5 1.41.06.09.12.18.17.26z"
        id="path8374"
      />
      <path
        className="st10"
        d="M459.12 860.18c-.99 0-1.88-.7-2.07-1.72l-.04-.24c1.14-.85 2.43-1.55 3.9-2.06l.29 1.51c.04.19.04.37.03.55-.1-.11-.15-.17-.15-.18-.37-.45-1.04-.52-1.49-.15a1.07 1.07 0 0 0-.15 1.49c.03.04.23.27.56.61-.15.07-.31.12-.48.16-.14.01-.27.03-.4.03z"
        id="path8376"
      />
      <path
        className="st10"
        d="m457.98 840.85.46 2.42c-1.66-.13-3.14-.34-4.41-.58l-.2-1.05c-.22-1.15.53-2.25 1.68-2.47.2-.04.39-.05.58-.03.92.08 1.72.75 1.89 1.71z"
        id="path8378"
      />
      <path
        className="st10"
        d="M457.98 840.85c-.18-.95-.97-1.63-1.9-1.71l.06-.42c4.01.58 9.88.73 16.56-1.28v.01c-.88.33-1.47 1.23-1.36 2.21l.26 2.49c-3.68.91-7.09 1.23-10.09 1.23-1.08 0-2.11-.04-3.07-.11z"
        id="path8380"
      />
      <path
        className="st10"
        d="M456.16 860.94c-.11-.57.28-1.12.86-1.22.57-.11 1.12.28 1.22.85.01.08.14.73.5 1.66-.58.51-1.11 1.09-1.57 1.69-.77-1.64-.99-2.85-1.01-2.98z"
        id="path8382"
      />
      <path
        className="st10"
        d="M454.07 880.07c-1.59-.25-2.6-.46-2.78-.49-.44-.09-.76-.44-.83-.85a1.059 1.059 0 0 1 1.26-1.21c.04.01.71.15 1.86.33.01.16.01.28.02.37z"
        id="path8384"
      />
      <path
        className="st10"
        d="m450.01 881.24-.55-2.18c-.01-.06-.03-.11-.04-.18l1.04-.16c.07.41.39.76.83.85.18.04 1.18.25 2.78.49l.04.14c.23.9.91 1.62 1.78 1.87 4.66 1.34 13.86 2.95 23.14-1.36.78-.36 1.31-1.14 1.4-2.04.91-.35 1.78-.76 2.61-1.22.34-.18.54-.54.55-.89l1.06.06.03 1.66c.04 2.71-1.47 5.17-3.87 6.28-5.19 2.4-10.32 3.18-14.82 3.18-4.64 0-8.62-.84-11.27-1.6a6.786 6.786 0 0 1-4.71-4.9z"
        id="path8386"
      />
      <path
        className="st10"
        d="M449.4 878.71c-.44-5.66.89-15.54 7.6-20.49l.04.24a2.116 2.116 0 0 0 2.07 1.72c.13 0 .27-.01.4-.04.17-.04.33-.08.48-.16.22.23.51.5.85.8-.79.41-1.49.9-2.11 1.45-.36-.93-.49-1.57-.5-1.66-.1-.57-.65-.96-1.22-.85-.58.1-.97.65-.86 1.22.02.13.25 1.35 1.01 2.98-3.62 4.77-3.65 11.89-3.58 13.93-1.15-.18-1.82-.32-1.86-.33-.58-.13-1.13.25-1.25.82-.03.13-.03.27-.01.39l-1.04.16c0-.06-.02-.12-.02-.18z"
        id="path8388"
      />
      <path
        className="st10"
        d="M449.83 828.34c.14.81.3 1.63.45 2.44-1.88-.63-2.95-1.24-3.09-1.32-.3-.18-.48-.47-.52-.78a1.054 1.054 0 0 1 1.57-1.05c.03.01.58.31 1.59.71z"
        id="path8390"
      />
      <path
        className="st10"
        d="M447.19 829.46c.15.08 1.21.69 3.09 1.32.42 2.3.86 4.62 1.31 6.94.94.29 2.51.7 4.55.99l-.06.42c-.18-.02-.38-.01-.58.03-1.15.22-1.9 1.32-1.68 2.47l.2 1.05c-3.02-.58-4.86-1.31-5.08-1.4a2.11 2.11 0 0 1-1.27-1.55c-.7-3.64-1.39-7.26-2.05-10.86l1.04-.19c.05.31.23.6.53.78z"
        id="path8392"
      />
      <path
        className="st10"
        d="M445.63 828.87c-16.18-88.37-18.52-168.76-18.43-209.6.08.37.25.73.53 1.04.42.45.98.68 1.55.68.51 0 1.03-.19 1.44-.56l.71-.66c-.06 40.82 2.3 120.75 18.4 208.57-1.01-.39-1.56-.7-1.59-.71a1.05 1.05 0 0 0-1.44.39c-.12.2-.16.44-.13.66z"
        id="path8394"
      />
      <path
        className="st10"
        d="M445.31 602.67c7.93 2.54 19.73 5.48 33.78 6.45l-.08 1.16c-1.17 0-2.11.94-2.11 2.11v.8c-12.96-1.06-23.93-3.71-31.69-6.12l.89-.82c.86-.79.91-2.13.12-2.98-.25-.29-.57-.49-.91-.6z"
        id="path8396"
      />
      <path
        className="st10"
        d="M443.24 603.13c.58-.53 1.37-.68 2.07-.46a2.105 2.105 0 0 1 .8 3.56l-.89.82c-.4-.12-.8-.25-1.18-.37-1.2-.38-2.35-.76-3.42-1.13z"
        id="path8398"
      />
      <path
        className="st10"
        d="m445.22 607.06-13.79 12.71c.01-2.02.01-3.95.03-5.78l9.15-8.43c1.08.37 2.22.75 3.42 1.13.39.13.78.25 1.19.37z"
        id="path8400"
      />
      <path
        className="st10"
        d="M431.74 597.49c2.18 1.01 6.88 3.05 13.58 5.18v.01c-.7-.22-1.49-.07-2.07.46l-2.63 2.43c-3.86-1.34-6.9-2.59-8.98-3.49.03-1.73.06-3.26.1-4.59z"
        id="path8402"
      />
      <path
        className="st10"
        d="m432.29 589.96-.67.05c-.35-.55-.96-.93-1.67-.97-1.11-.06-2.04.73-2.19 1.79.01-.05.01-.11.03-.16 9.55-41.39 10.64-74.23 10.71-78.84.84 1.32 1.52 5.66 2.62 6.94.32.37.74.6 1.18.68-.45 10.62-2.32 36.64-10.01 70.51z"
        id="path8404"
      />
      <path
        className="st10"
        d="m543.33 592.31.51.07c.29-.53.77-.88 1.32-.88.85-.01 1.52.79 1.58 1.83 0-.05-.01-.1-.01-.15-5.31-40.91-4.59-73.14-4.42-77.66-.7 1.26-.88 2.97-1.78 4.19-.26.35-1.14 3.08-1.48 3.14-.16 10.41.03 35.98 4.28 69.46z"
        id="path8406"
      />
      <path
        className="st10"
        d="M431.63 590c.23.36.36.8.34 1.25-.01.11-.06 1.18-.13 3.13-.97-.43-1.92-.87-2.89-1.32-.74-.36-1.2-1.11-1.21-1.9.01-.06.01-.11.01-.12a2.085 2.085 0 0 1 2.21-2c.71.03 1.31.42 1.67.96z"
        id="path8408"
      />
      <path
        className="st10"
        d="M431.74 597.49c-.04 1.33-.07 2.86-.11 4.59-1.59-.7-2.61-1.2-2.99-1.39a2.102 2.102 0 0 1-1.16-1.84c0-.09 0-.18.01-.27v-.03c.03-.24.09-.48.21-.7a2.102 2.102 0 0 1 2.83-.94c.21.1.61.3 1.21.58z"
        id="path8410"
      />
      <path
        className="st10"
        d="M431.63 602.07c-.08 3.28-.14 7.28-.18 11.92l-3.61 3.33c-.34.31-.56.71-.64 1.13.02-8.33.14-14.95.27-19.6.01.75.44 1.47 1.16 1.84.4.19 1.41.69 3 1.38z"
        id="path8412"
      />
      <path
        className="st10"
        d="m427.85 617.32 3.61-3.33-.03 5.78-.71.66c-.41.37-.92.56-1.44.56-.57 0-1.13-.23-1.55-.68-.27-.3-.45-.66-.53-1.04v-.01c0-.27 0-.54.01-.8v-.01c.08-.42.3-.82.64-1.13z"
        id="path8414"
      />
      <path
        className="st10"
        d="M430.53 596.9a2.11 2.11 0 0 0-3.04 1.64c.11-4.27.23-6.81.25-7.39.01.8.47 1.54 1.21 1.9.97.46 1.92.89 2.89 1.32-.03.86-.06 1.9-.1 3.1-.6-.26-1-.46-1.21-.57z"
        id="path8416"
      />
      <path
        className="st10"
        d="M427.76 590.83c-.01.07-.02.14-.02.21 0-.07.01-.14.02-.21z"
        id="path8418"
      />
      <path
        className="st10"
        d="M427.48 598.85c-.01-.09 0-.18.01-.27-.01.08-.01.18-.01.27z"
        id="path8420"
      />
      <path
        className="st10"
        d="M427.21 618.46c-.01.26-.01.53-.01.8-.05-.26-.05-.54.01-.8z"
        id="path8422"
      />
      <g id="g8444">
        <g id="g8432">
          <g id="g8426">
            <path
              d="M506.42 493.95a5.484 5.484 0 0 0-7.76-.08l-1.87 1.83-1.83-1.87a5.511 5.511 0 0 0-3.87-1.65c-1.4-.01-2.82.51-3.9 1.57a5.484 5.484 0 0 0-.08 7.76l1.83 1.87 7.68 7.85 7.84-7.69 1.87-1.83a5.511 5.511 0 0 0 1.65-3.87c.02-1.41-.5-2.81-1.56-3.89z"
              id="path8424"
              style={{
                fill: "#ff1a1a",
              }}
            />
          </g>
          <g id="g8430">
            <path
              className="st10"
              d="M472.31 492.05c.19-.35.41-.6.67-.75.25-.15 1.18-.21 2.78-.2 1.63.02 2.57.11 2.82.29.55.33.82.87.81 1.63v.3c-.03.5-.22.91-.58 1.24l-.53.48-.06 6.05-.02 6.02.56.27c.72.33 1.08.94 1.07 1.82-.01 1.1-.66 1.81-1.94 2.12-.45.12-.92.18-1.39.17-.53-.01-1.14-.07-1.84-.21-.75-.13-1.26-.27-1.54-.41-.27-.14-.5-.37-.67-.7-.15-.3-.22-.63-.22-.98.01-.88.39-1.49 1.15-1.83l.57-.29.1-5.94.06-5.98-.45-.08c-.48-.1-.87-.35-1.18-.75-.31-.39-.46-.84-.46-1.34 0-.27.1-.58.29-.93z"
              id="path8428"
            />
          </g>
        </g>
        <g id="g8442">
          <path
            className="st10"
            d="M459.65 520.16c.19-.35.41-.6.67-.75.25-.15 1.18-.21 2.78-.2 1.63.02 2.57.11 2.82.29.55.33.82.87.81 1.63v.3c-.03.5-.22.91-.58 1.23l-.53.48-.06 6.05-.02 6.02.56.27c.72.33 1.08.94 1.07 1.82-.01 1.1-.66 1.81-1.94 2.12-.45.12-.92.18-1.39.17-.53-.01-1.14-.07-1.84-.21-.75-.13-1.26-.27-1.54-.41-.27-.14-.5-.37-.67-.7-.15-.3-.22-.63-.22-.98.01-.88.39-1.49 1.15-1.83l.57-.29.1-5.94.06-5.98-.45-.08c-.48-.1-.87-.35-1.18-.75-.31-.39-.46-.84-.46-1.34 0-.26.1-.57.29-.92z"
            id="path8434"
          />
          <path
            className="st10"
            d="M473.38 517.93c.68-.37 1.21-.55 1.58-.55.28 0 .51.02.71.04 1.08.09 2.19.15 3.34.19 1.33.06 2.23.21 2.7.44.7.38 1.04.98 1.03 1.78-.01.93-.42 1.54-1.22 1.83-.23.1-.7.14-1.43.14-.45 0-1.13-.04-2.03-.1-.9-.06-1.48-.09-1.73-.09-.33 0-.51.02-.56.07-.05.05-.11.74-.17 2.07l-.1 1.99c.5.01 1.26.03 2.27.06 1.02.04 1.77.06 2.27.06l.41.42c.45.43.67.95.66 1.55 0 .43-.15.84-.43 1.24-.25.32-.58.53-.97.63-.39.1-1.15.14-2.28.13l-2.03-.02-.01.68c0 .43.03 1.1.11 2.03.08.93.14 1.48.19 1.66.05.18 1.01.27 2.89.29 1.53.02 2.51.07 2.93.16.43.09.76.32 1.01.67.15.23.24.59.29 1.09v.23c-.01.7-.33 1.25-.96 1.64-.35.2-1.7.28-4.03.26-1.96-.02-3.16-.08-3.61-.17-.45-.09-.89-.35-1.31-.78-.94-.99-1.52-3.12-1.74-6.41-.04-.8-.06-1.58-.05-2.33.02-1.93.12-3.98.31-6.14.18-2.17.37-3.41.55-3.74.22-.32.68-.65 1.41-1.02z"
            id="path8436"
          />
          <path
            className="st10"
            d="M488.31 517.82c.2-.1.6-.14 1.2-.14l8.34.27c1.9.07 3.08.16 3.51.26.44.11.79.37 1.06.8.2.28.29.64.29 1.09-.01.8-.33 1.4-.96 1.8-.25.15-1.2.21-2.86.2l-2.44-.06-.07 7.14c-.05 4.76-.15 7.31-.3 7.63-.36.7-.98 1.04-1.85 1.03-.78-.01-1.35-.31-1.72-.92-.12-.23-.19-.68-.21-1.37-.02-.69-.01-2.8.03-6.34l.08-7.29-1.92-.13c-1.05-.06-1.76-.15-2.12-.27-.36-.12-.67-.35-.91-.71-.2-.28-.29-.63-.29-1.06 0-.96.38-1.61 1.14-1.93z"
            id="path8438"
          />
          <path
            className="st10"
            d="M507.34 517.64c.25-.17 1.14-.25 2.67-.24l2.18.02c2.43.05 3.9.12 4.4.21.5.09.9.38 1.19.86.22.35.33.72.33 1.09-.01.8-.34 1.38-1 1.72-.33.17-1.51.25-3.54.23l-3.08-.03.06 1.28c0 .23.02.66.06 1.3.04.64.08 1.07.1 1.3l.1 1.28 1.28.09c.1 0 .25.01.45.02s.34.02.41.02c.53.01.94-.03 1.24-.1.2-.05.48-.07.83-.07 1.15.01 1.84.61 2.05 1.79v.23c-.01.7-.29 1.26-.84 1.68-.56.4-1.54.59-2.94.57-.38 0-.68-.02-.9-.05l-1.65-.09.04 3.38c.02.75.02 1.57.01 2.44-.01.7-.06 1.15-.16 1.35-.36.7-.91 1.08-1.67 1.15h-.26c-.75-.01-1.31-.31-1.68-.92-.12-.2-.2-.65-.23-1.34-.03-.69-.07-2.79-.1-6.3-.04-2.96-.06-5.52-.03-7.67.03-2.66.09-4.21.2-4.66.03-.18.2-.37.48-.54z"
            id="path8440"
          />
        </g>
      </g>
      <radialGradient
        id="SVGID_00000080913371773681548450000009388068352636210580_"
        cx={493.23}
        cy={435.515}
        r={23.966}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#e57070",
          }}
          id="stop8446"
        />
        <stop
          offset={0.17}
          style={{
            stopColor: "#e67574",
            stopOpacity: 0.8303,
          }}
          id="stop8448"
        />
        <stop
          offset={0.379}
          style={{
            stopColor: "#ea8480",
            stopOpacity: 0.6213,
          }}
          id="stop8450"
        />
        <stop
          offset={0.608}
          style={{
            stopColor: "#f09d93",
            stopOpacity: 0.3917,
          }}
          id="stop8452"
        />
        <stop
          offset={0.851}
          style={{
            stopColor: "#f9c0ad",
            stopOpacity: 0.149,
          }}
          id="stop8454"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#ffd9c0",
            stopOpacity: 0,
          }}
          id="stop8456"
        />
      </radialGradient>
      <path
        style={{
          opacity: 0.38,
          fill: "url(#SVGID_00000080913371773681548450000009388068352636210580_)",
        }}
        d="M507.61 436.72c-3.05 5.44-8.9 16.35-13.72 28.38-.11.26-.21.53-.32.79h-8.71c-.01-.03-.02-.05-.03-.08 20.93-41.33-6.65-58.87-6.65-58.87 1.47.08 2.96.11 4.44.11.48 0 .95-.01 1.43-.01 5.47-.08 10.9-.73 16.2-1.89v12.5c0 .35.09.7.26 1.01l2.4 4.38c0 .01 0 .01.01.01l4.73 8.65a5.18 5.18 0 0 1-.04 5.02z"
        id="path8459"
      />
      <path
        className="st13"
        d="M480.42 642.98v182.53c-7.64 3.65-14.25 4.76-19.46 4.76-5.28 0-9.12-1.15-11.12-1.93-2.65-14.44-4.92-28.68-6.88-42.55 37.57-58.86 33.95-144.42 33.95-144.42l.76-.77c.61 1.01 1.58 1.84 2.75 2.38z"
        id="path8461"
      />
      <path
        className="st13"
        d="M495.4 642.13c-.31 54.74 18.76 100.8 37.15 135.82-2.18 16.34-4.81 33.21-7.95 50.39-3.97 1.56-15.17 4.54-30.58-2.84V642.98c.5-.23.97-.52 1.38-.85z"
        id="path8463"
      />
      <path
        d="M453.95 829.55c-1.78-.37-3.16-.83-4.12-1.21-2.65-14.44-4.92-28.68-6.88-42.55-9.93-70.5-11.58-131.91-11.53-166.01l1.16-1.06c.63 13.13 6.52 130.6 21.37 210.83z"
        id="path8465"
        style={{
          opacity: 0.65,
          fill: "#fff",
        }}
      />
      <g id="g8471">
        <g id="g8469">
          <path
            className="st10"
            d="M433.16 484.37c.83 7.55 1.94 15.1 3.61 22.51.88 3.93 1.85 7.85 3.04 11.71.56 1.84 1.14 3.69 1.88 5.46.73 1.75 1.49 3.44 2.25 5.16.12.26.49.07.44-.19-.74-3.69-1.39-7.4-2.23-11.09-.87-3.86-1.76-7.71-2.52-11.6-1.43-7.28-2.67-14.59-3.49-21.97-.2-1.88-3.19-1.9-2.98.01z"
            id="path8467"
          />
        </g>
      </g>
      <path
        className="st0"
        d="M430.97 317.73c-.45 2.5-.87 5.04-1.26 7.64a15.49 15.49 0 0 1 3.68-2.41c-1-1.82-1.79-3.59-2.42-5.23z"
        id="path8473"
      />
      <path
        className="st0"
        d="M484.78 331.98c.26.2.51.42.74.65l10.53 1c.27-.19.55-.35.85-.5 19.6-9.64 37.56-5.77 49.18-.83 3.28 1.4 5.83 3.8 7.42 6.72.02-6.4-.17-12.53-.58-18.36-4.48-2.41-21.11-12.31-29.33-30.97-19.38 27.89-51.89 29.55-70.67 27.76-3.45-.33-6.43-.78-8.79-1.19-.26 1.28-.34 2.78-.26 4.47 11.71-1.22 26.63.46 40.91 11.25z"
        id="path8475"
      />
      <path
        className="st0"
        d="M483.08 339.02c-.31 2.84-1 7.16-2.61 11.41-.41 1.05-.87 2.1-1.38 3.12-1.47 2.89-3.71 5.4-6.51 7.27-1.05.72-2.21 1.35-3.41 1.87-2.34 1-4.79 1.55-7.28 1.62-2.74.09-6.92.09-11.21-.38-7.95-.89-14.69-5.67-18.04-12.79-1.98-4.25-3.25-8.68-3.74-13.17-.11-.92-.1-1.83.03-2.71.49-3.63 2.77-6.77 6.05-8.37.63-.31 1.3-.57 2.01-.75.02-.01.05-.02.08-.02.14-.03.29-.07.43-.11 1.46-.31 3-.59 4.62-.82.09-.01.17-.03.24-.04.48-.07.98-.12 1.47-.18 3.61-.39 7.54-.5 11.68-.11 8.43.81 17.7 3.7 26.69 10.49.43.33.73.76.88 1.27.09.3.13.62.1.94 0 .43-.04.91-.1 1.46z"
        id="path8477"
      />
      <path
        className="st0"
        d="M551 344.74c-.52-3.7-2.94-7-6.59-8.55-.31-.13-.63-.26-.96-.4-2.2-.9-4.64-1.75-7.26-2.44a55.95 55.95 0 0 0-9.24-1.69c-8.44-.81-18.09.28-28.19 5.26-.48.23-.86.61-1.11 1.07-.15.28-.24.58-.27.9-.3 2.62-.68 7.83.26 13.16h.01c.18 1.1.44 2.23.75 3.31.9 3.12 2.63 6.01 5.01 8.37.91.91 1.92 1.75 3.01 2.49 2.1 1.42 4.4 2.41 6.83 2.96 2.69.6 6.78 1.4 11.08 1.74 7.98.63 15.5-2.79 20.14-9.16 2.75-3.79 4.83-7.9 6.16-12.21.49-1.6.6-3.25.37-4.81zm-14.98-10.42c-.13-.07-.27-.12-.42-.16.19-.24.38-.5.57-.77.01 0-.03.36-.15.93zm7.15 2.23c-.01-.01-.02-.01-.04-.03.02-.02.04-.05.06-.08 0 0 0 .03-.02.11z"
        id="path8479"
      />
      <path
        className="st0"
        d="M551.48 374.24c-.12 1.22-.25 2.45-.39 3.67-.15 1.36-.32 2.73-.47 4.11-.02.16-.05.32-.06.48-.14 1.22-.31 2.44-.47 3.68-.36 2.79-.74 5.62-1.17 8.49a61.442 61.442 0 0 1-5.62 5.68 61.504 61.504 0 0 1-8 6.02c-.33.21-.65.42-.99.62a70.797 70.797 0 0 1-9.79 4.98c-10.96 4.5-23.11 6.37-35.15 5.42-2.55-.2-5.12-.53-7.63-.95-.02-.01-.04-.02-.06-.02-.05-.02-.11-.02-.16-.03-.14-.01-.28-.04-.42-.07-.51-.1-1.01-.18-1.52-.28-.61-.12-1.2-.24-1.8-.37-.4-.09-.81-.17-1.22-.27-4.39-1-8.81-2.33-13.19-4-1.07-.4-2.13-.83-3.19-1.25-.84-.34-1.67-.7-2.5-1.07-1.13-.49-2.24-1.01-3.37-1.55-1.29-.62-2.6-1.28-3.88-1.95-1.36-.71-2.65-1.41-3.87-2.14-.37-.2-.75-.43-1.09-.63-.62-.38-1.22-.75-1.82-1.13-.52-.34-1.01-.66-1.52-.99-.05-.03-.1-.07-.15-.1a66.15 66.15 0 0 1-2.68-1.91c-.44-.34-.87-.67-1.3-1.02-.01 0-.01 0-.02-.01-.3-.23-.59-.48-.88-.7-.59-.49-1.15-.97-1.7-1.46-.26-.24-.51-.48-.77-.72-.33-.3-.64-.61-.93-.9-.21-.21-.41-.41-.61-.62-.5-.52-.98-1.04-1.44-1.57-1.98-2.26-3.59-4.67-4.8-7.15-.21-5.65-.28-11.27-.23-16.85v-.01c0-.12-.01-.25 0-.37.01-1.12.03-2.22.06-3.33.01-.91.03-1.82.06-2.73.01-1.13.06-2.25.1-3.37.11-2.92.24-5.8.42-8.66.46 1.25.98 2.49 1.55 3.72.43.92.91 1.81 1.45 2.67.17.27.34.54.52.8.19.29.37.57.59.86.18.26.36.5.56.75.41.53.85 1.05 1.31 1.55.57.63 1.16 1.22 1.78 1.77.27.25.53.48.81.72.32.26.63.51.95.76.3.23.61.45.93.66.6.43 1.24.83 1.9 1.2.24.15.49.29.74.4.24.15.51.27.76.4.45.23.91.44 1.37.64.34.15.69.28 1.05.42.24.1.48.18.73.26.39.14.77.26 1.16.37.37.1.74.21 1.11.29l.21.06c.33.09.66.16.98.23.26.06.52.1.78.14.26.06.55.1.83.13.29.05.58.09.88.12l.99.1c4.19.41 8.16.39 10.82.31.91-.03 1.82-.11 2.73-.25.29-.03.57-.07.86-.14.39-.07.79-.15 1.16-.24.34-.07.69-.16 1.03-.26.3-.08.59-.17.88-.26.35-.11.71-.24 1.07-.37.36-.15.72-.28 1.08-.43 1.46-.64 2.84-1.39 4.11-2.26 3.38-2.26 6.11-5.33 7.9-8.86.59-1.15 1.11-2.34 1.56-3.53 1.54-4.06 2.33-8.15 2.71-11.19 2.33-.21 4.23.17 5.79.82-.18 3.03-.18 7.1.56 11.24.2 1.26.51 2.53.85 3.76 1.1 3.81 3.21 7.34 6.08 10.2 1.11 1.1 2.31 2.09 3.63 2.99.9.61 1.83 1.15 2.79 1.63.18.07.34.16.52.24.18.08.35.17.54.24.25.11.5.23.75.32.3.12.58.23.88.33.03 0 .06.02.1.02.3.11.61.22.92.3h.01c.31.11.64.21.97.28.26.08.54.16.81.21 2.62.58 6.5 1.35 10.7 1.75l.98.09c.45.04.9.06 1.36.07.04.02.08.01.12.01.47.01.92.01 1.39 0 .93-.02 1.88-.09 2.79-.21.44-.05.87-.11 1.3-.19.08-.01.17-.04.24-.05.4-.08.81-.15 1.19-.25.35-.07.71-.17 1.06-.27.22-.05.45-.11.67-.19.62-.18 1.25-.4 1.86-.65.22-.07.45-.17.67-.26.39-.15.75-.32 1.12-.51.26-.1.5-.23.74-.35.15-.08.3-.15.44-.23.3-.14.59-.31.87-.49.21-.11.4-.22.59-.34.33-.2.64-.41.96-.62.32-.22.63-.44.93-.67.31-.23.59-.45.88-.69.07-.05.14-.1.2-.16.36-.3.69-.6 1.04-.91.52-.48.99-.96 1.46-1.47.27-.27.53-.56.75-.86.17-.19.35-.39.51-.59.25-.32.52-.67.76-1.01 2.07-2.84 3.79-5.82 5.13-8.95-.27 5-.67 10.17-1.17 15.46-.14 1.13-.25 2.29-.37 3.45z"
        id="path8481"
      />
      <path
        className="st0"
        d="M414.46 352.11c-1.92-1.66-3.42-3.78-3.38-6.38.04-2.09.65-4.01 1.84-5.73.42 3.43.93 7.57 1.54 12.11z"
        id="path8483"
      />
      <path
        className="st0"
        d="M584.61 354.34c-.29 4.86-2.25 9.31-5.37 12.21-2.84 2.65-6.64 3.85-10.57 3.48-1.28-.12-2.57-.41-3.84-.88.85-6.42 1.46-12.93 1.81-19.47.32-.01.64-.09.94-.26.5-.28.84-.73.99-1.23.16-.2.51-.61 1.28-1.39l.14-.15c1.46-1.53 2.97-2.57 4.49-3.08 3.72-1.27 6.15.54 7.53 2.29.01.02.03.04.04.06 1.75 2.22 2.73 5.44 2.56 8.42z"
        id="path8485"
      />
      <path
        className="st10"
        d="M625.32 427.07a2.12 2.12 0 0 0 .45-2.96c-.6-.82-1.69-1.08-2.59-.66 4.96-2.85 8.48-6.91 9.84-11.47 2.27-7.63-2.33-13.22-7.56-15.2-4.19-1.59-10.05-1.22-13.52 4.6a35.95 35.95 0 0 1-3.22-2.83c4.55-6.97 12.19-8.01 18.24-5.72 7.23 2.73 13.02 10.6 10.11 20.36-1.68 5.64-5.92 10.58-11.89 13.98.05-.03.1-.07.14-.1z"
        id="path8487"
      />
      <path
        className="st10"
        d="M625.78 424.11c.69.94.49 2.27-.45 2.96-.05.03-.09.07-.14.1a34.9 34.9 0 0 1-3.73 1.83c-4.27 1.77-8.93 2.78-13.87 2.98-.34.02-.68.03-1.02.02 5.45-1.61 10.87-4.39 16.25-8.35.01-.01.02-.01.02-.02.01-.01.02-.01.04-.02.1-.05.19-.1.28-.16.01-.01.02-.01.03-.01.89-.41 1.99-.15 2.59.67z"
        id="path8489"
      />
      <path
        className="st10"
        d="M623.16 423.46c-.09.06-.18.11-.28.16.09-.06.18-.12.28-.16z"
        id="path8491"
      />
      <path
        className="st10"
        d="M621.58 407.28c1.05.51 1.48 1.78.97 2.82a2.112 2.112 0 0 1-2.82.98c-4.38-2.14-8.14-4.5-11.26-7.11.99.38 2.13-.02 2.64-.99.03-.05.05-.11.08-.16 0-.01.01-.01.01-.02.23-.5.48-.97.74-1.42 2.69 2.12 5.9 4.07 9.64 5.9z"
        id="path8493"
      />
      <path
        className="st10"
        d="M607.59 431.98c4.93-.2 9.6-1.21 13.87-2.98 1.3-.55 2.55-1.16 3.73-1.83-11.05 8.08-22.4 11.62-33.78 10.54-.99-.09-1.97-.22-2.96-.39-17.25-2.85-29.66-15.48-34.69-21.47.09-.25.17-.49.26-.73 0-.03.01-.05.02-.08.45-1.31.89-2.63 1.33-3.96 1.25 1.62 4.34 5.4 8.93 9.42 6.01 5.28 14.58 10.96 24.87 12.65 5.8.96 11.61.57 17.41-1.15.33.01.67 0 1.01-.02z"
        id="path8495"
      />
      <path
        className="st10"
        d="M607.42 427.76c4.43-.19 8.6-1.08 12.41-2.67 1.05-.44 2.06-.92 3.01-1.45-.01.01-.02.01-.02.02-5.37 3.95-10.8 6.73-16.25 8.35-1.74.04-3.5-.03-5.27-.2-4.5-.43-9.03-1.49-13.38-3.15-10.44-3.97-23.89-12.26-30.73-23.51.51-1.74 1.01-3.5 1.48-5.26.06-.23.12-.47.19-.7 4.85 11.44 18.75 21.04 30.56 25.52 5.88 2.23 12.1 3.29 18 3.05z"
        id="path8497"
      />
      <path
        className="st10"
        d="M611.94 401.38c-.26.44-.51.91-.74 1.42 0 .01-.01.01-.01.02-.03.05-.05.11-.08.16-.51.97-1.65 1.38-2.64.99-.36-.3-.71-.6-1.05-.91-.35-.59-.4-1.33-.08-1.99.01-.03.03-.05.04-.08.41-.89.86-1.7 1.35-2.45.97.98 2.05 1.93 3.21 2.84z"
        id="path8499"
      />
      <path
        className="st10"
        d="M608.47 403.97c-.07-.03-.14-.06-.21-.1-.37-.19-.65-.48-.84-.81.33.31.69.61 1.05.91z"
        id="path8501"
      />
      <path
        className="st10"
        d="M584.52 269.7c11.76 21.97 12.3 47.73 1.54 74.56-.23-.35-.47-.69-.73-1.02-.75-.95-1.58-1.74-2.47-2.38 9.52-24.97 8.81-48.83-2.07-69.17-12.45-23.25-38.1-40.78-68.62-46.89-2.49-.5-5.17-.88-7.97-1.13 1.06-.1 1.91-.99 1.92-2.08.01-.67.03-1.33.1-1.97 2.37.25 4.64.6 6.79 1.04 31.74 6.35 58.48 24.69 71.51 49.04z"
        id="path8503"
      />
      <path
        className="st10"
        d="M586.07 344.25c-.14.37-.29.73-.44 1.1-.36.89-1.25 1.39-2.16 1.3a2.2 2.2 0 0 1-.6-.15c-.33-.13-.6-.34-.81-.59-.01-.02-.03-.04-.04-.06-.45-.58-.59-1.38-.29-2.11.4-.97.78-1.93 1.15-2.89.89.64 1.72 1.43 2.47 2.38.24.34.49.67.72 1.02z"
        id="path8505"
      />
      <path
        className="st10"
        d="M566.64 349.69c.07-1.27.13-2.54.17-3.81l.79-.09-.3-2.43c1.83-1.82 3.78-3.1 5.82-3.79 3.53-1.19 6.95-.71 9.74 1.3-.37.96-.75 1.92-1.15 2.89-.3.73-.16 1.53.29 2.11-1.38-1.75-3.81-3.55-7.53-2.29-1.52.51-3.04 1.55-4.49 3.08l-.14.15c-.77.78-1.12 1.19-1.28 1.39-.15.5-.49.95-.99 1.23-.29.16-.61.24-.93.26z"
        id="path8507"
      />
      <path
        className="st10"
        d="m567.6 345.79-.79.09c.02-.39.03-.78.05-1.17l.03-.92.04-.05c.13-.13.25-.26.38-.39z"
        id="path8509"
      />
      <path
        className="st10"
        d="M564.83 369.15c-.39 2.9-.83 5.78-1.31 8.64 0 .01-.01.03-.01.04-.02.09-.03.17-.05.26-.03.05-.05.12-.07.17-.34.84-1.21 1.4-2.16 1.31a2.097 2.097 0 0 1-1.9-2.3v-.01c0-.05.01-.11.03-.15.02-.17.07-.33.14-.49 1.31-3.02 1.68-4.38 1.79-4.92a2.112 2.112 0 0 1 2.72-2.88c.26.12.54.23.82.33z"
        id="path8511"
      />
      <path
        className="st10"
        d="M566.81 345.88c-.04 1.27-.1 2.54-.17 3.81-.74.04-1.48-.33-1.89-1.01l-1.45-2.37z"
        id="path8513"
      />
      <path
        className="st10"
        d="m566.93 343.74-.04.05c.04-1.07.06-2.14.08-3.19l.33 2.76c-.12.12-.25.25-.37.38z"
        id="path8515"
      />
      <path
        className="st10"
        d="m566.77 343.89.06-.06.05-.05-.03.92c-.02.39-.03.78-.05 1.17l-3.52.43-.35-.57c-.22-.37-.32-.77-.31-1.18 0-.04 0-.08.01-.13.06-.64.41-1.24 1-1.6.99-.61 2.29-.3 2.91.7z"
        id="path8517"
      />
      <path
        className="st10"
        d="M563.51 377.79c.48-2.86.92-5.74 1.31-8.64 1.28.47 2.57.75 3.84.88 3.93.37 7.72-.83 10.57-3.48 3.13-2.91 5.09-7.36 5.37-12.21.17-2.98-.81-6.2-2.55-8.42.22.25.49.46.81.59.2.08.4.13.6.15.9.09 1.79-.42 2.16-1.3.15-.37.3-.73.44-1.1 1.94 2.93 2.96 6.7 2.77 10.32-.35 5.94-2.8 11.42-6.72 15.06-4.52 4.22-10.83 5.66-16.99 4.04-.32 1.09-.86 2.52-1.67 4.42.02-.09.03-.17.05-.26.01-.02.01-.04.01-.05z"
        id="path8519"
      />
      <path
        className="st10"
        d="M566.97 340.59c-.02 1.05-.05 2.12-.08 3.19l-.05.05-.06.06-.22-.36c-.61-1-1.91-1.31-2.91-.7-.59.36-.94.96-1 1.6.04-1.26.08-2.51.1-3.73l4.18-.52z"
        id="path8521"
      />
      <path
        className="st10"
        d="M558.87 399.19c-.06.23-.12.47-.19.7-.47 1.76-.97 3.52-1.48 5.26a32.38 32.38 0 0 1-2.52-5.03 2.03 2.03 0 0 1-.09-1.26c.15-.65.61-1.22 1.28-1.48 1.09-.43 2.31.1 2.74 1.19.07.2.16.41.26.62z"
        id="path8523"
      />
      <path
        className="st10"
        d="m562.95 345.74.35.57-.72.09c.02-.61.05-1.23.07-1.84-.03.4.08.81.3 1.18z"
        id="path8525"
      />
      <g id="g8535">
        <path
          className="st15"
          d="M587.93 428.66c-10.44-3.97-23.89-12.26-30.73-23.51-.59 2-1.2 3.98-1.84 5.93 1.25 1.62 4.34 5.4 8.93 9.42 6.01 5.28 14.58 10.96 24.87 12.65 5.8.96 11.61.57 17.41-1.15-1.74.04-3.5-.03-5.27-.2-4.49-.42-9.02-1.48-13.37-3.14z"
          id="path8527"
        />
        <path
          className="st15"
          d="M510.92 200.6c-4.91 4.86-8.29 11.09-8.92 18.66-5.48-.35-10.61-.18-14.88.15-3.82.29-6.95.72-9 1.06.37-3.68 1.82-10.67 7.45-15.42 3.51-2.96 8.12-4.65 13.78-5.08 3.48-.27 7.33-.06 11.57.63z"
          id="path8529"
        />
        <path
          className="st15"
          d="M582.87 340.86c-.34-.24-.68-.46-1.03-.65-2.59-1.45-5.61-1.7-8.71-.65-2.04.69-3.99 1.97-5.82 3.79l-.33-2.76c0-.18.01-.36.01-.54-.02.04-.05.07-.06.09 0-.42-.01-.84-.01-1.25-.03-2.47-.12-4.88-.25-7.23-.52-9.14-1.71-17.35-3.07-24.22-2.58-13.03-5.77-21.31-6.09-22.12.26 1.03 3.4 13.69 4.72 33.19.42 6.26.66 13.23.55 20.74 0 .47-.01.96-.02 1.44-.02 1.23-.06 2.48-.1 3.73v.13c-.02.61-.05 1.23-.07 1.84-.43 10.36-1.52 20.68-3.23 30.71 0 .01 0 .03-.01.04-.75 4.47-1.64 8.92-2.66 13.32.01.01 0 .01 0 .01-.54 2.37-1.12 4.73-1.74 7.05-.11.42-.22.84-.33 1.25-.01.02-.01.04-.01.06-1.09 4.04-2.29 8.05-3.59 11.97-.01.01-.01.03-.02.04v.01c-.31.95-.63 1.88-.95 2.81.2-1.09.4-2.19.6-3.3l.09-.5c.82-4.68 1.59-9.39 2.28-14 0-.04.01-.08.02-.11 2.6-17.49 4.13-33.8 4.57-48.77 0-.08.01-.16.01-.25.05-1.83.09-3.65.11-5.45.02-1.74.02-3.45.01-5.15-.03-5.89-.25-11.55-.66-16.95v-.06c-.12-1.58-.25-3.13-.41-4.66-3.36-17.5-10.09-29.68-10.36-30.15 3.01 8.86 5.09 19.33 6.21 31.17-6.45-3.97-20.47-14.19-26.45-31.04 0-.02-.01-.04-.02-.05-1.99-5.65-2.93-11.62-2.81-17.78-4.18 6.99-1.75 17.25-1.52 18.15v.01c.01.02.01.04.02.05v.01c-3.55 5.63-7.65 10.21-12.1 13.92l-.01.01c-5.82 4.87-12.22 8.25-18.72 10.54-16.9 5.97-34.45 4.62-44.09 3.09 7.96-4.33 14.67-11.34 16.56-13.42h.01c14.54-2.97 19.45-12.9 19.65-13.31-4.96 5.6-12.97 8.16-20.7 9.23-.2 0-.4.02-.6.08-.57.07-1.15.14-1.72.2 0 0 .01-.01.02-.01s.01-.01.02-.01c16.9-9.53 25.37-25.12 25.82-25.98 0-.01.01-.01.01-.01h-.01v.01c-.01.01-.02.01-.02.03-.02.03-.04.05-.07.09-.2.26-.64.85-1.32 1.67l-.09.12c-4.95 6-21.44 23.76-43.26 23.9v.01c-.13-.01-.26.01-.41.04-.05.01-.11.03-.16.03a2.1 2.1 0 0 0-1.51 2.33c.13.98.93 1.72 1.89 1.81l.11.01c.42.05.98.11 1.65.18 2.95.28 8.14.61 14.09.27-4.11 3.92-10.89 9.53-17.75 11.44-.92.25-1.55 1.09-1.55 2.05 0 .95.64 1.78 1.56 2.03.03.01.35.09.93.23-.33 1.72-.44 3.69-.3 5.87-.73.12-1.44.25-2.13.4a37.473 37.473 0 0 1-3.78-9.02c-.58-2.14-.8-3.72-.87-4.34 2.26-9.92 5.13-18.9 8.58-26.85 2.15-4.98 4.53-9.56 7.13-13.72.01-.02.03-.05.03-.07h.01c.01-.01.01-.02.01-.02l-.02.02c-.78 1.03-9.65 12.9-16.97 30.56a53.39 53.39 0 0 0-2.76 8.56c-.07.3-.14.61-.22.92 0 .03-.01.05-.01.08-1.93 8.5-3.43 17.69-4.47 27.42-.45 4.16-.82 8.43-1.1 12.79-.62 9.45-.84 19.18-.68 29.04-.37-2.23-.73-4.47-1.08-6.69-.77-4.96-1.47-9.82-2.07-14.2-1.17-8.53-2.09-16.12-2.67-21.01l-.03-.23c-.7-5.92-1.09-9.71-1.1-9.74 0-.04-.01-.07-.01-.11-.37-2.41-.7-4.77-.96-7.03 0-.01 0-.04-.01-.06 0-.06-.02-.12-.03-.19 0-.04-.01-.08-.02-.12-.02-.08-.05-.15-.08-.23-.03-.08-.07-.16-.11-.23-.04-.07-.08-.15-.14-.22-.1-.14-.22-.27-.36-.39l-.02-.02c-.08-.06-.16-.12-.25-.17a.076.076 0 0 0-.04-.02c-.07-.04-.15-.09-.23-.11-.03-.02-.06-.03-.09-.04-.08-.03-.15-.05-.23-.07h-.01c-.1-.02-.19-.04-.29-.05-.07-.01-.15-.01-.23-.01-.07 0-.15 0-.23.01-.06 0-.12.02-.19.03-.06.01-.12.02-.18.05-.06.02-.12.03-.17.05-.08.03-.16.07-.23.11-.07.04-.15.08-.22.13-.06.04-.11.09-.17.13-.04.04-.08.07-.12.12-.04.03-.07.07-.1.11l-.02.02c-2.01 2.38-4.15 4.07-6.08 5.25 2.94-4.94 5.82-11.63 8.6-19.99.02-.05.03-.1.04-.15.03-.1.05-.21.06-.31v-.01c.01-.08.01-.15.01-.23-.21-20.62 4.73-36.61 14.3-46.22 6.3-6.34 12.74-8 14.22-8.31.2-.04.31-.06.32-.06.67-.1 1.25-.5 1.57-1.1 7.8-14.63 30.81-20.29 32.45-20.68.03 0 .05-.01.08-.01 0 0 .01 0 .01-.01.13-.02 1.05-.21 2.58-.45h.03c.44-.07.93-.15 1.46-.22 4.89-.7 13.6-1.58 23.02-.81.17.04.35.07.53.07.07 0 .13 0 .21-.01.01-.01.01 0 .01 0 2.8.25 5.48.63 7.97 1.13 30.52 6.11 56.17 23.64 68.62 46.89 10.94 20.39 11.65 44.25 2.13 69.22z"
          id="path8531"
        />
        <path
          className="st15"
          d="M633.03 411.98c-.73 2.45-2.08 4.74-3.94 6.79 0 .01 0 .01-.01.01-1.6 1.77-3.59 3.35-5.89 4.68-.01 0-.01.01-.03.01-.1.04-.19.1-.28.16l-.04.02c-.95.53-1.96 1.02-3 1.45-3.81 1.58-7.99 2.48-12.41 2.67-5.9.24-12.12-.82-17.99-3.05-11.81-4.49-25.71-14.09-30.56-25.52 1.83-6.87 3.38-13.97 4.59-21.09.13-.29.25-.58.36-.85.62-1.48 1.04-2.65 1.32-3.57 6.16 1.63 12.47.18 16.99-4.04.42-.39.82-.8 1.21-1.24 3.21-3.59 5.19-8.52 5.51-13.83.16-3.02-.52-6.15-1.89-8.81-.27-.52-.56-1.03-.88-1.51 3.82-9.52 6.2-18.91 7.18-28.04v-.01c1.77-16.6-1.14-32.34-8.72-46.51-3.67-6.86-8.43-13.25-14.09-19.02-1.1-1.12-2.24-2.22-3.4-3.3-.63-.58-1.28-1.16-1.93-1.73-.74-.64-1.49-1.28-2.25-1.91-.13-.1-.26-.21-.39-.31-.96-.78-1.94-1.55-2.94-2.3-.27-.21-.54-.41-.82-.62-.83-.6-1.66-1.21-2.51-1.79-2-1.39-4.07-2.72-6.19-3.98-1.36-.81-2.74-1.59-4.15-2.35-5.69-3.06-11.75-5.68-18.09-7.8-1-.34-2.01-.66-3.03-.98-1.63-.49-3.27-.96-4.93-1.38-.9-.24-1.8-.46-2.71-.68-1.36-.32-2.72-.62-4.09-.89-2.15-.44-4.43-.78-6.79-1.04.35-4.13 1.66-7.8 3.67-11.01 0-.01.01-.01.01-.01 1.79-2.86 4.13-5.37 6.84-7.49 6.05-4.75 13.91-7.63 21.46-8.58 36.55-4.58 75.09 12.87 91.64 41.5 8.72 15.09 11.39 33.51 7.52 51.85-3.37 15.96-11.69 30.32-19.73 44.22-4.2 7.26-8.56 14.78-12.18 22.48l-.11.22c-4.65 9.85-11.01 23.34-7.85 34.73 1.65 5.93 4.93 11.08 9.94 15.53.19.33.47.62.84.81.07.03.14.07.21.1 2.86 2.4 6.25 4.57 10.17 6.57l.06.03c.34.17.68.35 1.03.52.24.11.48.18.72.2.86.08 1.7-.36 2.1-1.18.51-1.05.08-2.31-.97-2.82-3.75-1.83-6.95-3.78-9.64-5.9 3.47-5.82 9.33-6.19 13.52-4.6 5.21 1.97 9.81 7.56 7.54 15.19z"
          id="path8533"
        />
      </g>
      <path
        className="st10"
        d="M561.22 369.95c-.25.59-.21 1.23.05 1.76-.1.54-.47 1.89-1.79 4.92-.07.16-.12.32-.14.49h-.01c1.71-10.04 2.8-20.36 3.23-30.71l.72-.09 1.45 2.37c.42.68 1.15 1.04 1.89 1.01-.35 6.53-.96 13.04-1.81 19.47-.28-.1-.56-.21-.84-.33-1.06-.47-2.29.03-2.75 1.11z"
        id="path8537"
      />
      <path
        className="st10"
        d="M554.03 415.04c-.01.03-.02.05-.02.08-.09.25-.17.49-.26.73-1.49-1.78-2.34-2.98-2.47-3.17-.39-.56-.48-1.24-.28-1.85.13-.43.41-.82.81-1.1.96-.67 2.28-.43 2.94.53.02.02.22.32.62.82-.44 1.33-.89 2.65-1.34 3.96z"
        id="path8539"
      />
      <path
        className="st10"
        d="M554.6 398.79c1.9-7.04 3.5-14.32 4.73-21.64.01-.01.01-.03.01-.04h.01c-.02.05-.02.1-.03.15v.01a2.11 2.11 0 0 0 1.9 2.3c.95.09 1.82-.46 2.16-1.31.03-.05.05-.12.07-.17-1.21 7.12-2.76 14.22-4.59 21.09-.1-.21-.19-.41-.27-.62a2.106 2.106 0 0 0-2.74-1.19c-.67.26-1.13.83-1.28 1.48.02-.01.02-.04.03-.06z"
        id="path8541"
      />
      <path
        className="st10"
        d="M562.75 340.7c.63-31.68-4.89-53.99-5.25-55.37.54 1.37 9.23 23.94 9.43 54.82.01-.02.03-.05.06-.09 0 .18-.01.35-.01.54l-.05-.41z"
        id="path8543"
      />
      <path
        className="st10"
        d="M553.01 395.77c-.04.42-.21.83-.49 1.17a66.1 66.1 0 0 1-4.75 5.03c.23-1.43.46-2.85.68-4.27l.36-2.44c.03-.2.06-.41.09-.6.15-.16.27-.31.39-.46.08-.09.17-.18.26-.26.11-.09.22-.16.35-.23.06-.04.13-.06.19-.09.02-.02.05-.03.08-.04.06-.03.11-.04.18-.06.11-.03.23-.05.35-.06.01 0 .02-.01.04-.01.05-.01.11-.01.17-.01.48 0 .96.17 1.35.5.56.48.81 1.17.75 1.83z"
        id="path8545"
      />
      <path
        className="st10"
        d="m557.59 347.01-2.28.28c.13-1.92-.11-3.82-.68-5.6l3.07-.37c-.01 1.87-.05 3.77-.11 5.69z"
        id="path8547"
      />
      <path
        className="st10"
        d="M551.8 409.73c-.39.27-.67.66-.81 1.1 1.3-3.92 2.5-7.94 3.59-11.97-.1.41-.07.84.09 1.26a31.52 31.52 0 0 0 2.52 5.03c-.59 2-1.2 3.98-1.84 5.93-.39-.5-.6-.8-.62-.82-.65-.96-1.97-1.19-2.93-.53z"
        id="path8549"
      />
      <path
        className="st10"
        d="M552.27 393.97c-.89-.76-2.22-.64-2.97.25-.13.15-.26.3-.4.45 2.06-13.92 3.43-27.06 4.1-39.36.63-1.47 1.18-2.97 1.65-4.49.36-1.17.58-2.35.65-3.53l2.28-.28c-.44 14.97-1.97 31.28-4.57 48.77H553c.07-.67-.18-1.35-.73-1.81z"
        id="path8551"
      />
      <path
        className="st10"
        d="m555.31 347.29-1.84.22-.1-.82c.04-1.64.08-3.26.1-4.86l1.17-.14c.56 1.78.8 3.68.67 5.6z"
        id="path8553"
      />
      <path
        className="st10"
        d="M553.49 339.02c.02-6.4-.17-12.53-.58-18.36.62.33 1.01.51 1.11.57.24.11.48.17.72.2.86.08 1.71-.37 2.1-1.19.16-.32.23-.67.21-1.01.53 6.96.73 14.35.65 22.1l-3.07.37c-.29-.94-.67-1.83-1.14-2.68z"
        id="path8555"
      />
      <path
        className="st10"
        d="M557.06 319.22c.02.34-.05.69-.21 1.01a2.112 2.112 0 0 1-2.82.99c-.11-.05-.49-.24-1.11-.57-.02-.4-.05-.79-.08-1.18-.1-1.33-.21-2.65-.34-3.96 2.03 1.24 3.31 1.87 3.36 1.9.71.34 1.14 1.01 1.19 1.75 0 .02.01.04.01.06z"
        id="path8557"
      />
      <path
        className="st10"
        d="m554.63 341.69-1.17.14c.02-.95.02-1.88.03-2.81.47.85.85 1.74 1.14 2.67z"
        id="path8559"
      />
      <path
        className="st10"
        d="M556.65 314.5c.15 1.53.29 3.08.41 4.66-.05-.73-.48-1.41-1.19-1.75-.05-.03-1.34-.66-3.36-1.9-1.12-11.84-3.2-22.3-6.21-31.17.26.48 6.99 12.66 10.35 30.16z"
        id="path8561"
      />
      <path
        className="st10"
        d="M545.23 436.57c.83-3.39 1.78-7.71 2.7-12.17.01-.01.01-.03.01-.05.71-3.41 1.41-6.99 2.08-10.66.33-.95.65-1.9.97-2.86-.19.6-.11 1.28.28 1.85.14.2.98 1.39 2.47 3.17-1.32 3.77-2.74 7.5-4.21 11.07-1.38 3.37-2.88 6.77-4.46 10.13l-.01.01c.05-.12.1-.24.13-.37z"
        id="path8563"
      />
      <path
        className="st10"
        d="M553 355.31c.17-2.92.28-5.79.37-8.61l.1.82 1.84-.22c-.08 1.17-.3 2.36-.65 3.53a50.39 50.39 0 0 1-1.66 4.48z"
        id="path8565"
      />
      <path
        className="st10"
        d="m553.37 346.69-.27-2.21-.31-2.56.68-.08c-.02 1.6-.06 3.22-.1 4.85z"
        id="path8567"
      />
      <path
        className="st10"
        d="M544.62 437.72a2.138 2.138 0 0 1-1.97.53 2.117 2.117 0 0 1-1.56-2.55c0-.01 0-.04.01-.06.02-.1.06-.19.1-.28.01-.03.02-.05.04-.07a216.71 216.71 0 0 0 8.76-21.5c.01-.03.02-.05.03-.08 0-.01.01-.02.01-.03-.68 3.67-1.38 7.25-2.08 10.66 0 .02 0 .04-.01.05-.92 4.46-1.88 8.78-2.7 12.17l-.03.12c-.03.13-.07.25-.13.37 0 .02-.01.04-.03.05-.04.08-.08.16-.12.23-.05.07-.09.13-.15.2-.06.08-.11.14-.17.19z"
        id="path8569"
      />
      <path
        className="st10"
        d="M541.12 435.57c.81-3.33 1.76-7.58 2.66-11.98 0-.02.01-.03.01-.06.94-4.55 1.87-9.39 2.76-14.38.42-2.39.83-4.8 1.22-7.19 1.68-1.6 3.27-3.28 4.75-5.03.29-.34.45-.75.49-1.16h.01c0 .04-.01.08-.02.11-.69 4.61-1.46 9.32-2.28 14-.23 1.27-.45 2.54-.69 3.8 0 .01-.01.02-.01.03-.01.03-.02.05-.03.08-1.37 3.93-2.83 7.8-4.36 11.52a216.71 216.71 0 0 1-4.4 9.98c-.02.03-.03.05-.04.07-.04.09-.07.18-.1.28z"
        id="path8571"
      />
      <path
        className="st10"
        d="M525.85 286.22c.34-.55.39-1.19.2-1.75 5.97 16.85 20 27.07 26.45 31.04.13 1.31.24 2.63.34 3.96.03.39.06.78.08 1.18-4.48-2.41-21.11-12.31-29.33-30.97.77-1.11 1.53-2.26 2.26-3.46z"
        id="path8573"
      />
      <path
        className="st10"
        d="M526.05 284.47c.19.56.13 1.2-.2 1.75a62.52 62.52 0 0 1-2.26 3.46c-.55-1.25-1.07-2.54-1.54-3.86-.11-.32-.22-.64-.33-.97v-.01c.17-.27.35-.55.52-.83.61-1 1.91-1.31 2.91-.71.44.26.74.66.89 1.1 0 .03.01.05.01.07z"
        id="path8575"
      />
      <path
        className="st10"
        d="M521.7 284.79c-.23-.9-2.66-11.16 1.52-18.15-.13 6.15.82 12.13 2.81 17.78-.16-.45-.46-.84-.89-1.1-1-.6-2.29-.29-2.91.71-.17.28-.34.55-.52.83 0-.02 0-.04-.01-.07z"
        id="path8577"
      />
      <path
        className="st10"
        d="M516.9 199.62c.24-1.14-.49-2.26-1.63-2.51-.07-.01-.15-.03-.22-.04 6.54-4.82 14.72-7.76 22.6-8.75 17.84-2.23 37.13.62 54.29 8.05 18.32 7.92 32.68 20.21 41.54 35.54 9.25 16 12.08 35.48 7.99 54.84-3.51 16.62-12 31.28-20.21 45.46-4.17 7.19-8.47 14.62-12.03 22.16l-.11.22c-4.36 9.25-10.33 21.92-7.6 31.8 1.27 4.58 3.62 8.58 7.17 12.14-.49.75-.94 1.56-1.35 2.45-.01.03-.03.05-.04.08-.32.66-.27 1.4.08 1.99-5-4.45-8.29-9.6-9.94-15.53-3.16-11.39 3.2-24.88 7.85-34.73l.11-.22c3.63-7.7 7.98-15.21 12.18-22.48 8.05-13.9 16.37-28.26 19.73-44.22 3.87-18.34 1.2-36.76-7.52-51.85-16.55-28.63-55.09-46.09-91.64-41.5-7.56.95-15.41 3.83-21.46 8.58l-.36-.47c.3-.27.49-.62.57-1.01z"
        id="path8579"
      />
      <path
        className="st10"
        d="M515.27 197.11c1.14.24 1.87 1.37 1.63 2.51-.09.4-.28.74-.54 1.02-.49.52-1.22.77-1.97.61a72.28 72.28 0 0 0-3.48-.65c1.28-1.27 2.67-2.44 4.14-3.53.08.02.15.03.22.04z"
        id="path8581"
      />
      <path
        className="st10"
        d="M516.73 201.11c-5.75 4.51-9.85 10.7-10.51 18.51-.66-.08-1.35-.14-2.03-.2-.74-.06-1.46-.12-2.19-.16.63-7.57 4-13.8 8.92-18.66 1.13.18 2.29.4 3.48.65.75.16 1.48-.09 1.97-.61z"
        id="path8583"
      />
      <path
        className="st10"
        d="m499.12 334.41-1.73 3.46-2.41 4.84c-.6-.43-1.29-.82-2.06-1.15.07-1.24.17-2.31.26-3.13.22-1.97 1.27-3.71 2.87-4.79l1.89.18z"
        id="path8585"
      />
      <path
        className="st10"
        d="M498.76 336.92c-.47.23-.86.62-1.11 1.08l-.26-.13 1.73-3.46h-.01l-1.17-.6-1.89-.18c.27-.19.55-.35.85-.5 19.6-9.64 37.56-5.77 49.18-.83 3.28 1.4 5.83 3.8 7.42 6.72 0 .93-.01 1.87-.03 2.81l-.68.08.31 2.56-2.1.25c-.53-3.7-2.94-6.99-6.59-8.54-.31-.14-.63-.27-.96-.4-2.2-.9-4.63-1.74-7.26-2.45-2.86-.77-5.96-1.37-9.24-1.68-8.43-.78-18.09.3-28.19 5.27z"
        id="path8587"
      />
      <path
        className="st10"
        d="m494.97 342.71 2.41-4.84.26.13c-.15.28-.24.59-.28.91-.3 2.63-.67 7.83.26 13.15l.01.01c.19 1.11.45 2.22.76 3.31.89 3.11 2.63 6.01 5.01 8.37.91.91 1.92 1.75 3.01 2.49 2.1 1.42 4.41 2.42 6.83 2.96 2.68.6 6.78 1.4 11.08 1.74 7.98.63 15.5-2.79 20.13-9.16 2.75-3.79 4.83-7.91 6.16-12.22.5-1.62.61-3.26.38-4.83l2.1-.25.27 2.21c-.08 2.82-.2 5.69-.37 8.61a46.452 46.452 0 0 1-5.12 8.95c-5.5 7.58-14.43 11.65-23.88 10.89-.33-.02-.66-.06-.98-.09-4.19-.4-8.09-1.16-10.7-1.75-2.94-.66-5.72-1.86-8.27-3.58-1.31-.89-2.53-1.9-3.62-2.99-2.88-2.86-5-6.39-6.09-10.19-.35-1.24-.65-2.5-.86-3.76-.73-4.15-.74-8.21-.56-11.24.78.34 1.46.74 2.06 1.17z"
        id="path8589"
      />
      <path
        className="st10"
        d="m485.52 332.63 10.53 1a6.66 6.66 0 0 0-2.87 4.79c-.09.83-.19 1.89-.26 3.13-1.55-.65-3.45-1.03-5.78-.82.15-1.12.24-2.09.3-2.86.13-1.97-.57-3.87-1.92-5.24z"
        id="path8591"
      />
      <path
        className="st10"
        d="M506.12 221.59c-.01 1.1-.85 1.99-1.92 2.08 0 0-.01-.01-.01 0-.12-.02-.24-.02-.36-.03l-.38-.03a2.116 2.116 0 0 1-1.56-2.06c0-.78.04-1.53.11-2.28.73.04 1.45.1 2.19.16.68.06 1.36.12 2.03.2-.07.63-.09 1.28-.1 1.96z"
        id="path8593"
      />
      <path
        className="st10"
        d="M504.19 223.67c-.07.01-.14.01-.21.01-.18 0-.37-.03-.53-.07.13 0 .25.02.38.03.12 0 .24.01.36.03z"
        id="path8595"
      />
      <path
        className="st10"
        d="M548.45 397.7c-.22 1.42-.44 2.84-.68 4.27-.55.52-1.12 1.04-1.69 1.55-2.63 2.33-5.5 4.48-8.53 6.41a73.1 73.1 0 0 1-11.44 5.93 79.312 79.312 0 0 1-16.54 4.76c-1.41.26-2.82.47-4.23.64-5.39.66-10.85.77-16.3.34-.48-.04-.96-.08-1.43-.13-1.47-.14-2.95-.31-4.41-.53-.75-.11-1.49-.23-2.24-.35-.64-.12-1.29-.22-1.94-.35-10.19-1.95-20.48-5.61-30.58-10.92-8.84-4.64-15.19-9.37-19.99-14.87-.41-.47-.81-.95-1.2-1.44-.1-1.69-.19-3.54-.29-5.53 2.34 4.51 6.22 8.14 10.99 10.17.43.36.86.7 1.32 1.02.86.66 1.75 1.29 2.68 1.91.05.04.1.07.15.1.49.34 1 .67 1.52.99.59.38 1.2.75 1.82 1.13.36.21.72.43 1.09.63 1.23.72 2.52 1.43 3.87 2.13 1.29.68 2.59 1.33 3.89 1.95 1.12.54 2.24 1.06 3.36 1.56.83.36 1.66.72 2.5 1.06 1.06.44 2.13.86 3.19 1.26 4.39 1.66 8.8 2.99 13.19 4 .4.09.82.19 1.22.27.6.13 1.2.26 1.81.37.51.1 1.01.19 1.52.29.14.02.28.05.42.07.05.01.11.01.16.03.02 0 .04 0 .06.02 2.52.42 5.09.74 7.63.94 12.03.95 24.18-.92 35.14-5.43 3.44-1.43 6.73-3.1 9.79-4.97 5.82-1.09 10.9-4.49 14.17-9.28z"
        id="path8597"
      />
      <path
        className="st10"
        d="M548.9 394.67c-.03.19-.06.4-.09.6l-.36 2.44A22.228 22.228 0 0 1 534.3 407c.33-.21.67-.41.99-.62 2.86-1.81 5.54-3.84 7.99-6.02 2.01-1.78 3.9-3.7 5.62-5.69z"
        id="path8599"
      />
      <path
        className="st10"
        d="M501.89 221.54c-.01.98.65 1.81 1.56 2.06-14.09-1.15-26.59 1.38-27.1 1.48 1-.22 1.7-1.13 1.66-2.15 0-.03-.03-.98.12-2.47 4.35-.7 13.49-1.86 23.87-1.21a24.9 24.9 0 0 0-.11 2.29z"
        id="path8601"
      />
      <path
        className="st10"
        d="M484.96 341.07v-.01l-1.4-4.58-1.08-3.56c.71-.29 1.13-.47 1.13-.47l1.9.18c1.36 1.37 2.06 3.27 1.91 5.25-.06.77-.15 1.74-.3 2.86-.68.05-1.4.17-2.16.33z"
        id="path8603"
      />
      <path
        d="M470.74 380.19c-.22.04-.43.08-.64.13.21-.05.43-.09.64-.13z"
        id="path8605"
        style={{
          fill: "#f47a7a",
        }}
      />
      <path
        className="st10"
        d="M478.01 222.93a2.12 2.12 0 0 1-1.66 2.15l-.01.01c-.03 0-.05.01-.08.01a2.12 2.12 0 0 1-2.43-1.64c-.17-.79.13-1.58.71-2.07.25-.21.57-.36.91-.44.14-.03 1.09-.23 2.67-.49-.14 1.49-.12 2.44-.11 2.47z"
        id="path8607"
      />
      <path
        className="st10"
        d="M478.13 220.47c-1.58.26-2.54.46-2.67.49-.35.07-.66.23-.91.44l-.73-.06c.2-3.87 1.49-13.13 9-19.49 7.24-6.13 18.1-7.74 32.25-4.78a36.733 36.733 0 0 0-4.14 3.53c-11.17-1.81-19.69-.32-25.34 4.45-5.64 4.75-7.09 11.74-7.46 15.42z"
        id="path8609"
      />
      <path
        className="st10"
        d="M411.48 299.4c-1.02-.1-1.93.55-2.22 1.49l-.09.27c-.2-27.49 8.44-41.87 15.76-49.11 6.52-6.45 13.11-8.53 15.64-9.13 8.1-13.95 27.45-20.01 33.24-21.55v-.03l.73.06c-.58.49-.89 1.27-.71 2.07.23 1.11 1.3 1.83 2.43 1.64-1.64.39-24.65 6.05-32.45 20.68-.32.6-.9 1-1.57 1.1-.06.01-7.39 1.19-14.54 8.37-9.56 9.61-14.51 25.6-14.3 46.22a2.112 2.112 0 0 0-1.92-2.08z"
        id="path8611"
      />
      <path
        className="st10"
        d="M463.89 295.65c.72.83.68 2.05-.05 2.83-.09.09-.25.27-.47.52-2.24.34-4.45.55-6.58.68 2.3-2.19 3.75-3.85 3.91-4.03.06-.07.13-.14.21-.21.25-.21.53-.36.82-.44.2-.02.4-.05.6-.08.58.01 1.15.26 1.56.73z"
        id="path8613"
      />
      <path
        className="st10"
        d="M462.33 294.92c7.72-1.08 15.73-3.63 20.7-9.23-.2.41-5.11 10.33-19.65 13.31h-.01c.23-.25.39-.43.47-.52.73-.78.77-2 .05-2.83-.41-.47-.98-.72-1.56-.73z"
        id="path8615"
      />
      <path
        className="st10"
        d="M462.33 294.92c-.2.02-.4.05-.6.08.19-.06.4-.08.6-.08z"
        id="path8617"
      />
      <path
        className="st10"
        d="M460.69 295.65c-.16.18-1.61 1.84-3.91 4.03-5.95.35-11.14.01-14.09-.27-.67-.06-1.23-.12-1.65-.18l-.11-.01c-.96-.09-1.75-.83-1.89-1.81a2.1 2.1 0 0 1 1.51-2.33c.21-.06.4-.08.57-.07V295c25.87-.16 44.26-25.11 44.78-25.83-.26.49-8.72 16.36-25.84 26.01-.01.01-.02.01-.02.01-.01.01-.02.01-.02.01.57-.06 1.14-.12 1.72-.2-.29.08-.57.23-.82.44-.09.06-.16.13-.23.21z"
        id="path8619"
      />
      <path
        className="st10"
        d="M444.05 322.84c.13 1.1-.6 2.1-1.66 2.31l-.24.03c-.14.02-.26.02-.4 0-.97-.09-1.78-.85-1.9-1.86-.08-.7-.14-1.38-.18-2.04 1.35-.23 2.74-.43 4.19-.57.04.69.1 1.4.19 2.13z"
        id="path8621"
      />
      <path
        className="st10"
        d="M443.33 311.83c1.09.4 1.65 1.62 1.25 2.72-.19.52-.34 1.09-.45 1.7-.7-.13-1.36-.25-1.95-.37-.93-.18-1.68-.35-2.2-.46.16-.83.37-1.61.63-2.34.4-1.09 1.62-1.65 2.72-1.25z"
        id="path8623"
      />
      <path
        className="st10"
        d="M442.38 325.15a2.1 2.1 0 0 0 1.66-2.31c-.09-.74-.15-1.44-.18-2.12 11.72-1.21 26.63.46 40.91 11.25.26.2.51.42.74.65l-1.9-.18s-.43.17-1.13.47l1.08 3.56-.45.14c-.15-.5-.46-.94-.88-1.27-8.99-6.79-18.26-9.68-26.69-10.48-4.14-.39-8.07-.29-11.67.11-.51.06-1 .12-1.49.18z"
        id="path8625"
      />
      <path
        className="st10"
        d="M444.12 316.25c-.26 1.28-.34 2.78-.26 4.47-1.45.14-2.85.34-4.19.57-.13-2.19-.03-4.15.3-5.87.52.11 1.27.28 2.2.46.6.12 1.25.24 1.95.37z"
        id="path8627"
      />
      <path
        className="st10"
        d="M438.3 322.94c-.26-.41-.52-.84-.76-1.25.69-.15 1.41-.28 2.13-.4.04.66.1 1.34.18 2.04a2.108 2.108 0 0 0 2.3 1.86c-1.62.23-3.16.51-4.62.82-.15.04-.3.07-.44.11.2-.05.4-.14.58-.26.97-.63 1.26-1.93.63-2.92z"
        id="path8629"
      />
      <path
        className="st10"
        d="M439.98 315.42c-.58-.14-.9-.22-.93-.23a2.107 2.107 0 0 1-1.56-2.03c-.01-.96.62-1.79 1.55-2.05 6.86-1.91 13.64-7.52 17.75-11.44 2.12-.13 4.34-.34 6.58-.68-1.89 2.08-8.6 9.09-16.56 13.42 16.18 2.56 54.61 4.64 74.91-27.56.11.33.22.64.33.97.47 1.33.98 2.61 1.54 3.86-19.38 27.89-51.89 29.55-70.67 27.76-3.45-.33-6.43-.78-8.79-1.19.11-.62.26-1.19.45-1.7.4-1.1-.15-2.31-1.25-2.72-1.09-.4-2.31.15-2.72 1.25-.27.73-.48 1.51-.63 2.34z"
        id="path8631"
      />
      <path
        className="st10"
        d="M438.3 322.94c.63.99.34 2.29-.64 2.92-.18.12-.37.21-.58.26-.03 0-.06.02-.08.02-.22.06-.46.07-.68.05-.62-.06-1.21-.4-1.58-.96-.49-.76-.93-1.51-1.34-2.26 1.01-.48 2.1-.84 3.24-1.09.3-.06.6-.13.9-.18.24.4.49.82.76 1.24z"
        id="path8633"
      />
      <path
        className="st10"
        d="M437.54 321.69c-.3.06-.61.12-.9.18-1.14.24-2.22.61-3.24 1.09-1.01-1.82-1.8-3.59-2.42-5.23.56-3.1 1.18-6.13 1.85-9.07.02-.11.05-.21.07-.33.07.62.29 2.19.87 4.34.66 2.46 1.81 5.67 3.77 9.02z"
        id="path8635"
      />
      <path
        className="st10"
        d="m428.15 404.14-2.09.28-2.1.22c-.22-1.97-.91-9.03-1.31-19.45.02.25.08.5.2.74.53 1.14 1.14 2.27 1.82 3.37 1.08 5.45 2.24 10.47 3.42 14.51.03.12.05.22.06.33z"
        id="path8637"
      />
      <path
        className="st10"
        d="M428.15 404.14c-.01-.11-.04-.22-.07-.32-1.19-4.04-2.34-9.06-3.42-14.51.77 1.26 1.64 2.5 2.6 3.71.36 5.86.75 9.78.89 11.12z"
        id="path8639"
      />
      <path
        className="st10"
        d="M434.99 326.88c-3.28 1.6-5.55 4.74-6.05 8.37l-.48-.05c.37-3.34.79-6.62 1.26-9.83a15.49 15.49 0 0 1 3.68-2.41c.41.75.86 1.5 1.34 2.26.36.57.95.9 1.58.96.22.02.46.01.68-.05-.7.19-1.37.44-2.01.75z"
        id="path8641"
      />
      <path
        className="st10"
        d="M437.08 396.95c.29.26.58.49.89.71a22.184 22.184 0 0 1-10.99-10.17c-.04-.82-.07-1.65-.11-2.52-.01-.15-.02-.29-.02-.45 1.2 2.48 2.82 4.88 4.79 7.15.46.53.94 1.05 1.44 1.58.2.2.39.41.6.61.3.3.61.61.93.91.25.24.51.48.78.71.54.5 1.11.99 1.69 1.47z"
        id="path8643"
      />
      <path
        className="st10"
        d="M427.26 393.02a40.06 40.06 0 0 1-2.6-3.7c-.39-1.94-.77-3.95-1.13-5.98.09-.08.22-.14.33-.21.44-.21.92-.25 1.36-.14.62.13 1.16.54 1.45 1.17.06.13.12.24.18.36.01.15.02.29.02.45.04.87.06 1.71.11 2.52.09 1.99.18 3.84.28 5.53z"
        id="path8645"
      />
      <path
        className="st10"
        d="M424.01 404.96c-.03-.1-.06-.2-.09-.31l.04-.01 2.1-.22 2.09-.28c.03.17.03.34.02.5a2.11 2.11 0 0 1-2.3 1.9c-.92-.08-1.64-.73-1.86-1.58z"
        id="path8647"
      />
      <path
        className="st10"
        d="M432.9 308.34c-.02.11-.05.21-.07.33-.67 2.94-1.28 5.96-1.85 9.07-2.01-5.24-2.31-9.15-2.33-9.39-.01-.18 0-.36.03-.54.17-.92.96-1.65 1.93-1.72 1.16-.08 2.17.8 2.25 1.96 0 .01.02.11.04.29z"
        id="path8649"
      />
      <path
        className="st10"
        d="M427.32 348.3c.29-4.47.67-8.84 1.14-13.1l.48.05c-.12.88-.14 1.79-.03 2.71.49 4.48 1.75 8.92 3.74 13.16 3.34 7.13 10.08 11.91 18.04 12.8 4.29.47 8.46.47 11.2.38 2.49-.07 4.94-.62 7.28-1.62 1.2-.52 2.35-1.14 3.41-1.86 2.79-1.87 5.04-4.39 6.5-7.28a31.6 31.6 0 0 0 1.37-3.11c0-.01 0-.01.01-.01 1.92-5.06 2.54-10.23 2.74-12.87.02-.32-.01-.64-.1-.94l.45-.14 1.4 4.58v.03c.76-.17 1.48-.28 2.17-.34-.39 3.03-1.16 7.13-2.71 11.19-.45 1.19-.98 2.38-1.56 3.53-1.79 3.53-4.53 6.6-7.91 8.86-1.27.86-2.66 1.62-4.11 2.25a24.145 24.145 0 0 1-8.81 1.96c-2.67.09-6.64.1-10.83-.3-.32-.03-.65-.06-.98-.1-9.43-1.05-17.43-6.73-21.4-15.21-.58-1.22-1.1-2.46-1.56-3.72.04-.3.05-.6.07-.9z"
        id="path8651"
      />
      <path
        className="st10"
        d="m427.32 348.3-.06.9c-1.3-3.51-2.16-7.12-2.56-10.77-.12-1.07-.12-2.12-.03-3.14.37-3.88 2.21-7.41 5.04-9.92-.47 3.21-.89 6.49-1.26 9.83-.46 4.26-.83 8.63-1.13 13.1z"
        id="path8653"
      />
      <path
        className="st10"
        d="M423.53 383.34c.37 2.03.74 4.03 1.14 5.98-.68-1.11-1.29-2.23-1.82-3.37-.12-.24-.18-.49-.2-.74v-.07c0-.03 0-.06-.01-.09 0-.67.32-1.31.89-1.71z"
        id="path8655"
      />
      <path
        className="st10"
        d="M422.64 385.04c-.1-2.67-.17-5.33-.22-7.98.36 2.11.72 4.21 1.1 6.28-.56.4-.88 1.04-.88 1.7z"
        id="path8657"
      />
      <path
        className="st10"
        d="M422.65 385.13v.07c0-.05 0-.11-.01-.16.01.03 0 .06.01.09z"
        id="path8659"
      />
      <path
        className="st10"
        d="M432.87 308.05a2.113 2.113 0 0 0-2.25-1.96c-.98.07-1.76.79-1.93 1.72 0-.03.01-.05.01-.08.07-.31.14-.62.22-.92.68-2.93 1.61-5.78 2.76-8.56 7.36-17.77 16.29-29.67 16.98-30.58-6.76 10.82-12.07 24.5-15.76 40.67-.02-.18-.04-.28-.03-.29z"
        id="path8661"
      />
      <path
        className="st10"
        d="M428.65 308.35c.02.24.31 4.15 2.33 9.39-.45 2.5-.87 5.04-1.26 7.64a15.194 15.194 0 0 0-5.04 9.92l-.48-.05c1.05-9.74 2.55-18.92 4.47-27.42-.02.16-.03.33-.02.52z"
        id="path8663"
      />
      <path
        className="st10"
        d="M423.1 348.02c.28-4.36.65-8.63 1.1-12.79l.48.05c-.1 1.02-.09 2.08.03 3.14.4 3.65 1.26 7.25 2.56 10.77-.72 11.46-.86 23.34-.42 35.33-.07-.13-.13-.25-.18-.37a2.097 2.097 0 0 0-3.14-.82c-.38-2.07-.74-4.17-1.1-6.28-.17-9.84.06-19.58.67-29.03z"
        id="path8665"
      />
      <path
        className="st10"
        d="M419.26 356.17c.07.43-.01.88-.22 1.28a2.11 2.11 0 0 1-2.07 1.11c-.27-.03-.54-.1-.8-.24-.32-.17-.64-.35-.95-.53l-.15-1.05c-.22-1.58-.42-3.14-.63-4.65 1.16 1 2.49 1.84 3.72 2.49.63.35 1.02.95 1.1 1.59z"
        id="path8667"
      />
      <path
        className="st10"
        d="M423.92 404.66c-3.48-12.02-6.62-31.87-8.69-46.86.31.18.62.36.95.53a2.12 2.12 0 0 0 2.87-.87c.22-.4.29-.85.22-1.28h.01c.87 6.35 1.95 13.66 3.15 20.89.04 2.65.12 5.31.22 7.98 0 .05 0 .11.01.16.4 10.41 1.1 17.47 1.31 19.45z"
        id="path8669"
      />
      <path
        className="st10"
        d="M415.08 356.75c.05.34.1.7.15 1.05-5.57-3.24-8.46-7.42-8.38-12.15.09-5.28 2.8-8.92 5.41-11.21.04.37.08.75.13 1.14.15 1.3.33 2.78.53 4.42a10.144 10.144 0 0 0-1.84 5.73c-.04 2.6 1.45 4.72 3.38 6.38.2 1.5.41 3.06.62 4.64z"
        id="path8671"
      />
      <path
        className="st10"
        d="M416.6 335.17c.57 4.89 1.5 12.48 2.67 21.01h-.01c-.08-.64-.47-1.24-1.09-1.58-1.23-.66-2.55-1.49-3.72-2.49-.6-4.53-1.12-8.68-1.54-12.11.73-1.08 1.69-2.08 2.87-3 .59-.45.87-1.15.82-1.83z"
        id="path8673"
      />
      <path
        className="st10"
        d="M416.6 335.17c.05.68-.23 1.38-.81 1.83-1.18.92-2.14 1.92-2.87 3-.2-1.64-.37-3.12-.53-4.42-.05-.39-.09-.77-.13-1.14.31-.27.62-.54.93-.77.92-.72 2.25-.55 2.97.37.21.28.35.59.42.91 0 .06.01.14.02.22z"
        id="path8675"
      />
      <path
        className="st10"
        d="M414.02 319.61c.38-.45.53-1 .49-1.55.26 2.25.59 4.62.96 7.03 0 .04.01.07.01.11 0 .04.4 3.82 1.1 9.74-.07-.32-.2-.63-.42-.91a2.115 2.115 0 0 0-2.97-.37c-.31.24-.62.5-.93.77-.58-5.01-.94-8.31-.98-8.75-.15-.96-.29-1.9-.42-2.84 1.07-.93 2.13-2 3.16-3.23z"
        id="path8677"
      />
      <path
        className="st10"
        d="M414.51 318.06c.05.54-.11 1.1-.49 1.55-1.03 1.23-2.1 2.31-3.16 3.24-.21-1.49-.39-2.94-.56-4.35-.07-.59.11-1.16.46-1.58l.02-.02c.03-.04.06-.08.1-.11.04-.05.08-.08.12-.12.05-.04.11-.09.17-.13.07-.05.14-.1.22-.13.07-.04.15-.08.23-.11.05-.02.11-.04.17-.05.06-.02.12-.04.18-.05.07-.01.12-.02.19-.03.08-.01.15-.01.23-.01.08-.01.16 0 .23.01.1.01.2.03.29.05h.01c.08.02.15.04.23.07.03.01.05.02.09.04.08.03.16.07.23.11.01.01.03.02.04.02.09.05.17.11.25.17l.02.02c.14.12.26.24.36.39.05.07.1.14.13.22.04.07.08.15.11.23.03.07.06.15.08.23.01.04.02.09.02.12.02.07.02.12.03.19v.03z"
        id="path8679"
      />
      <path
        className="st10"
        d="M414.5 318c-.01-.06-.02-.12-.03-.19.01.07.03.14.03.19z"
        id="path8681"
      />
      <path
        className="st10"
        d="M414.44 317.69c-.02-.07-.05-.15-.08-.23.04.08.06.15.08.23z"
        id="path8683"
      />
      <path
        className="st10"
        d="M414.37 317.47c-.03-.08-.07-.16-.11-.23.04.07.07.15.11.23z"
        id="path8685"
      />
      <path
        className="st10"
        d="M414.25 317.24c-.04-.07-.08-.15-.13-.22.05.07.1.14.13.22z"
        id="path8687"
      />
      <path
        className="st10"
        d="M413.74 316.61c-.08-.06-.16-.12-.25-.17.09.05.17.11.25.17z"
        id="path8689"
      />
      <path
        className="st10"
        d="M413.46 316.42c-.07-.04-.15-.09-.23-.11.07.02.15.07.23.11z"
        id="path8691"
      />
      <path className="st10" d="M413.14 316.27z" id="path8693" />
      <path
        className="st10"
        d="M412.9 316.2c-.1-.02-.19-.04-.29-.05.1.01.2.02.29.05z"
        id="path8695"
      />
      <path
        className="st10"
        d="M412.38 316.14c-.08 0-.15.01-.23.01.09-.01.16-.01.23-.01z"
        id="path8697"
      />
      <path
        className="st10"
        d="M412.16 316.15c-.06.01-.12.02-.19.03.07-.01.13-.03.19-.03z"
        id="path8699"
      />
      <path
        className="st10"
        d="M413.39 301.48c0 .08 0 .15-.01.23v.01c-.01.11-.03.21-.06.31-.01.05-.02.1-.04.15-.3.91-1.2 1.53-2.2 1.44a2.11 2.11 0 0 1-1.91-2.16v-.3l.09-.27c.29-.94 1.21-1.58 2.22-1.49 1.09.1 1.91 1.01 1.91 2.08z"
        id="path8701"
      />
      <path
        className="st10"
        d="M413.28 302.18c.02-.05.03-.1.04-.15-.01.04-.02.1-.04.15z"
        id="path8703"
      />
      <path
        className="st10"
        d="M411.97 316.18c-.06.01-.12.02-.18.05.06-.02.12-.04.18-.05z"
        id="path8705"
      />
      <path
        className="st10"
        d="M411.62 316.29c-.08.03-.16.07-.23.11.08-.04.15-.08.23-.11z"
        id="path8707"
      />
      <path
        className="st10"
        d="M411.39 316.4c-.07.04-.15.08-.22.13.07-.05.15-.1.22-.13z"
        id="path8709"
      />
      <path
        className="st10"
        d="M411 316.67c-.04.03-.08.07-.12.12.05-.05.08-.09.12-.12z"
        id="path8711"
      />
      <path
        className="st10"
        d="M413.28 302.18c-2.78 8.36-5.66 15.05-8.6 19.99 1.93-1.18 4.07-2.87 6.08-5.25-.35.43-.53.99-.46 1.58.16 1.41.34 2.86.56 4.35-5.86 5.16-11.65 6.12-11.94 6.16-.18.03-.35.03-.53.01-.7-.07-1.33-.48-1.68-1.12-.41-.8-.28-1.78.35-2.44 4.06-4.26 8.13-12.44 12.1-24.3 0 .1-.01.2 0 .3-.03 1.1.8 2.05 1.91 2.16 1.01.09 1.91-.53 2.21-1.44z"
        id="path8713"
      />
      <radialGradient
        id="SVGID_00000160156348628200864500000000837837588945147815_"
        cx={453.463}
        cy={383.62}
        r={22.194}
        gradientTransform="rotate(5.438 517.208 308.869)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#e57070",
          }}
          id="stop8715"
        />
        <stop
          offset={0.17}
          style={{
            stopColor: "#e67574",
            stopOpacity: 0.8303,
          }}
          id="stop8717"
        />
        <stop
          offset={0.379}
          style={{
            stopColor: "#ea8480",
            stopOpacity: 0.6213,
          }}
          id="stop8719"
        />
        <stop
          offset={0.608}
          style={{
            stopColor: "#f09d93",
            stopOpacity: 0.3917,
          }}
          id="stop8721"
        />
        <stop
          offset={0.851}
          style={{
            stopColor: "#f9c0ad",
            stopOpacity: 0.149,
          }}
          id="stop8723"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#ffd9c0",
            stopOpacity: 0,
          }}
          id="stop8725"
        />
      </radialGradient>
      <path
        style={{
          opacity: 0.15,
          fill: "url(#SVGID_00000160156348628200864500000000837837588945147815_)",
        }}
        d="M468.75 379.34c-.04.46-.1.92-.19 1.38-.02.17-.04.34-.08.51-.05.28-.11.55-.17.83-.11.48-.23.94-.36 1.41-.08.24-.14.48-.23.73-.08.26-.17.53-.27.79-.13.37-.28.73-.43 1.1-.44 1.01-.96 1.98-1.53 2.9-.04.07-.09.14-.13.2-4.34 6.79-12.23 10.97-20.82 10.15-2.32-.22-4.52-.79-6.56-1.65-.01 0-.01 0-.02-.01a22.184 22.184 0 0 1-10.99-10.17c-.74-1.42-1.33-2.93-1.76-4.5-.67-2.49-.92-5.15-.66-7.86.25-2.66.97-5.17 2.05-7.45v-.01c1.55-3.22 3.84-5.99 6.63-8.11 1.15-.88 2.38-1.64 3.67-2.27.92-.44 1.88-.84 2.86-1.16 2.81-.91 5.85-1.28 8.98-.99.25.02.5.05.75.08.04 0 .09.01.13.02h.02c1.22.16 2.4.42 3.54.78.15.04.31.08.45.14a22.03 22.03 0 0 1 10.86 7.88c.88 1.2 1.65 2.49 2.28 3.85 1.63 3.45 2.37 7.36 1.98 11.43z"
        id="path8728"
      />
      <radialGradient
        id="SVGID_00000146465446209257506990000014163992931765616284_"
        cx={537.306}
        cy={383.617}
        r={22.191}
        gradientTransform="rotate(5.438 517.208 308.869)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#e57070",
          }}
          id="stop8730"
        />
        <stop
          offset={0.17}
          style={{
            stopColor: "#e67574",
            stopOpacity: 0.8303,
          }}
          id="stop8732"
        />
        <stop
          offset={0.379}
          style={{
            stopColor: "#ea8480",
            stopOpacity: 0.6213,
          }}
          id="stop8734"
        />
        <stop
          offset={0.608}
          style={{
            stopColor: "#f09d93",
            stopOpacity: 0.3917,
          }}
          id="stop8736"
        />
        <stop
          offset={0.851}
          style={{
            stopColor: "#f9c0ad",
            stopOpacity: 0.149,
          }}
          id="stop8738"
        />
        <stop
          offset={1}
          style={{
            stopColor: "#ffd9c0",
            stopOpacity: 0,
          }}
          id="stop8740"
        />
      </radialGradient>
      <path
        style={{
          opacity: 0.15,
          fill: "url(#SVGID_00000146465446209257506990000014163992931765616284_)",
        }}
        d="M552.21 387.29c-.21 2.18-.72 4.25-1.51 6.18-.6 1.5-1.36 2.91-2.25 4.23a22.228 22.228 0 0 1-14.15 9.29c-2.02.38-4.13.49-6.28.29-9.21-.88-16.56-7.27-19.12-15.59-.06-.19-.12-.37-.15-.56-.22-.75-.39-1.51-.51-2.28v-.01c-.1-.53-.17-1.06-.2-1.6v-.01c-.09-.79-.12-1.58-.1-2.39 0-.49.03-.98.08-1.49v-.01c-.01-.05 0-.1 0-.15l.01-.11c.35-3.68 1.58-7.07 3.47-9.97.85-1.33 1.85-2.55 2.97-3.65a22.09 22.09 0 0 1 17.75-6.37c3.1.3 5.99 1.22 8.57 2.64 1.29.7 2.49 1.53 3.6 2.46 3.05 2.57 5.37 5.92 6.69 9.73a21.87 21.87 0 0 1 1.13 9.37z"
        id="path8743"
      />
      <g
        id="g8773"
        style={{
          opacity: 0.5,
        }}
      >
        <path
          className="st20"
          d="M515 287.88c-1.1 3.55-2.8 7.31-5.38 10.9l-.01.01c-5.82 4.87-12.22 8.25-18.72 10.54 25.61-13.66 25.84-38.86 25.84-38.86l.02.16c.15 1.23.93 8.66-1.75 17.25z"
          id="path8745"
        />
        <path
          className="st20"
          d="M607.31 214.96c-51.18-30.5-79.54-6.65-90.21 6.58-1.36-.32-2.72-.62-4.09-.89-2.15-.44-4.43-.78-6.79-1.04.35-4.13 1.66-7.8 3.67-11.01 0-.01.01-.01.01-.01a31.44 31.44 0 0 1 3.83-3.73c1.3-1.06 2.7-2.05 4.17-2.93.28-.18.56-.34.83-.5.87-.5 1.76-.97 2.66-1.41.65-.31 1.3-.61 1.96-.87.83-.35 1.66-.68 2.5-.97 3.25-1.16 6.6-1.94 9.91-2.35 1.6-.2 3.21-.36 4.82-.47 1.92-.14 3.86-.23 5.78-.25h.01c.76-.01 1.52-.01 2.28 0h.01c2.15.02 4.28.12 6.42.29 3.08.24 6.15.62 9.2 1.14h.01a101.67 101.67 0 0 1 15.78 4.02c.01 0 .01 0 .03.01 7.81 2.66 15.22 6.26 21.92 10.64l.01.01c1.63 1.08 3.22 2.18 4.78 3.36.05.04.1.07.15.11.01 0 .02.01.03.02.1.08.21.16.32.25z"
          id="path8747"
        />
        <path
          className="st20"
          d="M636.6 270.23c-.15-.6-.32-1.21-.51-1.81-4.09-14.18-12.96-29.3-31.23-39.96-21.75-12.7-42.93-6.18-59 3.92-5.69-3.06-11.75-5.68-18.09-7.8 5.41-5.58 17.49-14.39 40.37-15.13 19.96-.65 45.84 7.82 60.61 30.36 4.39 8.37 6.97 17.67 7.68 27.35.07.92.13 1.84.15 2.76.01.11.01.21.02.31z"
          id="path8749"
        />
        <path
          className="st20"
          d="M562.77 339.26c-1.06 1.8-2.21 3.55-3.46 5.27a88.5 88.5 0 0 1-1.71 2.24c.05-1.83.09-3.65.11-5.45.02-1.74.02-3.45.01-5.15 2-6.03 3.5-11.92 4.51-17.65.41 6.26.65 13.23.54 20.74z"
          id="path8751"
        />
        <path
          className="st20"
          d="M581.84 340.21c-2.59-1.45-5.61-1.7-8.71-.65-2.04.69-3.99 1.97-5.82 3.79l-.33-2.76c0-.18.01-.36.01-.54-.02.04-.05.07-.06.09 0-.42-.01-.84-.01-1.25 11.03-25.47 7.97-49.03 7.97-49.03.02.33.71 21.63-8.22 41.8-.52-9.14-1.71-17.35-3.07-24.22 2.67-39.15-19.47-68.21-65.91-73.81-16.3-1.96-28.81-1.32-38.41.71 4.54-2.02 9.53-3.59 14.94-4.72.95-.2 1.91-.38 2.89-.55 7.44-1.3 15.61-1.8 24.43-1.47 2.75.09 5.56.28 8.44.54l.39.04c27.46 2.62 51.92 17.5 65.49 39.88 12.66 20.93 14.73 46.31 5.98 72.15z"
          id="path8753"
        />
        <path
          className="st20"
          d="M562.61 203.92s-22.55 1.76-37.87 19.69c-1.63-.49-3.27-.96-4.93-1.38 7.08-6.85 23.12-19.66 42.8-18.31z"
          id="path8755"
        />
        <path
          className="st20"
          d="M636.64 272.63c-3.49-11.59-10.75-27.51-25.43-36.48-17.17-10.49-40.62-5.51-55.01 2.56-2-1.39-4.07-2.72-6.19-3.98 6.18-4.22 19.44-10.84 39.49-8.44 22.38 2.69 39.45 20.94 46.6 42.13.17.5.34.99.49 1.5 0 .11.01.21.01.31.02.34.03.68.03 1.03v.01c0 .45.01.91.01 1.36z"
          id="path8757"
        />
        <path
          className="st20"
          d="M602.14 236.57s-11.39-1.28-24.44 1.51c-5.02 1.07-10.28 2.75-15.24 5.34-.96-.78-1.94-1.55-2.94-2.3-.27-.21-.54-.41-.82-.62 8.41-4 24.23-9.15 43.44-3.93z"
          id="path8759"
        />
        <path
          className="st20"
          d="M593.25 316.2c1.77-16.6-1.14-32.34-8.72-46.51-3.67-6.86-8.43-13.25-14.09-19.02-1.1-1.12-2.24-2.22-3.4-3.3 6.74-1.35 15.92-1.34 24.88 4.54h.01c2.02 1.32 4.02 2.94 5.99 4.91 11.88 11.92 3.41 37.36-4.67 59.38z"
          id="path8761"
        />
        <path
          className="st20"
          d="M631.29 292.84c-.6 5.85-1.86 11.62-3.6 17.22l-.09.3c-.34.73-.68 1.45-1.03 2.17.27-.85.53-1.7.78-2.57 1.63-5.62 2.76-11.37 3.24-17.19.51-5.8.24-11.67-.84-17.37-.57-2.84-1.37-5.64-2.39-8.34-1.03-2.7-2.35-5.28-3.88-7.72a38.115 38.115 0 0 0-12.06-12.08 36.263 36.263 0 0 0-7.73-3.67l-2.04-.62c-.69-.2-1.4-.34-2.1-.5-1.41-.32-2.8-.69-4.23-.87-.01 0-.01-.01-.01 0-5.66-.96-11.47-1.09-17.1-.24-2.81.48-5.59 1.15-8.26 2.12-.66.26-1.32.5-1.98.78-.64.3-1.29.56-1.92.89-.32.16-.63.32-.95.49-.31.16-.6.33-.9.51-.27.15-.54.32-.8.49-.72-.65-1.46-1.28-2.2-1.9.55-.38 1.07-.68 1.62-.99.01-.01.02-.01.03-.02.66-.38 1.33-.71 2-1.03.68-.34 1.39-.61 2.08-.92.7-.28 1.42-.52 2.12-.79 2.87-.98 5.82-1.63 8.78-2.07 1.66-.22 3.33-.35 5-.4 4.32-.15 8.64.21 12.86 1.01 1.47.22 2.91.63 4.35.98.72.2 1.44.34 2.15.57l2.14.7c2.83 1.02 5.53 2.37 8.03 4.01a39.64 39.64 0 0 1 12.3 12.82c1.53 2.55 2.83 5.24 3.84 8.03.99 2.8 1.75 5.67 2.28 8.58.99 5.82 1.15 11.77.51 17.62z"
          id="path8763"
        />
        <path
          className="st20"
          d="M567.76 250.8c.16.16.3.31.46.47h-.01c-.15-.16-.3-.32-.45-.47z"
          id="path8765"
        />
        <path
          className="st20"
          d="M618.7 410.57c-2.23-.08-4.46-.24-6.68-.57-2.36-.36-4.71-.87-7-1.59-4.58-1.43-8.95-3.85-12.4-7.36-3.47-3.49-5.9-7.94-7.33-12.62-1.45-4.7-2.01-9.6-2.09-14.47-.02-1.86.02-3.71.13-5.55 3.21-3.59 5.19-8.52 5.51-13.83.16-3.02-.52-6.15-1.89-8.81.04-.17.08-.35.13-.52 2.32-9.36 5.37-18.51 8.64-27.5.82-2.25 1.64-4.47 2.41-6.67.77-2.21 1.49-4.43 2.18-6.66.68-2.23 1.3-4.48 1.92-6.75.62-2.27 1.2-4.53 1.72-6.78 1.04-4.5 1.82-8.98 2.08-13.4.27-4.45.05-8.72-1.12-12.56-.57-1.92-1.37-3.7-2.37-5.27-1-1.57-2.23-2.92-3.66-4.07-1.97-1.58-4.34-2.78-6.96-3.66h-.01c-1.19-.4-2.45-.74-3.73-1.01-1.02-.22-2.07-.4-3.13-.56-1.07-.15-2.14-.28-3.19-.37-2.11-.16-4.21-.19-6.26-.05-1.77.13-3.5.37-5.17.75-1.1-1.12-2.24-2.22-3.4-3.3-.79.15-1.54.33-2.26.51-.13-.12-.25-.24-.38-.35-.27-.25-.53-.5-.81-.74a.526.526 0 0 0-.14-.12c-.01-.02-.03-.02-.05-.04-.72-.65-1.46-1.28-2.2-1.9.55-.38 1.07-.68 1.62-.99.01-.01.02-.01.03-.02-.13-.1-.26-.21-.39-.31-.96-.78-1.94-1.55-2.94-2.3 2.44-1.02 4.96-1.75 7.47-2.25 2.73-.53 5.47-.78 8.17-.82.85-.01 1.69 0 2.54.04 1.73.06 3.44.21 5.14.43a58.875 58.875 0 0 1 4.18.71c1.28.26 2.56.56 3.85.92 1.48.4 2.97.88 4.44 1.46.01-.01.01 0 .01 0 1.07.41 2.15.88 3.2 1.41.68.33 1.36.7 2.03 1.09 1.35.79 2.67 1.68 3.91 2.69 0 .01 0 .01.01.01s.01.01.01.01a26.85 26.85 0 0 1 6.59 7.8c1.41 2.52 2.41 5.2 3.04 7.88 1.29 5.37 1.18 10.77.61 15.78-.6 5.05-1.74 9.92-3.1 14.62-.68 2.35-1.42 4.66-2.18 6.95-.75 2.27-1.53 4.57-2.37 6.85-.84 2.28-1.72 4.54-2.64 6.78-.92 2.25-1.88 4.44-2.8 6.61-3.72 8.7-7.18 17.47-9.95 26.45-2.74 8.96-4.89 18.16-5.29 27.47-.19 4.64.1 9.31 1.21 13.78 1.1 4.46 3.12 8.73 6.19 12.18 3.06 3.48 7.11 6.05 11.51 7.7 2.21.83 4.49 1.46 6.81 1.95 1.38.28 2.78.49 4.18.67l.06.01c.77.09 1.54.18 2.31.26z"
          id="path8767"
        />
        <path
          className="st20"
          d="M630.59 415.29c-.35 1.2-.86 2.37-1.51 3.48 0 .01 0 .01-.01.01-1.6 1.77-3.59 3.35-5.89 4.68-.01 0-.01.01-.03.01-.1.04-.19.1-.28.16l-.04.02c-.95.53-1.96 1.02-3 1.45-3.81 1.58-7.99 2.48-12.41 2.67-5.9.24-12.12-.82-17.99-3.05-11.81-4.49-25.71-14.09-30.56-25.52 1.83-6.87 3.38-13.97 4.59-21.09.13-.29.25-.58.36-.85.12.03.26.05.38.07h.01c.02 0 .03.01.05.01 2.85.51 5.13 2.67 5.58 5.52 2.53 15.93 9.82 31.74 28.01 37.02 20.17 5.85 28.79-2.9 32.37-13.14.66 1.49 1.03 3.19.96 5.05a14.4 14.4 0 0 1-.59 3.5z"
          id="path8769"
        />
        <path
          className="st20"
          d="M622.15 280.34c-.28 2.85-.81 5.65-1.42 8.41-.62 2.76-1.34 5.48-2.12 8.18-1.62 5.39-3.44 10.68-5.3 15.93-1.92 5.23-3.8 10.46-5.62 15.69-.89 2.62-1.72 5.25-2.47 7.9-.75 2.65-1.38 5.32-1.71 8.01-.16 1.34-.25 2.69-.17 4.02.08 1.33.35 2.64.93 3.8.08.16.16.32.25.47-.15.3-.3.6-.45.91-.24-.28-.46-.57-.65-.89-.81-1.26-1.22-2.71-1.43-4.14-.22-1.44-.25-2.88-.2-4.31.33-5.72 1.75-11.21 3.28-16.59 1.53-5.4 3.37-10.67 5.09-15.96 1.78-5.27 3.55-10.53 5.08-15.82 1.58-5.28 2.94-10.63 3.62-15.99.34-2.69.49-5.34.24-8-.22-2.68-.64-5.35-1.37-7.92-1.47-5.14-4.23-9.93-8.25-13.55-1.51-1.41-3.2-2.63-5-3.69-.01 0-.01 0-.01-.01-.56-.32-1.13-.63-1.7-.93a31.86 31.86 0 0 0-3.79-1.64c-1.3-.47-2.63-.88-4-1.13 1.89.12 3.76.47 5.58 1.01.88.25 1.75.55 2.61.88 1.33.5 2.61 1.12 3.85 1.82 1.24.71 2.44 1.48 3.57 2.37 4.54 3.53 7.93 8.56 9.75 14.04.93 2.74 1.52 5.59 1.82 8.45.36 2.89.27 5.84-.01 8.68z"
          id="path8771"
        />
      </g>
      <path
        className="st21"
        d="M417.81 300s.53 10.96-13.12 22.16c2.94-4.94 5.82-11.63 8.6-19.99.02-.05.03-.1.04-.15.03-.1.05-.21.06-.31v-.01c.01-.08.01-.15.01-.23-.21-20.62 4.73-36.61 14.3-46.22 6.3-6.34 12.74-8 14.22-8.31-6.2 4.15-25.5 19.79-24.11 53.06z"
        id="path8775"
      />
      <path
        className="st20"
        d="M478.96 224.63c.44-.07.93-.15 1.46-.22-.51.12-1 .2-1.46.22z"
        id="path8777"
      />
      <path
        d="M487.13 219.41c-3.82.29-6.95.72-9 1.06.37-3.68 1.82-10.67 7.45-15.42 3.51-2.96 8.12-4.65 13.78-5.08-13.1 5.6-12.61 15.32-12.23 19.44z"
        id="path8779"
        style={{
          opacity: 0.31,
          fill: "#754a1b",
        }}
      />
      <path
        className="st21"
        d="m485.89 269.18-.01.01c-.01.01-.02.01-.02.03-.02.03-.04.05-.07.09-.2.26-.67.86-1.32 1.67l-.09.12c-4.95 6-21.44 23.76-43.26 23.9v.01c-.13-.01-.26.01-.41.04 19.75-4.3 44.4-25.22 45.18-25.87z"
        id="path8781"
      />
      <path
        className="st20"
        d="M441.48 281.49c2.15-4.98 4.53-9.56 7.13-13.72-.42.76-3.51 6.45-7.13 13.72z"
        id="path8783"
      />
      <path
        className="st21"
        d="M448.64 267.69c-.78 1.03-9.65 12.9-16.97 30.56a53.39 53.39 0 0 0-2.76 8.56c-.07.3-.14.61-.22.92 0 .03-.01.05-.01.08-1.93 8.5-3.43 17.69-4.47 27.42-.45 4.16-.82 8.43-1.1 12.79-.62 9.45-.84 19.18-.68 29.04-.37-2.23-.73-4.47-1.08-6.69.08-10.74.4-25.27 1.36-42.07 2.05-35.64 25.23-59.88 25.93-60.61z"
        id="path8785"
      />
      <path
        className="st20"
        d="M448.65 267.67s0 .01-.01.02c-.01.02-.02.04-.04.07.01-.02.03-.05.03-.07.02-.01.02-.02.02-.02z"
        id="path8787"
      />
      <path
        className="st10"
        d="M486.63 345.6c2 3 2.79 6.93 1.88 10.58-.42 1.84-1.39 3.51-2.28 5.04-.92 1.56-1.9 3.08-2.85 4.6-.96 1.51-1.93 3.02-2.7 4.57-.76 1.54-1.35 3.24-.35 4.43.47.61 1.2 1.06 1.97 1.38.78.33 1.63.52 2.49.6 1.73.19 3.53-.12 5.12-.98-1.42 1.13-3.29 1.68-5.15 1.67a9.48 9.48 0 0 1-2.78-.43c-.9-.29-1.8-.77-2.49-1.54-.33-.39-.64-.85-.77-1.38l-.1-.4c-.02-.13-.02-.26-.03-.4 0-.13-.01-.27-.01-.4l.04-.38c.13-1 .47-1.91.86-2.75.79-1.69 1.77-3.22 2.72-4.75.98-1.52 1.95-3.02 2.9-4.54.97-1.53 1.86-2.99 2.37-4.64 1-3.29.63-7.01-.84-10.28z"
        id="path8789"
      />
      <path
        d="M548.83 323.12s-8.55-6.57-12.86-6.63c-6.47-.08-20.54 4.06-25.94 5.08-5.4 1.01-5.84-1.15-6.67-2.78-.83-1.63 4.62-2.64 13.21-3.61 8.59-.97 18.37-3.01 22.66-.8 4.29 2.2 9.6 8.74 9.6 8.74z"
        id="path8791"
      />
      <path
        d="M477.88 320.83c-1.29 1.27-2.13 3.05-9.36 1.33-4.16-.98-12.11-3.3-19.79-5.28l16.76-.2c8.51 1.71 13.48 3.09 12.39 4.15z"
        id="path8793"
      />
      <g id="g8913">
        <path
          className="st10"
          d="M534.83 344.35c2.05.56 4.72.83 6.94-.45 0 0-2.28 3.31-4.89 3.39-.69-.98-1.35-1.97-2.05-2.94z"
          id="path8795"
        />
        <path
          className="st10"
          d="m536.32 351.19.23.39c-.09.24-.18.48-.28.71-.13-.12-.25-.25-.37-.38.15-.25.29-.49.42-.72z"
          id="path8797"
        />
        <path
          className="st10"
          d="m535.9 350.48.42.7c-.13.23-.27.47-.42.72-.15-.17-.29-.35-.43-.54.3-.54.43-.88.43-.88z"
          id="path8799"
        />
        <path
          className="st10"
          d="M534.83 344.35c.7.97 1.36 1.96 2.05 2.93-.37.01-.74-.04-1.12-.18-.9-.33-1.62-.81-2.2-1.33-.15-.72-.39-1.43-.68-2.09.52.23 1.2.47 1.95.67z"
          id="path8801"
        />
        <path
          className="st10"
          d="M536.82 350.12c.04-.24-1.35-1.78-3.13-3.61a8.55 8.55 0 0 0-.13-.73c.58.51 1.3 1 2.2 1.33.37.13.75.19 1.12.18 1.04 1.45 2.14 2.85 3.5 4.02.29.24.72.48 1.01.23-.92.79-1.7 1.58-3.03 1.6-.86.02-1.53-.33-2.09-.85.1-.23.19-.47.28-.71l-.23-.39c.27-.47.47-.88.5-1.07z"
          id="path8803"
        />
        <path
          className="st10"
          d="M536.27 352.29c-2.12 4.91-7.08 6.64-11.09 7.21 4.16-.85 7.03-3.13 8.5-4.58v-.01c.75-.74 1.13-1.26 1.13-1.26s.56-.86 1.09-1.75c.12.14.25.27.37.39z"
          id="path8805"
        />
        <path
          className="st10"
          d="M533.51 354.1c.96-1.06 1.59-2.06 1.96-2.73.13.19.27.37.43.54-.53.89-1.09 1.75-1.09 1.75s-.38.52-1.13 1.26c-.04-.29-.09-.55-.17-.82z"
          id="path8807"
        />
        <path
          className="st23"
          d="M534.66 350.09c.26.42.52.86.82 1.27-.37.67-1 1.67-1.96 2.73-.15-.59-.38-1.16-.67-1.7a10.997 10.997 0 0 0 .92-3.68c.31.45.6.91.89 1.38z"
          id="path8809"
        />
        <path
          className="st10"
          d="M540.42 336.61s-1.8 7.16-6.18 6.95a17.194 17.194 0 0 0-2.42-2.69c2.44.14 5.93-.49 8.6-4.26z"
          id="path8811"
        />
        <path
          className="st10"
          d="M533.77 348.71c.05-.74.02-1.48-.08-2.2 1.79 1.82 3.18 3.37 3.13 3.61-.03.19-.23.6-.5 1.07l-.42-.7s-.13.34-.42.88c-.3-.42-.56-.85-.82-1.27-.29-.48-.58-.94-.89-1.39z"
          id="path8813"
        />
        <path
          className="st10"
          d="M532.56 349.75c.15-.83.2-1.66.14-2.47.38.46.74.94 1.07 1.43a10.997 10.997 0 0 1-.92 3.68c-.2-.38-.43-.75-.7-1.1.04-.1.07-.18.1-.28.12-.4.23-.83.31-1.26z"
          id="path8815"
        />
        <path
          className="st10"
          d="M534.83 344.35c-.76-.2-1.43-.44-1.95-.67-.08-.16-.15-.32-.23-.48.18.06.36.12.56.18.36.11.7.16 1.03.18.21.26.4.52.59.79z"
          id="path8817"
        />
        <path
          className="st10"
          d="M531.82 340.87c.69.63 1.34 1.32 1.94 2.06.16.21.33.42.48.63-.33-.02-.67-.07-1.03-.18-.2-.06-.38-.12-.56-.18-.45-.88-1.01-1.69-1.68-2.42.26.05.55.08.85.09z"
          id="path8819"
        />
        <path
          className="st24"
          d="M527.84 347.04c1.61.89 3.13 2.17 4.4 3.96-.03.1-.06.18-.1.28-1.04-1.43-2.53-2.68-4.22-3.7-.02-.18-.04-.35-.08-.54z"
          id="path8821"
        />
        <path
          className="st10"
          d="M533.92 333.77s-.51 4.69-2.93 6.39c-.99-.79-2.07-1.45-3.23-1.96 1.57-.28 3.95-1.27 6.16-4.43z"
          id="path8823"
        />
        <path
          className="st10"
          d="M532.7 347.28c-.06-.75-.21-1.49-.43-2.19.49.48.96.96 1.42 1.43.1.72.13 1.46.08 2.2-.33-.5-.69-.98-1.07-1.44.01.01 0 0 0 0z"
          id="path8825"
        />
        <path
          className="st10"
          d="M533.68 354.92c-1.47 1.45-4.34 3.73-8.5 4.58h-.03c-2.86.4-5.22.21-5.71.17-.06-.01-.09-.01-.09-.01 7.45.09 11.8-2.95 14.16-5.56.08.27.13.53.17.82z"
          id="path8827"
        />
        <path
          className="st10"
          d="M533.56 345.78c-1.32-1.18-1.88-2.54-1.92-2.66.06.03.52.27 1.24.56.29.67.53 1.37.68 2.1z"
          id="path8829"
        />
        <path
          className="st10"
          d="M532.27 345.08c-.28-.9-.7-1.74-1.23-2.51.44.21.97.42 1.61.63.08.16.15.32.23.48-.72-.29-1.18-.53-1.24-.56.04.12.59 1.47 1.92 2.66.05.24.1.49.13.73-.46-.46-.94-.95-1.42-1.43z"
          id="path8831"
        />
        <path
          className="st10"
          d="M531.82 340.87c-.3-.01-.59-.04-.85-.08-.12-.13-.24-.26-.38-.38.14-.07.27-.14.4-.24.29.22.57.45.83.7z"
          id="path8833"
        />
        <path
          className="st10"
          d="M529.95 341.26c.4.41.77.85 1.09 1.32-1.37-.66-1.88-1.3-2.05-1.77l.96.45z"
          id="path8835"
        />
        <path
          className="st10"
          d="M530.97 340.79c-.34-.04-.65-.09-.92-.16.19-.05.37-.13.54-.22.14.12.26.25.38.38z"
          id="path8837"
        />
        <path
          className="st10"
          d="M531.04 342.58a9.798 9.798 0 0 0-1.63-1.83c.22-.01.45-.06.65-.12.27.07.58.12.92.16.67.73 1.23 1.54 1.68 2.42-.65-.21-1.19-.42-1.62-.63z"
          id="path8839"
        />
        <path
          className="st10"
          d="M532.27 345.08c-1.68-1.67-3.45-3.35-4.61-4.35.39.02.81.04 1.25.03.02.02.06.03.08.04.17.47.67 1.11 2.05 1.77.53.77.95 1.61 1.23 2.51z"
          id="path8841"
        />
        <path
          className="st10"
          d="M529.4 340.75c.19.17.37.34.54.51l-.96-.45c-.01-.01 0-.02-.01-.03h.12c.11-.01.21-.01.31-.03z"
          id="path8843"
        />
        <path
          className="st10"
          d="M529.4 340.75c-.1.02-.21.02-.31.02h-.12c-.06-.16-.07-.31-.07-.42.18.13.35.27.5.4z"
          id="path8845"
        />
        <path
          className="st10"
          d="M530.59 340.4c-.91-.89-1.98-1.63-3.18-2.15.11-.02.23-.03.35-.05 1.15.51 2.23 1.17 3.23 1.96-.13.1-.26.18-.4.24z"
          id="path8847"
        />
        <path
          className="st10"
          d="M528.98 340.77c.01.01 0 .02.01.03-.02-.02-.06-.03-.08-.04.01.01.04.01.07.01z"
          id="path8849"
        />
        <path
          className="st10"
          d="M528.93 340.29c.11.05.51.2 1.12.34-.2.07-.42.11-.65.12-.16-.13-.32-.27-.49-.39.01-.18.06-.28.06-.28z"
          id="path8851"
        />
        <path
          className="st10"
          d="M527.84 347.04c.04.18.06.36.08.54-1.46-.89-3.06-1.6-4.65-2.12 1.53.27 3.09.77 4.57 1.58z"
          id="path8853"
        />
        <path
          className="st10"
          d="M526.42 339.82c.12 0 .58.34 1.24.91-3.09-.17-4.61-.87-4.61-.87l1.69-.91c.79.4 1.37.87 1.68.87z"
          id="path8855"
        />
        <path
          className="st10"
          d="M528.9 340.77c-1.41-.67-2.81-1.33-4.06-1.86l.44-.24c1.35.31 2.57.9 3.62 1.69 0 .11.01.26.07.42-.02-.01-.05-.01-.07-.01z"
          id="path8857"
        />
        <path
          className="st10"
          d="M528.91 340.35a9.573 9.573 0 0 0-3.62-1.69l.75-.4s.52.1 1.37-.01c1.2.52 2.28 1.25 3.18 2.15-.17.1-.35.17-.54.22-.61-.14-1.02-.29-1.12-.34l.04-.22c0 .01-.05.11-.06.29z"
          id="path8859"
        />
        <path
          className="st10"
          d="M524.85 338.9c1.24.53 2.64 1.2 4.06 1.86-.44 0-.86-.01-1.25-.03-.65-.57-1.11-.91-1.24-.91-.3 0-.89-.47-1.68-.86z"
          id="path8861"
        />
        <path
          className="st10"
          d="M524.03 343.29c1.97.37 3.44 1.9 3.81 3.75-1.48-.82-3.04-1.31-4.57-1.58-.43-.15-.85-.27-1.27-.38-.04-.58-.31-1.11-.74-1.48.85-.36 1.8-.48 2.77-.31z"
          id="path8863"
        />
        <path
          className="st10"
          d="m525.29 338.66-.44.24c-.38-.17-.74-.32-1.08-.46.38.02.76.07 1.14.14.12.03.25.06.38.08z"
          id="path8865"
        />
        <path
          className="st10"
          d="M524.03 343.29c-.97-.18-1.92-.06-2.77.31-.27-.24-.61-.41-.99-.48-1.03-.19-2.02.39-2.38 1.34-1.19-.02-2.22.16-2.95.53-.35.18-.7.37-1.05.58a9.498 9.498 0 0 1 2.13-3.97c1.4-.4 2.88-.61 4.33-.55 4 .16 7.9 1.84 10.83 4.57.55.51 1.06 1.07 1.53 1.65 0 0 .01.01 0 .01a9.822 9.822 0 0 1-.46 3.73c-1.27-1.79-2.79-3.07-4.4-3.96a4.806 4.806 0 0 0-3.82-3.76z"
          id="path8867"
        />
        <path
          className="st10"
          d="M522 345.09c.42.11.84.23 1.27.38-.43-.07-.85-.13-1.27-.18a.67.67 0 0 0 0-.2z"
          id="path8869"
        />
        <path
          className="st6"
          d="M525.16 359.5c-1.69.34-3.59.45-5.71.17.49.04 2.85.23 5.71-.17z"
          id="path8871"
        />
        <path
          className="st6"
          d="M522 345.09c.01.07.01.13 0 .2-.95-.09-1.87-.11-2.73-.08.14-.21.31-.4.49-.58.72.1 1.47.26 2.24.46z"
          id="path8873"
        />
        <path
          className="st10"
          d="M523.77 338.45c.34.14.7.29 1.08.46l-.11.06c-.93-.46-2.17-.82-3.54-.11-.9.46-2.21.91-3.59 1.34a9.492 9.492 0 0 1 6.16-1.75z"
          id="path8875"
        />
        <path
          className="st10"
          d="M523.77 338.45c-2.25-.15-4.41.5-6.16 1.74-.81.26-1.65.52-2.44.78a10.644 10.644 0 0 1 12.24-2.72c-.84.1-1.37.01-1.37.01l-.75.4c-.13-.03-.26-.05-.39-.08-.37-.06-.75-.11-1.13-.13z"
          id="path8877"
        />
        <path
          className="st6"
          d="M520.87 348.66a.534.534 0 0 1-.43-.62.535.535 0 0 1 1.05.2c-.06.28-.34.47-.62.42z"
          id="path8879"
        />
        <path
          className="st6"
          d="M521.26 343.61c.43.37.7.9.74 1.48-.77-.2-1.52-.36-2.24-.46.42-.44.94-.79 1.5-1.02z"
          id="path8881"
        />
        <path
          className="st6"
          d="M519.27 345.2c.86-.03 1.78-.01 2.73.08 0 .11-.01.22-.03.33a2.128 2.128 0 0 1-2.48 1.7 2.04 2.04 0 0 1-.98-.47c.15-.6.41-1.16.76-1.64z"
          id="path8883"
        />
        <path
          className="st6"
          d="M517.89 344.48c.36-.95 1.35-1.53 2.38-1.34.38.07.72.24.99.48-.56.24-1.08.59-1.5 1.02-.65-.11-1.28-.16-1.87-.16z"
          id="path8885"
        />
        <path
          className="st10"
          d="M521.06 347.61a.54.54 0 0 0-.62.42c-.05.29.14.57.43.62.28.05.56-.14.62-.43a.535.535 0 0 0-.43-.61zm1.21 5.09a4.785 4.785 0 0 1-3.83-5.58c.02-.09.04-.18.07-.27.27.24.61.4.98.47 1.15.22 2.26-.55 2.48-1.7.02-.11.03-.22.03-.33.42.05.84.11 1.27.18 1.58.52 3.19 1.23 4.65 2.12.04.42.02.85-.06 1.29a4.785 4.785 0 0 1-5.59 3.82z"
          id="path8887"
        />
        <path
          className="st6"
          d="M519.27 345.2c-.35.48-.62 1.04-.76 1.65-.46-.38-.74-.94-.75-1.54.48-.05.99-.08 1.51-.11z"
          id="path8889"
        />
        <path
          className="st24"
          d="M517.76 345.31c.01.61.3 1.16.75 1.54-.03.09-.05.18-.07.27-.48 2.6 1.23 5.1 3.83 5.58a4.785 4.785 0 0 0 5.64-5.12c1.69 1.02 3.18 2.27 4.22 3.7-1.57 4.31-6.07 7-10.74 6.12-5.2-.97-8.63-5.97-7.66-11.17l.02-.1c.62-.21 2.09-.62 4.01-.82z"
          id="path8891"
        />
        <path
          className="st6"
          d="M519.27 345.2c-.53.02-1.04.06-1.51.11-.01-.16 0-.31.03-.47.03-.13.06-.25.1-.36.58 0 1.22.06 1.87.15-.18.18-.35.36-.49.57z"
          id="path8893"
        />
        <path
          className="st10"
          d="M514.94 345c.73-.37 1.76-.54 2.95-.53-.04.11-.08.24-.1.36-.03.15-.04.31-.03.47-1.92.2-3.39.61-4 .83.04-.19.08-.37.13-.56.35-.2.7-.39 1.05-.57z"
          id="path8895"
        />
        <path
          className="st10"
          d="M516.02 341.61c.48-.53 1.02-1.01 1.59-1.42 1.38-.44 2.68-.89 3.59-1.34 1.37-.7 2.61-.35 3.54.11l-1.69.91s1.52.7 4.61.87c1.16 1 2.93 2.68 4.61 4.35.23.7.37 1.44.43 2.19-.47-.58-.97-1.14-1.53-1.65-2.92-2.73-6.83-4.41-10.83-4.57-1.44-.05-2.92.15-4.32.55z"
          id="path8897"
        />
        <path
          className="st10"
          d="M516.02 341.61c-.62.17-1.23.39-1.82.65.29-.46.62-.89.97-1.29.79-.26 1.63-.52 2.44-.78-.58.41-1.11.89-1.59 1.42z"
          id="path8899"
        />
        <path
          className="st23"
          d="M513.98 342.35c.07-.03.14-.07.22-.09-.72 1.12-1.25 2.4-1.5 3.79l-.06.37c-3.03 2.33-4.73 6.06.9 11.79-5.93-2.14-8.6-5.49-8.6-5.49v-.01c0-.01 0-.01.01-.01.31-.79.65-1.55 1-2.27.23-.4.47-.8.72-1.2 1.74-2.87 4.2-5.49 7.31-6.88z"
          id="path8901"
        />
        <path
          className="st10"
          d="M512.63 346.43c.4-.3.82-.58 1.26-.85-.05.19-.09.37-.13.56l-.02.1c-.97 5.2 2.46 10.2 7.66 11.17 4.67.87 9.17-1.81 10.74-6.12.27.35.5.72.7 1.1-1.97 4.35-6.72 6.98-11.64 6.06-5.65-1.04-9.41-6.39-8.57-12.02z"
          id="path8903"
        />
        <path
          className="st10"
          d="M512.69 346.05c.26-1.39.78-2.68 1.5-3.79.59-.26 1.2-.48 1.82-.65a9.498 9.498 0 0 0-2.13 3.97c-.43.26-.86.54-1.26.85.03-.13.05-.25.07-.38z"
          id="path8905"
        />
        <path
          className="st6"
          d="M519.36 359.66c-2.22-.31-4.15-.82-5.83-1.43-5.62-5.73-3.93-9.46-.9-11.79-.85 5.64 2.92 10.98 8.57 12.03 4.92.92 9.67-1.71 11.64-6.06.3.55.52 1.11.67 1.7-2.35 2.6-6.7 5.64-14.15 5.55z"
          id="path8907"
        />
        <path
          className="st10"
          d="M511.39 342.61c-1.3 1.08-3.58 3.95-5.45 7.83-.42.72-.78 1.44-1 2.27 1.96-7.14 7.13-14.58 15.04-15.62.66-.09 1.34-.13 2.02-.12.73.01 1.47.07 2.2.18 1.25.19 2.44.55 3.56 1.05-.13.02-.24.04-.35.05-.72-.32-1.5-.56-2.31-.71-3.81-.71-7.54.71-9.93 3.43-1.65.53-3.12 1.07-3.78 1.64z"
          id="path8909"
        />
        <path
          className="st10"
          d="M513.98 342.35c-3.11 1.39-5.57 4.01-7.32 6.88-.25.41-.49.81-.72 1.2 1.87-3.88 4.15-6.75 5.45-7.83.66-.57 2.13-1.1 3.78-1.64-.35.4-.68.83-.97 1.29-.08.03-.15.07-.22.1z"
          id="path8911"
        />
      </g>
      <g id="g9033">
        <path
          className="st23"
          d="M473.51 352.01s-3.28 3.04-9.73 4.32c6.68-5.03 5.53-9.13 2.78-12.01 0-.13 0-.27-.01-.41a11.02 11.02 0 0 0-.96-4.15c.08.04.14.08.21.13 2.99 1.92 5.11 5.01 6.46 8.24.19.44.37.88.54 1.31.27.83.5 1.69.71 2.57z"
          id="path8915"
        />
        <path
          className="st10"
          d="M465.59 339.77c.57 1.27.91 2.67.96 4.15.01.14.01.28.01.41-.36-.38-.76-.74-1.17-1.08a9.873 9.873 0 0 0-1.58-4.44c.62.29 1.22.61 1.78.96z"
          id="path8917"
        />
        <path
          className="st10"
          d="M465.59 339.77c-.23-.52-.51-1.02-.81-1.49 1.62.82 3.04 1.6 3.65 2.29 1.16 1.32 3.06 4.61 4.38 8.88-.17-.44-.36-.87-.54-1.31-1.35-3.23-3.47-6.32-6.46-8.24-.07-.05-.14-.09-.22-.13z"
          id="path8919"
        />
        <path
          className="st24"
          d="M465.44 343.95c.18 5.51-4.13 10.13-9.64 10.32-4.95.16-9.18-3.3-10.12-8.01 1.31-1.31 3.04-2.36 4.94-3.15-.11.43-.16.88-.15 1.34a4.987 4.987 0 0 0 5.16 4.82c2.75-.09 4.91-2.4 4.82-5.16 0-.1-.01-.2-.02-.29.52-.32.89-.85 1.02-1.46 1.94.51 3.39 1.15 3.99 1.48z"
          id="path8921"
        />
        <path
          className="st10"
          d="M463.81 338.81a9.95 9.95 0 0 0-1.44-1.73c.8.4 1.63.8 2.41 1.19.3.48.58.97.81 1.49-.56-.34-1.16-.66-1.78-.95z"
          id="path8923"
        />
        <path
          className="st10"
          d="M461.48 341.87c-.01-.13-.02-.26-.05-.39 1.23.17 2.26.5 2.96 1 .33.24.67.5.99.76.03.2.04.4.05.6-.6-.33-2.05-.98-3.99-1.48.04-.16.05-.32.04-.49z"
          id="path8925"
        />
        <path
          className="st6"
          d="M459.9 342.02c.54.1 1.06.22 1.55.34-.12.62-.5 1.15-1.02 1.46-.06-.64-.24-1.25-.53-1.8z"
          id="path8927"
        />
        <path
          className="st6"
          d="M461.45 342.36c-.49-.13-1.01-.25-1.55-.34-.12-.23-.25-.46-.41-.67.69 0 1.33.04 1.94.13.03.13.04.25.05.39.01.17 0 .33-.03.49z"
          id="path8929"
        />
        <path
          className="st6"
          d="M460.43 343.83c-.31.2-.69.32-1.09.33a2.22 2.22 0 0 1-2.29-2.14c0-.12 0-.23.01-.34.99.05 1.95.17 2.84.34.29.55.47 1.16.53 1.81z"
          id="path8931"
        />
        <path
          className="st6"
          d="M459.49 341.35c.16.21.29.43.41.67-.89-.17-1.84-.29-2.84-.34l.03-.2c.84-.1 1.64-.14 2.4-.13z"
          id="path8933"
        />
        <path
          className="st6"
          d="M458.1 340.06c.54.33 1.02.77 1.39 1.29-.76-.01-1.57.03-2.39.13.13-.6.5-1.11 1-1.42z"
          id="path8935"
        />
        <path
          className="st6"
          d="M459.49 341.35c-.37-.51-.85-.95-1.39-1.29.32-.21.69-.32 1.09-.34a2.22 2.22 0 0 1 2.24 1.76c-.6-.09-1.25-.13-1.94-.13z"
          id="path8937"
        />
        <path
          className="st6"
          d="M451.54 355.81c2.86.86 5.33 1.05 5.89 1.08-2.23-.03-4.19-.44-5.89-1.08z"
          id="path8939"
        />
        <path
          className="st6"
          d="M457.14 344.79a.555.555 0 0 1 1.11-.04.555.555 0 0 1-1.11.04z"
          id="path8941"
        />
        <path
          className="st10"
          d="M458.1 340.06c-.51.31-.88.82-1.01 1.41-.44.04-.9.1-1.35.18-1.62.04-3.31.31-4.97.92a4.992 4.992 0 0 1 4.52-3.28c1.03-.02 2 .26 2.81.77z"
          id="path8943"
        />
        <path
          className="st10"
          d="M457.1 341.48c-.01.06-.03.13-.03.2-.43-.02-.87-.02-1.32-.02.45-.08.9-.14 1.35-.18z"
          id="path8945"
        />
        <path
          className="st10"
          d="M458.25 344.75a.555.555 0 0 0-1.11.04.555.555 0 0 0 1.11-.04zm-7.63-1.64a23.37 23.37 0 0 1 5.13-1.45c.45 0 .89 0 1.32.02-.01.11-.01.22-.01.34a2.22 2.22 0 0 0 2.29 2.14c.4-.01.77-.13 1.09-.33.02.09.02.19.02.29.09 2.76-2.07 5.07-4.82 5.16-2.75.09-5.07-2.06-5.16-4.82-.02-.47.03-.92.14-1.35z"
          id="path8947"
        />
        <path
          className="st10"
          d="M455.75 341.66c-1.72.29-3.49.77-5.13 1.45.04-.18.09-.36.16-.53 1.66-.62 3.35-.88 4.97-.92z"
          id="path8949"
        />
        <path
          className="st10"
          d="M455.13 334.31c.4-.01.8 0 1.19.03-.38.09-.77.18-1.19.29l-.41-.31c.14.01.27 0 .41-.01z"
          id="path8951"
        />
        <path
          className="st10"
          d="M445.68 346.26c.94 4.7 5.17 8.17 10.12 8.01 5.51-.19 9.82-4.81 9.64-10.32v-.11c-.01-.2-.02-.4-.05-.6.41.33.81.69 1.17 1.08-.01 5.94-4.74 10.85-10.72 11.05-5.21.17-9.7-3.27-11.06-8.08.27-.35.57-.7.9-1.03z"
          id="path8953"
        />
        <path
          className="st10"
          d="M456.32 334.35c2.33.2 4.45 1.2 6.05 2.74-1.34-.66-2.61-1.32-3.46-1.92-1.31-.94-2.62-.77-3.67-.43l-.11-.08c.42-.13.81-.22 1.19-.31z"
          id="path8955"
        />
        <path
          className="st10"
          d="M456.32 334.35c-.39-.04-.79-.05-1.19-.03-.14.01-.27.01-.41.02l-.72-.54s-.55.02-1.4-.23c.79-.21 1.63-.34 2.49-.37 4.04-.14 7.65 1.9 9.7 5.07-.78-.39-1.61-.79-2.41-1.19 0-.01 0-.01-.01-.01a9.98 9.98 0 0 0-6.05-2.72z"
          id="path8957"
        />
        <path
          className="st10"
          d="M453.38 335.35c.31.05.99-.35 1.86-.62l1.61 1.2s-1.68.48-4.89.18c.76-.5 1.29-.78 1.42-.76z"
          id="path8959"
        />
        <path
          className="st10"
          d="M450.65 335.93c1.57-.47 3.11-.94 4.48-1.29l.11.08c-.87.28-1.55.67-1.86.62-.13-.02-.66.27-1.42.75-.42-.03-.85-.09-1.31-.16z"
          id="path8961"
        />
        <path
          className="st10"
          d="M455.09 333.21c-.86.03-1.69.15-2.49.37-.11-.03-.22-.07-.34-.11 1.23-.34 2.5-.52 3.82-.52.77 0 1.54.05 2.3.16.7.09 1.39.24 2.07.44 8 2.31 12.17 10.8 13.07 18.47-.11-.91-.38-1.74-.7-2.56-1.32-4.27-3.22-7.56-4.38-8.88-.6-.69-2.03-1.47-3.65-2.29-2.05-3.18-5.66-5.22-9.7-5.08z"
          id="path8963"
        />
        <path
          className="st24"
          d="M450.78 342.58c-.06.17-.12.35-.16.53-1.9.79-3.63 1.84-4.94 3.15l-.06-.29c1.6-1.65 3.35-2.73 5.16-3.39z"
          id="path8965"
        />
        <path
          className="st10"
          d="M450.72 335.51c1.2-.65 2.56-1.07 4-1.17l.41.31c-1.37.36-2.91.83-4.48 1.29-.01 0-.03 0-.05-.01.07-.17.11-.31.12-.42z"
          id="path8967"
        />
        <path
          className="st10"
          d="M452.25 333.47c-1.27.34-2.5.86-3.65 1.52-2.22-2.13-2.01-7.04-2.01-7.04 1.78 3.6 4.1 4.98 5.66 5.52z"
          id="path8969"
        />
        <path
          className="st10"
          d="M454.72 334.33c-1.44.11-2.79.52-4 1.17.02-.18-.02-.3-.02-.3v.22c-.11.04-.56.12-1.22.17-.18-.09-.36-.19-.51-.31 1.08-.78 2.3-1.37 3.62-1.72.85.25 1.4.23 1.4.23z"
          id="path8971"
        />
        <path
          className="st10"
          d="M450.72 335.51c-.01.12-.05.26-.13.42-.04 0-.08-.01-.13-.02l-.33-.06c.2-.12.4-.24.59-.34z"
          id="path8973"
        />
        <path
          className="st10"
          d="M450.65 335.93c-.02.01-.04.02-.07.02.01-.01.01-.02.02-.02h.05z"
          id="path8975"
        />
        <path
          className="st10"
          d="m450.6 335.93-.02.02c-.35.11-.71.22-1.07.32.2-.15.41-.3.63-.43.11.02.22.05.33.06l.13.03z"
          id="path8977"
        />
        <path
          className="st10"
          d="M450.7 335.21s.03.11.02.3c-.19.11-.39.22-.58.34-.23-.06-.45-.14-.65-.24.65-.05 1.1-.14 1.22-.17z"
          id="path8979"
        />
        <path
          className="st10"
          d="M449.51 336.28c.36-.1.72-.21 1.07-.32-.24.46-.86 1.05-2.4 1.51.41-.44.85-.84 1.33-1.19z"
          id="path8981"
        />
        <path
          className="st10"
          d="M449.49 335.61c-.28.02-.61.03-.97.03.14-.12.29-.23.45-.34h.01c.16.11.33.22.51.31z"
          id="path8983"
        />
        <path
          className="st10"
          d="M446.43 337.86c.59-.84 1.29-1.58 2.1-2.22.35 0 .68-.01.97-.03.2.1.42.18.65.24-.22.14-.42.28-.63.43-.48.35-.92.75-1.33 1.19-.49.14-1.08.28-1.76.39z"
          id="path8985"
        />
        <path
          className="st10"
          d="M448.97 335.29c-.13-.1-.25-.2-.36-.31 1.15-.66 2.38-1.17 3.65-1.52.12.04.24.08.34.11-1.33.35-2.55.94-3.63 1.72z"
          id="path8987"
        />
        <path
          className="st10"
          d="M448.61 334.98c.11.11.24.21.36.31-.15.11-.3.22-.45.34-.28-.01-.58-.02-.89-.05.31-.21.64-.41.98-.6z"
          id="path8989"
        />
        <path
          className="st10"
          d="M451.95 336.1c-1.35.85-3.44 2.3-5.44 3.77.44-.88 1-1.69 1.67-2.4 1.53-.46 2.15-1.05 2.4-1.51.03 0 .05-.01.07-.02.46.06.89.12 1.3.16z"
          id="path8991"
        />
        <path
          className="st10"
          d="M447.47 337.93c-.06.12-.84 1.43-2.39 2.44.27-.72.62-1.4 1.03-2.05.78-.19 1.29-.37 1.36-.39z"
          id="path8993"
        />
        <path
          className="st6"
          d="M457.55 356.9c-7.7-1.07-11.7-4.89-13.72-7.94.24-.59.56-1.13.95-1.66 1.36 4.8 5.85 8.25 11.06 8.08 5.99-.2 10.71-5.11 10.72-11.05 2.75 2.87 3.9 6.98-2.78 12.01-1.82.36-3.9.59-6.23.56z"
          id="path8995"
        />
        <path
          className="st10"
          d="M450.78 342.58c-1.8.66-3.56 1.73-5.15 3.39-.07-.43-.12-.89-.13-1.35-.03-.89.06-1.75.25-2.58.57-.52 1.18-1.01 1.83-1.45 3.44-2.35 7.73-3.48 11.88-3.02 1.49.17 2.98.61 4.36 1.24.85 1.3 1.41 2.81 1.58 4.44-.32-.27-.66-.52-.99-.76-.7-.5-1.73-.83-2.96-1a2.23 2.23 0 0 0-2.24-1.76c-.4.01-.77.13-1.09.34a4.91 4.91 0 0 0-2.81-.76 4.95 4.95 0 0 0-4.53 3.27z"
          id="path8997"
        />
        <path
          className="st10"
          d="M447.57 340.59c-.65.44-1.26.93-1.83 1.45.17-.76.43-1.49.77-2.18 2-1.46 4.09-2.92 5.44-3.77 3.21.31 4.89-.18 4.89-.18l-1.61-1.2c1.04-.33 2.36-.5 3.67.43.85.61 2.12 1.27 3.46 1.92.01 0 .01 0 .01.01.54.52 1.02 1.1 1.44 1.73-1.38-.64-2.87-1.07-4.36-1.24-4.16-.45-8.44.68-11.88 3.03z"
          id="path8999"
        />
        <path
          className="st10"
          d="M444.78 347.3a11.369 11.369 0 0 1-.37-3.94c.42-.46.87-.9 1.33-1.32-.2.83-.29 1.69-.25 2.58.02.45.06.91.13 1.35.02.1.03.19.06.29-.33.33-.63.68-.9 1.04z"
          id="path9001"
        />
        <path
          className="st10"
          d="M444.83 341.11c.08-.26.16-.5.26-.75 1.55-1.01 2.32-2.32 2.39-2.44-.07.03-.58.2-1.36.39.1-.15.2-.31.31-.46.69-.11 1.27-.25 1.76-.4-.67.71-1.23 1.52-1.67 2.4-.59.43-1.15.85-1.69 1.26z"
          id="path9003"
        />
        <path
          className="st10"
          d="M443.83 348.95c2.02 3.05 6.03 6.88 13.72 7.94h-.12c-.55-.03-3.02-.22-5.89-1.08-.01 0-.02 0-.03-.01-4.12-1.53-6.7-4.31-7.99-6.03v-.01c.09-.27.18-.54.31-.81z"
          id="path9005"
        />
        <path
          className="st10"
          d="M445.82 337.95c-.39.06-.75.06-1.09.02.19-.19.39-.38.59-.57.72-.67 1.49-1.28 2.31-1.81h.01c.31.03.61.05.89.05-.8.64-1.5 1.39-2.1 2.22-.2.03-.4.07-.61.09z"
          id="path9007"
        />
        <path
          className="st10"
          d="M445.74 342.04c-.47.42-.91.86-1.33 1.32.07-.77.2-1.52.42-2.24.54-.41 1.1-.83 1.68-1.25-.34.68-.6 1.41-.77 2.17z"
          id="path9009"
        />
        <path
          className="st10"
          d="M444.83 341.11c-.22.72-.36 1.48-.42 2.24-.39.42-.77.85-1.13 1.28-.33.4-.67.81-1.04 1.19-.22-.61-.31-.97-.31-.97l-.54.66c-.2-.52-.34-.97-.35-1.18-.01-.25 1.66-1.62 3.79-3.22z"
          id="path9011"
        />
        <path
          className="st23"
          d="M443.83 348.95c-.83-1.25-1.32-2.37-1.59-3.12.37-.38.71-.79 1.04-1.19.36-.44.75-.87 1.13-1.28-.03.43-.05.86-.03 1.3.03.92.17 1.79.4 2.64-.39.52-.71 1.07-.95 1.65z"
          id="path9013"
        />
        <path
          className="st10"
          d="M444.72 337.97c-4.55-.48-5.28-8.13-5.28-8.13 2.16 4.3 5.65 5.5 8.18 5.74-.81.54-1.59 1.15-2.31 1.81-.2.2-.4.39-.59.58z"
          id="path9015"
        />
        <path
          className="st10"
          d="M446.12 338.32c-.58.14-1.31.29-2.12.38.23-.25.47-.49.73-.73.34.04.71.03 1.09-.02.21-.03.42-.06.61-.09-.11.15-.21.3-.31.46z"
          id="path9017"
        />
        <path
          className="st10"
          d="M441.7 346.32c.41 1 .86 1.97.86 1.97s.31.59.97 1.48v.01c1.29 1.72 3.87 4.5 7.99 6.03-4.03-1.22-8.84-3.78-10.25-9.15.15-.11.29-.22.43-.34z"
          id="path9019"
        />
        <path
          className="st10"
          d="M441.7 346.32c.18-.15.36-.31.53-.49.27.75.77 1.87 1.59 3.12-.12.26-.22.54-.3.81-.66-.88-.97-1.48-.97-1.48s-.44-.97-.85-1.96z"
          id="path9021"
        />
        <path
          className="st10"
          d="M441.42 341.4c.87-.9 1.7-1.81 2.57-2.7.81-.09 1.54-.24 2.12-.38-.41.64-.76 1.33-1.03 2.05-.68.45-1.5.83-2.49 1.03-.4.07-.79.08-1.17 0z"
          id="path9023"
        />
        <path
          className="st10"
          d="M442.24 345.83c-.17.17-.35.34-.53.49-.11-.27-.22-.55-.32-.8l.54-.66s.08.36.31.97z"
          id="path9025"
        />
        <path
          className="st10"
          d="M444 338.7c-.87.89-1.71 1.81-2.57 2.7-2.68-.48-4.51-4.26-4.51-4.26 2.08 1.68 4.89 1.81 7.08 1.56z"
          id="path9027"
        />
        <path
          className="st10"
          d="M441.39 345.51c.09.26.21.53.32.8-.14.12-.28.24-.44.34-.07-.25-.12-.51-.18-.77z"
          id="path9029"
        />
        <path
          className="st10"
          d="M444.83 341.11c-2.13 1.6-3.8 2.97-3.79 3.22.01.2.15.65.35 1.18l-.3.37c.05.26.11.52.18.77-.65.44-1.41.7-2.29.55-1.37-.23-2.05-1.17-2.87-2.13.25.3.74.13 1.08-.08 1.6-.99 2.95-2.26 4.24-3.59.37.07.77.07 1.18-.01.98-.2 1.81-.58 2.49-1.03-.11.25-.19.5-.27.75z"
          id="path9031"
        />
      </g>
      <path
        d="M502.11 396.28s-1.04.89-4.92 3.05c-7.05 3.93-21.84-.14-25.59-5.17 0 0-2.26-4.4-5.35-6.05-1.5-.8-1.55-.98-2.4-1.16 1.14.42.82.76 2.93.54 3-.31 3.76-1.64 7.54-2.44 1.13-.24 3.22-.66 5.8-.29 2.58.37 3.68 1.24 6.39 1.7 2.7.46 1.98-.34 5.24-.04 1.67.15 3.82.35 6.19 1.46 2.43 1.14 2.78 2.14 5.87 4.09.45.28.92.5 1.51.68 1.44.44 2.57.24 2.58.39.02.15-1.08.3-2.13.69-1.69.62-2.5 1.56-3.66 2.55z"
        id="path9035"
        style={{
          fill: "#ea7177",
        }}
      />
      <g id="g9041">
        <g id="g9039">
          <path
            className="st26"
            d="M507.56 392.94c-3.05.28-5.97-.05-8.94-.78-2.73-.67-5.53-1.43-8.37-1.4-1.02.01-2.02.07-3.04-.03-1.87-.19-3.66-.64-5.46-1.17-1.76-.52-3.51-1.05-5.33-1.29-1.59-.21-3.19-.18-4.79-.17-1.86.01-3.94.09-5.72-.48-1.03-.33-1.77-1.18-2.8-1.5-.08-.02-.12.09-.05.13.88.47 1.42 1.34 2.32 1.8 1.41.72 3.12.93 4.68 1.02 1.62.09 3.25-.05 4.87.05 1.86.11 3.65.55 5.44 1.07 3.03.89 6.01 1.73 9.2 1.53 2.8-.18 5.58.4 8.31.96 1.41.29 2.82.56 4.26.66 1.82.13 3.63-.01 5.42-.29.07-.03.05-.12 0-.11z"
            id="path9037"
          />
        </g>
      </g>
      <path
        className="st26"
        d="M464.11 385.87c-.08-.25-.14-.5-.17-.73-1.17.4-2.21 1.19-2.94 2.23.76-.68 1.37-.52 2.35-.4.79.09 1.89 1.22 2.68 1.33-.54-.37-1.49-1.14-1.92-2.43z"
        id="path9043"
      />
      <path
        className="st26"
        d="M508.16 392.3c.19-.13.41-.28.63-.22.1.02.19.09.27.15a4.71 4.71 0 0 1 1.61 2.68c-.38-.65-1-1.12-1.68-1.4-1.11-.46-2.46-.57-3.65-.51.87.32 2.06-.21 2.82-.7z"
        id="path9045"
      />
      <g className="st27" id="g9051">
        <g id="g9049">
          <path
            className="st26"
            d="M460.82 380.55c-.36 1.18-1.53 1.66-2.56 2.13-.92.42-1.83 1.02-2.18 2.01-.41 1.15.19 2.3.91 3.17.85 1.02 1.76 1.81 2.02 3.18.02.08.15.08.17 0 .57-2.43-3.22-3.87-2.26-6.29.4-1 1.52-1.47 2.36-2.01.8-.51 1.5-1.18 1.66-2.16.01-.07-.09-.1-.12-.03z"
            id="path9047"
          />
        </g>
      </g>
      <g className="st27" id="g9057">
        <g id="g9055">
          <path
            className="st26"
            d="M513.3 389.4c-.5.8-.13 1.73.39 2.42.66.87 1.68 1.58 1.56 2.81-.12 1.18-1.14 2.09-1.95 2.84-.74.69-1.52 1.38-1.84 2.37-.02.07.08.11.11.05 1.13-1.84 3.64-2.57 4.21-4.79.25-.97-.12-1.82-.78-2.53-.77-.83-2.22-1.8-1.64-3.13.02-.05-.04-.08-.06-.04z"
            id="path9053"
          />
        </g>
      </g>
      <g id="g9063">
        <g id="g9061">
          <path
            className="st10"
            d="M572.73 475.22c-7.21 3.47-14.55 6.61-22.14 9.19a164.6 164.6 0 0 1-6.52 2.08c.53.3 1.05.6 1.58.9-.44-1.23-.87-2.47-1.31-3.7-.23-.65-.88-1.09-1.58-.9-.63.17-1.13.92-.9 1.58.44 1.23.87 2.47 1.31 3.7.23.64.88 1.11 1.58.9 7.84-2.35 15.51-5.22 22.97-8.57 2.12-.95 4.21-1.95 6.28-3 .61-.31.78-1.16.45-1.73-.36-.63-1.11-.75-1.72-.45z"
            id="path9059"
          />
        </g>
      </g>
      <g id="g9069">
        <g id="g9067">
          <path
            className="st10"
            d="M574.13 476.85c.51-.1.9-.54 1.15-.96.35-.58.37-1.15.23-1.8-.11-.5-.24-.99-.35-1.49-.06-.27-.13-.54-.19-.8s-.1-.55-.21-.8c-.22-.53-.64-.9-1.25-.82-.51.07-1.05.56-.99 1.12.06.58.25 1.14.4 1.7.13.46.25.93.38 1.39.06.21.12.41.17.62.03.11.03.23.06.34.06.25-.04-.21.05-.28-.13.09-.26.47-.3.6-.08.28-.07.61.09.87.17.27.45.37.76.31z"
            id="path9065"
          />
        </g>
      </g>
      <g id="g9075">
        <g id="g9073">
          <path
            className="st10"
            d="M505.44 422.59c1.35.21 2.73.48 4.09.53 1.37.06 2.74.04 4.1-.09 2.74-.25 5.4-.9 8.01-1.75 4.97-1.62 9.79-3.81 14.94-4.82 4.34-.86 9.15-.86 13.15 1.27 3.82 2.03 6.22 5.72 7.97 9.56 1.96 4.29 3.18 8.87 4.66 13.33 1.8 5.42 3.92 10.73 6.17 15.98 1.15 2.68 2.34 5.34 3.55 7.99.49 1.09 1.23 2.26 1.4 3.46.15 1.07-.74 1.63-1.53 2.13-4.6 2.9-9.48 5.41-14.54 7.39-4.76 1.87-9.7 3.3-14.74 4.18-.58.1-1.17.21-1.76.29-.59.08-.88.05-1.25-.42-.75-.93-1.28-2.07-1.91-3.08-1.35-2.2-2.35-4.62-3.45-6.95-.56-1.2-1.08-2.39-1.76-3.54-.09-.15-.34-.05-.29.12.85 2.63 1.51 5.28 2.21 7.95.68 2.6 1.62 5.46 3.49 7.47 1.1 1.18 2.48 1.12 3.95.89 1.32-.2 2.64-.45 3.94-.72 2.58-.55 5.12-1.24 7.63-2.05 5.35-1.74 10.53-4.03 15.45-6.76 1.29-.71 2.56-1.46 3.81-2.23 1.06-.65 2.22-1.34 2.84-2.47.73-1.32.54-2.81 0-4.15-.57-1.42-1.25-2.79-1.88-4.18-2.45-5.42-4.8-10.88-6.88-16.46-1.85-4.95-3.27-10.04-5.07-15.01-1.59-4.39-3.56-8.87-6.95-12.19-3.57-3.49-8.43-4.99-13.36-4.93-5.34.07-10.42 1.81-15.38 3.64-2.59.95-5.18 1.93-7.84 2.64-2.76.74-5.61 1.13-8.47 1.22-1.37.05-2.73.14-4.1.08-.9-.02-1.15 1.53-.2 1.68z"
            id="path9071"
          />
        </g>
      </g>
      <g id="g9081">
        <g id="g9079">
          <path
            className="st10"
            d="M402.74 477.22c7.29 3.67 14.93 6.72 22.68 9.31 2.2.73 4.42 1.43 6.65 2.08.7.2 1.36-.25 1.58-.9.43-1.24.86-2.47 1.28-3.71.23-.66-.26-1.41-.9-1.58-.71-.19-1.35.24-1.58.9-.43 1.24-.86 2.47-1.29 3.71.53-.3 1.05-.6 1.58-.9-7.67-2.24-15.2-4.98-22.51-8.22a233.3 233.3 0 0 1-6.22-2.87c-.62-.29-1.36-.17-1.73.45-.32.57-.16 1.42.46 1.73z"
            id="path9077"
          />
        </g>
      </g>
      <g id="g9087">
        <g id="g9085">
          <path
            className="st10"
            d="M403.37 476.37c.15-.25.17-.56.1-.83-.03-.13-.1-.26-.16-.38-.02-.04-.11-.24-.15-.25.09.03-.01.51.05.29.03-.11.03-.23.06-.34.05-.21.11-.42.17-.63.12-.47.25-.93.37-1.4.15-.56.33-1.13.39-1.7.06-.56-.48-1.05-.99-1.12-.6-.08-1.04.28-1.25.82-.1.25-.14.54-.2.8-.06.27-.12.54-.19.8-.11.5-.24.99-.34 1.49-.13.65-.12 1.22.24 1.8.26.42.65.86 1.16.96.28.06.57-.04.74-.31z"
            id="path9083"
          />
        </g>
      </g>
      <g id="g9093">
        <g id="g9091">
          <path
            className="st10"
            d="M473.77 420.5c-1.48.04-2.94-.08-4.42-.15-1.49-.08-3-.22-4.47-.47-2.86-.48-5.61-1.27-8.34-2.24-5.36-1.92-10.6-4.3-16.24-5.33-5.12-.93-10.61-.86-15.31 1.62-4.33 2.28-7.18 6.43-9.1 10.82-2.06 4.71-3.31 9.7-4.81 14.6-1.81 5.9-4 11.67-6.35 17.36-1.19 2.88-2.46 5.74-3.69 8.6-.59 1.38-1.1 2.88-.52 4.36.5 1.28 1.62 2.1 2.76 2.77 5.27 3.08 10.85 5.69 16.58 7.78 5.25 1.91 10.67 3.35 16.2 4.2 1.39.21 2.87.56 4.1-.34 1.14-.83 1.94-2.27 2.49-3.53 1.14-2.6 1.75-5.34 2.45-8.08.35-1.37.8-2.72 1.25-4.07.06-.17-.2-.27-.29-.12-1.37 2.32-2.32 4.89-3.49 7.32-.59 1.24-1.24 2.46-1.98 3.62-.36.57-.73 1.15-1.11 1.72-.23.35-.53.94-.94 1.11-.4.16-.98 0-1.39-.07-.69-.1-1.38-.21-2.07-.33-1.26-.22-2.51-.47-3.76-.75a84.3 84.3 0 0 1-7.81-2.15c-5.46-1.78-10.73-4.07-15.78-6.78-1.25-.67-2.52-1.33-3.71-2.1-.94-.61-1.39-1.27-1.06-2.41.39-1.36 1.1-2.65 1.66-3.95.61-1.4 1.21-2.81 1.8-4.22 2.3-5.47 4.47-11 6.32-16.64 1.58-4.82 2.76-9.76 4.54-14.51 1.5-4.01 3.58-8.16 7.1-10.77 3.93-2.91 8.96-3.41 13.69-2.81 5.34.68 10.37 2.8 15.38 4.67 2.52.94 5.05 1.86 7.67 2.49 2.88.69 5.84.98 8.81.9 1.35-.04 2.73-.28 4.07-.47.95-.12.71-1.68-.23-1.65z"
            id="path9089"
          />
        </g>
      </g>
    </g>
    <g id="Layer_2" transform="matrix(.285 0 0 .285 -89.865 -53.46)">
      <g id="g9101">
        <g id="g9099">
          <path
            className="st10"
            d="M544.49 487.38c-1.08 7.71-2.23 15.4-3.85 23.02-.78 3.65-1.56 7.3-2.33 10.95-.36 1.68-.73 3.4-.96 5.1-.25 1.79-.82 3.5-1.06 5.28-.03.21.26.4.39.16.81-1.56 1.29-3.28 2.02-4.88.68-1.49 1.23-3.07 1.76-4.63 1.23-3.67 2.2-7.43 3.01-11.22 1.65-7.73 2.96-15.56 3.55-23.45.09-1.41-2.33-1.76-2.53-.33z"
            id="path9097"
          />
        </g>
      </g>
      <g id="g9107">
        <g id="g9105">
          <path
            className="st10"
            d="M619.35 474c-1.32 2.44-2.33 5.03-3.34 7.61-1.03 2.65-2.04 5.3-3.05 7.95-2.03 5.35-4.05 10.7-6.03 16.06-1.89 5.1-3.7 10.23-5.63 15.31-1.69 4.43-3.64 8.93-6.67 12.62-3 3.66-7.01 6.41-11.56 7.77-1.22.36-2.46.62-3.73.54-1.13-.07-2.16-.55-3.04-1.24-1.6-1.25-2.96-2.91-4.25-4.46-5.49-6.64-9.62-14.41-13.36-22.13-3.87-7.98-7.16-16.2-10.75-24.3-.39-.88-.78-1.76-1.17-2.63-.55-1.24-2.74-.34-2.22.94 3.41 8.25 6.83 16.51 10.63 24.6 3.82 8.14 8.02 16.25 13.52 23.4 1.26 1.64 2.58 3.23 4.01 4.72 1.82 1.89 3.81 3.45 6.51 3.65 2.64.2 5.36-.81 7.73-1.89 2.28-1.03 4.39-2.42 6.29-4.04 3.77-3.24 6.4-7.56 8.41-12.05 2.17-4.87 3.84-9.95 5.67-14.95 2.01-5.49 4.04-10.96 6.1-16.43 2.03-5.41 3.99-10.87 6.2-16.21.52-1.25 1.09-2.48 1.72-3.67.68-1.31-1.29-2.47-1.99-1.17z"
            id="path9103"
          />
        </g>
      </g>
      <g id="g9113">
        <g id="g9111">
          <path
            className="st10"
            d="M605.91 456.44c-.84 1.46-1.53 2.92-1.98 4.56-.5 1.83-.76 3.67-.71 5.56.04 1.88-.08 3.7-.61 5.51-.45 1.55-1.17 3-1.94 4.4-1.82 3.3-3.75 6.54-5.88 9.66-.7 1.03-1.42 2.05-2.17 3.04-.13.17-.26.35-.39.52l-.19.25c.12-.16-.01.01-.06.07-.16.21-.32.41-.49.62-3.92 4.84-8.12 9.44-11.92 14.38-2.5 3.25-5.03 6.7-6.18 10.69-.7 2.44-1.06 5.04-.95 7.57.15 3.54 1.03 7 2.27 10.32.36.95.75 1.88 1.16 2.81.07.15.3.04.26-.11-.51-2-1.01-4.03-1.2-6.08-.16-1.69-.27-3.38-.25-5.09.03-2.68.24-5.12.86-7.67.21-.87.46-1.73.79-2.57.04-.1.08-.19.12-.29.09-.23-.09.2.01-.03.09-.2.18-.4.27-.59.19-.4.38-.8.59-1.19 1.02-1.91 2.24-3.7 3.51-5.45 3.76-5.18 7.92-10.06 11.96-15.02 3.12-3.84 5.77-8.1 8.18-12.41 1.77-3.15 3.37-6.37 3.73-10.02.17-1.77-.2-3.48-.25-5.24-.05-1.98.18-3.89.78-5.78.25-.79.48-1.58.81-2.35.05-.09-.07-.17-.13-.07z"
            id="path9109"
          />
        </g>
      </g>
      <g id="g9119">
        <g id="g9117">
          <path
            className="st10"
            d="M573.5 476.18c.15 1.19.64 2.33 1.02 3.46.36 1.09.74 2.18 1.11 3.27.76 2.22 1.54 4.43 2.33 6.63.8 2.2 1.59 4.41 2.45 6.59.43 1.09.84 2.18 1.31 3.25.24.55.5 1.1.75 1.65.24.54.44 1.12.84 1.56.49.52 1.45.13 1.43-.59-.01-.6-.29-1.16-.49-1.72-.18-.5-.35-1-.52-1.5-.38-1.09-.81-2.16-1.21-3.24-.83-2.24-1.67-4.46-2.48-6.7-.8-2.2-1.59-4.41-2.4-6.61-.4-1.08-.79-2.17-1.2-3.25-.4-1.07-.72-2.28-1.33-3.25-.41-.65-1.72-.46-1.61.45z"
            id="path9115"
          />
        </g>
      </g>
      <g id="g9151">
        <g id="g9125">
          <g id="g9123">
            <path
              className="st10"
              d="M597.04 484.26c3.25-3.77 6.39-7.94 7.56-12.86.35-1.47.43-3.03.48-4.53.06-1.62.15-3.27.4-4.7.38-2.2 1.02-4.26 1.81-6.34.57-1.49 1.2-2.83 2.11-4.15.96-1.39 2.06-2.67 3.1-3.99 2.04-2.6 3.97-5.53 4.2-8.93.08-1.13-.6-3.17 1.16-3.08 1.37.07 1.96 1.53 2.27 2.67.93 3.47.34 7.31-1.34 10.46-.69 1.29-.48 2.81.65 3.8.98.86 2.59 1.15 3.84 1.4.14.03.2-.17.06-.22-1.35-.45-2.42-1.11-3.25-2.29-.3-.43-.43-.93-.2-1.43.16-.34.44-.64.63-.97.25-.41.47-.84.69-1.27 1.48-2.98 1.68-6.61.87-9.8-.37-1.46-1.04-2.97-2.37-3.79-1.16-.72-2.82-.74-3.93.09-1.55 1.15-.91 3.01-1.07 4.64-.16 1.63-.86 3.17-1.69 4.56-1.75 2.93-4.25 5.3-6.02 8.21-.84 1.38-1.36 2.87-1.92 4.37-.42 1.11-.78 2.24-1.06 3.39-.44 1.83-.59 3.66-.54 5.54.04 1.52.19 3.05.12 4.57-.27 5.49-3.55 10.3-6.68 14.6-.03.03.07.1.12.05z"
              id="path9121"
            />
          </g>
        </g>
        <g id="g9131">
          <g id="g9129">
            <path
              className="st10"
              d="M631.17 462.08c4.24-.46 8.55-.56 12.8-.12 2.23.23 4.43.57 6.61 1.09.93.22 1.95.39 2.8.84.33.17.67.37.92.65.03.03.16.19.17.19.13.1-.1.14.03.02.09-.08-.02-.1 0-.1-.07-.02-.39.14-.46.15-.22.04-.44.05-.67.06-.57.04-1.15.07-1.72.1-1.18.06-2.36.08-3.55.11-2.29.04-4.57.03-6.86.12-3.85.16-7.65.85-11.23 2.31-3.71 1.51-7.06 3.67-10.26 6.06-.51.38-.76 1.01-.42 1.6.29.49 1.09.8 1.6.42 2.99-2.28 6.12-4.42 9.59-5.92 3.8-1.64 7.81-2.28 11.92-2.44 2.46-.09 4.92-.1 7.38-.16 1.27-.03 2.54-.08 3.8-.18 1-.08 2.1-.27 2.65-1.22 1.07-1.86-1.32-3.4-2.76-3.94-1.09-.41-2.3-.62-3.44-.84a52.86 52.86 0 0 0-3.53-.56c-5.15-.65-10.5-.31-15.41 1.45-.16.06-.15.33.04.31z"
              id="path9127"
            />
          </g>
        </g>
        <g id="g9137">
          <g id="g9135">
            <path
              className="st10"
              d="M655.41 463.82c.91.45 1.98.59 2.97.36 1.27-.3 2.28-1.64 1.83-2.94-.63-1.81-3.14-2.56-4.78-3.05-4.46-1.32-9.07-1.64-13.69-1.25-3.79.32-7.63 1.13-11.27 2.23-.11.03-.06.19.05.17 5.84-1.14 11.88-1.28 17.78-.48 1.39.19 2.77.47 4.15.77 1.72.37 3.6.8 5.08 1.62.19.1.38.22.55.35-.21-.15.54.47.27.23.04.04.08.07.12.11.18.18.01-.02.08.1.01.01.09.21.05.08-.03-.09.01.24-.01.32-.17.65-1.06.68-1.59.68-.27 0-.53-.01-.8-.04l-.44-.05c-.46-.11-.86.54-.35.79z"
              id="path9133"
            />
          </g>
        </g>
        <g id="g9143">
          <g id="g9141">
            <path
              className="st10"
              d="M657.89 460.46c1.06.79 2.99.32 3.61-.84.97-1.82-1.01-3.43-2.48-4.03-.61-.25-1.21-.38-1.86-.46-.1-.01-.4-.06-.02 0-.1-.02-.2-.03-.3-.04l-1.49-.24c-4.22-.66-8.54-.88-12.8-.45-4.21.42-8.43 1.24-12.53 2.32-.13.03-.11.26.03.24 6.01-.69 12.09-1.1 18.14-.87.97.04 1.93.09 2.9.17l1.24.12c.16.02.32.04.48.05l.27.03c.04 0 .41.05.18.02 1.04.14 2.06.33 3.09.5.26.04.52.07.78.11.04.01.16.03-.02 0 .17.03.34.06.52.11.35.09.69.19 1.02.34.34.16 1.44.79 1.27 1.3-.14.39-1.24.61-1.58.54-.67-.12-.99.68-.45 1.08z"
              id="path9139"
            />
          </g>
        </g>
        <g id="g9149">
          <g id="g9147">
            <path
              className="st10"
              d="M658.14 456.92c.75-.95.55-2.22-.1-3.17-.73-1.08-2.02-1.63-3.21-2.03-2.86-.95-5.95-1.25-8.95-1.24-5.98.02-11.83 1.41-17.76 1.94-1.61.14-3.3.3-4.91.13-1.42-.15-2.74-.67-3.53-1.9-.16-.24-.57-.22-.64.08-.27 1.13.44 2.14 1.31 2.8 1.14.87 2.61.99 4 1 2.85.02 5.69-.36 8.51-.75 5.75-.8 11.6-1.9 17.42-1.12 1.55.21 3.16.52 4.63 1.05 1.18.43 2.82 1.34 2.57 2.82-.06.35.38.74.66.39z"
              id="path9145"
            />
          </g>
        </g>
      </g>
      <g id="g9157">
        <g id="g9155">
          <path
            className="st10"
            d="M355.39 475.3c1.34 2.48 2.35 5.12 3.37 7.74 1.04 2.68 2.09 5.37 3.13 8.05 2.1 5.45 4.19 10.91 6.24 16.38 1.94 5.16 3.76 10.37 5.81 15.49 1.85 4.62 4.05 9.16 7.37 12.92 3.3 3.74 7.75 6.56 12.56 7.88 2.66.73 5.52.81 7.89-.8 1.82-1.23 3.31-2.98 4.71-4.66 5.72-6.83 10.01-14.8 13.84-22.81 3.93-8.2 7.46-16.62 10.84-25.07.37-.92.74-1.84 1.11-2.75.51-1.26-1.67-2.19-2.22-.94-3.5 7.96-6.67 16.05-10.3 23.94-3.69 8.03-7.73 16.03-13 23.16-1.11 1.5-2.29 2.95-3.55 4.33-1.48 1.62-3.11 3.43-5.46 3.56-2.39.13-4.89-.79-7.02-1.81a23.378 23.378 0 0 1-5.86-3.92c-3.54-3.25-5.91-7.49-7.81-11.86-2.07-4.76-3.73-9.7-5.56-14.55-2.01-5.35-4.05-10.7-6.11-16.04-2.04-5.29-3.99-10.64-6.25-15.83-.53-1.22-1.11-2.43-1.75-3.6-.71-1.26-2.68-.11-1.98 1.19z"
            id="path9153"
          />
        </g>
      </g>
      <g id="g9163">
        <g id="g9161">
          <path
            className="st10"
            d="M370.55 456.56a20.98 20.98 0 0 1 1.47 4.98c.32 1.89.14 3.74-.03 5.63-.32 3.58.74 6.99 2.37 10.14 2.64 5.11 5.79 10.07 9.38 14.58 3.68 4.62 7.58 9.05 11.17 13.73 1.42 1.86 2.82 3.76 4.03 5.77.47.79.92 1.59 1.31 2.42.09.18.17.37.25.55.04.08.07.17.11.25.06.13-.04-.1-.04-.1.03.07.06.14.08.21.14.37.28.74.4 1.11.73 2.32 1.03 4.52 1.24 6.86.3 3.43.05 6.93-.58 10.3-.2 1.05-.44 2.1-.7 3.14-.04.15.19.26.26.11 1.52-3.44 2.69-7.12 3.17-10.85.35-2.76.19-5.59-.42-8.3-.91-4-3.01-7.37-5.44-10.62-4.06-5.44-8.65-10.46-13.02-15.64-.24-.28-.47-.58-.7-.87l-.33-.42c-.1-.13.05.06-.1-.13-.07-.1-.15-.19-.22-.29-.34-.45-.68-.91-1.02-1.38-1.99-2.75-3.83-5.6-5.55-8.53-1.87-3.19-3.74-6.35-4.13-10.1-.18-1.73.05-3.46-.19-5.19-.26-1.86-.77-3.69-1.52-5.42-.31-.71-.72-1.37-1.11-2.04-.05-.07-.18.01-.14.1z"
            id="path9159"
          />
        </g>
      </g>
      <g id="g9169">
        <g id="g9167">
          <path
            className="st10"
            d="M401.62 475.58c-.59.94-.89 2.12-1.27 3.15-.4 1.08-.79 2.17-1.17 3.25-.81 2.24-1.6 4.49-2.4 6.74-.79 2.21-1.6 4.41-2.4 6.61-.39 1.08-.82 2.16-1.19 3.24-.18.54-.36 1.07-.54 1.61-.19.56-.47 1.12-.48 1.72-.01.71.93 1.12 1.43.59.41-.44.59-1.02.83-1.56.25-.55.5-1.1.74-1.65.47-1.07.87-2.17 1.29-3.26.84-2.19 1.62-4.4 2.41-6.61.78-2.21 1.55-4.43 2.29-6.65.37-1.09.73-2.18 1.09-3.28.37-1.13.86-2.28 1-3.47.09-.9-1.21-1.1-1.63-.43z"
            id="path9165"
          />
        </g>
      </g>
      <g id="g9201">
        <g id="g9175">
          <g id="g9173">
            <path
              className="st10"
              d="M379.86 484.16c-2.95-4-6.04-8.43-6.68-13.49-.41-3.22.3-6.47-.27-9.69-.42-2.4-1.26-4.73-2.19-6.97-1.31-3.17-3.74-5.6-5.78-8.3-1.01-1.33-1.97-2.76-2.57-4.33-.27-.7-.49-1.44-.58-2.19-.12-.9.06-1.78-.01-2.67-.13-1.64-1.41-2.69-3.02-2.72-1.57-.03-2.89.95-3.61 2.3-.86 1.6-1.15 3.57-1.18 5.36-.04 1.87.26 3.76.94 5.5.33.84.75 1.65 1.23 2.42.38.61.9 1.18.52 1.94-.68 1.36-2.04 2.13-3.4 2.6-.14.05-.08.25.06.22 1.11-.23 2.49-.49 3.45-1.14 1.04-.7 1.71-2.05 1.37-3.31-.18-.67-.65-1.26-.92-1.89-.32-.74-.58-1.54-.78-2.32-.41-1.58-.58-3.2-.45-4.83.11-1.36.36-3.04 1.25-4.13.55-.67 2.34-1.29 2.58 0 .14.74-.08 1.57-.02 2.32.07.91.25 1.81.55 2.67.53 1.55 1.34 2.99 2.28 4.33 1.89 2.71 4.34 5.04 5.87 7.99.65 1.25 1.13 2.66 1.59 4 .35 1.02.65 2.06.87 3.12.36 1.73.52 3.11.62 4.9.08 1.51.14 3 .36 4.49.78 5.34 4.41 9.96 7.85 13.89.01.07.11-.01.07-.07z"
              id="path9171"
            />
          </g>
        </g>
        <g id="g9181">
          <g id="g9179">
            <path
              className="st10"
              d="M345.51 461.99c-4.31-1.51-9.01-1.96-13.55-1.55-2.4.21-4.79.61-7.14 1.19-1.66.41-4.17 1.12-4.63 3.07-.24 1.01.39 1.91 1.31 2.28 1.03.42 2.3.34 3.39.38 2.47.1 4.95.08 7.42.12 2.27.04 4.56.08 6.81.43 1.96.3 3.88.79 5.74 1.47 3.99 1.45 7.55 3.82 10.92 6.36.5.38 1.31.08 1.6-.42.35-.59.09-1.22-.42-1.6-2.84-2.08-5.79-4.03-9.02-5.45a32.858 32.858 0 0 0-10.95-2.7c-4.56-.32-9.14-.03-13.71-.33-.21-.01-.43-.02-.64-.05-.06-.01-.4-.15-.45-.13.02-.01-.07-.02-.05-.03.01 0 .01.2.01.2.04-.04.09-.2.14-.26.48-.64 1.41-.94 2.14-1.14 2.16-.6 4.36-1.08 6.59-1.38 4.79-.63 9.64-.64 14.44-.16.2.03.21-.25.05-.3z"
              id="path9177"
            />
          </g>
        </g>
        <g id="g9187">
          <g id="g9185">
            <path
              className="st10"
              d="M320.9 463.37c-.64.1-1.89.31-2.53-.17-.26-.19-.34-.41-.3-.72-.02.14.11-.19.01-.05.08-.1.18-.19.28-.27.17-.15.26-.21.29-.23 1.41-.97 3.21-1.4 4.91-1.8 3.96-.95 8-1.44 12.07-1.46 1.55-.01 3.1-.05 4.65.07 1.96.15 3.9.45 5.83.81.11.02.15-.13.05-.17-1.83-.54-3.7-.98-5.58-1.31-1.56-.27-3.12-.6-4.7-.75-2.9-.28-5.8-.37-8.7.01-1.76.23-3.5.55-5.22 1.02-1.04.28-2.06.63-3.04 1.08-.82.38-1.73.87-2.22 1.66-.77 1.24-.21 2.8 1.15 3.35 1.07.44 2.38.27 3.4-.24.49-.25.11-.9-.35-.83z"
              id="path9183"
            />
          </g>
        </g>
        <g id="g9193">
          <g id="g9191">
            <path
              className="st10"
              d="M318.28 459.78c-.41.08-1.15-.12-1.46-.41-.34-.33.23-.87.54-1.09.55-.4 1.22-.6 1.88-.75.01 0 .41-.08.14-.03.03-.01.07-.01.1-.01.16-.02.32-.04.49-.07.95-.15 1.9-.34 2.85-.48.73-.11 1.17-.17 2.03-.26.92-.1 1.84-.16 2.76-.22 2.43-.14 4.87-.12 7.31-.07 3.9.07 7.75.36 11.63.78.14.01.16-.21.03-.24-6.32-1.62-12.87-2.68-19.4-2.35-1.82.09-3.63.29-5.43.57-.56.09-1.11.18-1.67.28-.2.03-.41.06-.61.1-.21.04.26-.03 0 0-.25.03-.49.06-.73.11-1.75.35-4.14 1.72-3.79 3.82.26 1.57 2.57 2.35 3.8 1.41.51-.41.22-1.22-.47-1.09z"
              id="path9189"
            />
          </g>
        </g>
        <g id="g9199">
          <g id="g9197">
            <path
              className="st10"
              d="M319.13 456.93c-.23-1.29 1-2.12 2.02-2.61 1.24-.59 2.68-.87 4.02-1.12 2.89-.54 5.85-.57 8.77-.37 5.75.39 11.42 1.72 17.19 1.86 1.51.04 3.3.1 4.65-.69 1.07-.63 2.09-1.82 1.76-3.14-.08-.3-.48-.33-.64-.08-1.51 2.39-4.86 2.06-7.32 1.91-2.93-.18-5.83-.61-8.74-1.01-5.95-.82-12.16-1.54-18.04.1-1.41.39-3.01.89-4 2.04-.83.97-1.18 2.45-.33 3.5.27.34.72-.04.66-.39z"
              id="path9195"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default Shrug
